export const piauiBoundaries  = [
    {lng:-42.69078445, lat:-9.54547024},
    {lng:-42.69121552, lat:-9.54516506},
    {lng:-42.70987701, lat:-9.53190041},
    {lng:-42.71780396, lat:-9.53094292},
    {lng:-42.72000504, lat:-9.53121853},
    {lng:-42.72056198, lat:-9.53290272},
    {lng:-42.71684647, lat:-9.55628681},
    {lng:-42.73239899, lat:-9.56911564},
    {lng:-42.74215698, lat:-9.58208179},
    {lng:-42.75770187, lat:-9.58929062},
    {lng:-42.76084137, lat:-9.60942459},
    {lng:-42.76512146, lat:-9.6167593},
    {lng:-42.80255127, lat:-9.62207031},
    {lng:-42.82050705, lat:-9.61924076},
    {lng:-42.82148361, lat:-9.59885883},
    {lng:-42.82973099, lat:-9.58126354},
    {lng:-42.8299408, lat:-9.55849838},
    {lng:-42.83709335, lat:-9.55038166},
    {lng:-42.84581375, lat:-9.54981041},
    {lng:-42.8626976, lat:-9.56024265},
    {lng:-42.86375427, lat:-9.56099796},
    {lng:-42.86955261, lat:-9.56398106},
    {lng:-42.87434387, lat:-9.56256104},
    {lng:-42.89463043, lat:-9.53804874},
    {lng:-42.9056015, lat:-9.52638531},
    {lng:-42.90877914, lat:-9.52564621},
    {lng:-42.92836761, lat:-9.52725315},
    {lng:-42.94620132, lat:-9.51842403},
    {lng:-42.95132065, lat:-9.51039219},
    {lng:-42.95176315, lat:-9.49766064},
    {lng:-42.96209335, lat:-9.46982956},
    {lng:-42.96284485, lat:-9.45706463},
    {lng:-42.95723724, lat:-9.43424416},
    {lng:-42.95728683, lat:-9.4340086},
    {lng:-42.967315, lat:-9.413386},
    {lng:-42.987668, lat:-9.401282},
    {lng:-43.007734, lat:-9.409373},
    {lng:-43.05452347, lat:-9.41530228},
    {lng:-43.05699921, lat:-9.41779995},
    {lng:-43.0583725, lat:-9.39935875},
    {lng:-43.05960846, lat:-9.39727211},
    {lng:-43.06656647, lat:-9.39405823},
    {lng:-43.07451248, lat:-9.39956856},
    {lng:-43.08283997, lat:-9.39733505},
    {lng:-43.08515167, lat:-9.39154911},
    {lng:-43.09569168, lat:-9.38552856},
    {lng:-43.10404968, lat:-9.38645458},
    {lng:-43.10737228, lat:-9.37850285},
    {lng:-43.11164093, lat:-9.38051796},
    {lng:-43.11837387, lat:-9.37320614},
    {lng:-43.11994934, lat:-9.3725481},
    {lng:-43.12381744, lat:-9.37905407},
    {lng:-43.12936401, lat:-9.37998867},
    {lng:-43.13310242, lat:-9.38725662},
    {lng:-43.14716721, lat:-9.37632179},
    {lng:-43.15857697, lat:-9.37704945},
    {lng:-43.17388153, lat:-9.4112339},
    {lng:-43.19165421, lat:-9.42044353},
    {lng:-43.19868088, lat:-9.41799641},
    {lng:-43.20611954, lat:-9.4028244},
    {lng:-43.20692444, lat:-9.40208054},
    {lng:-43.2081337, lat:-9.40192986},
    {lng:-43.21858597, lat:-9.40063095},
    {lng:-43.2289505, lat:-9.40295315},
    {lng:-43.24229431, lat:-9.4118948},
    {lng:-43.26662445, lat:-9.41191959},
    {lng:-43.27281952, lat:-9.42278862},
    {lng:-43.27872086, lat:-9.42458534},
    {lng:-43.28507233, lat:-9.42003632},
    {lng:-43.2955513, lat:-9.398983},
    {lng:-43.29938889, lat:-9.3958807},
    {lng:-43.31490707, lat:-9.38941097},
    {lng:-43.32989502, lat:-9.37280083},
    {lng:-43.33414841, lat:-9.36990643},
    {lng:-43.35351181, lat:-9.36896706},
    {lng:-43.37396622, lat:-9.35138321},
    {lng:-43.4044838, lat:-9.3015976},
    {lng:-43.42781067, lat:-9.27257824},
    {lng:-43.44132996, lat:-9.2653923},
    {lng:-43.45053482, lat:-9.26324463},
    {lng:-43.46162033, lat:-9.26178837},
    {lng:-43.48540878, lat:-9.26529598},
    {lng:-43.49747849, lat:-9.27253723},
    {lng:-43.5255127, lat:-9.30005741},
    {lng:-43.54083633, lat:-9.3082552},
    {lng:-43.54375458, lat:-9.30898666},
    {lng:-43.56925201, lat:-9.31537056},
    {lng:-43.57453156, lat:-9.31810093},
    {lng:-43.59514236, lat:-9.33980846},
    {lng:-43.6165657, lat:-9.3655262},
    {lng:-43.62454987, lat:-9.3736887},
    {lng:-43.66513062, lat:-9.40295982},
    {lng:-43.68676758, lat:-9.41806412},
    {lng:-43.75137329, lat:-9.43408203},
    {lng:-43.76968002, lat:-9.44206142},
    {lng:-43.7820015, lat:-9.45285511},
    {lng:-43.78587723, lat:-9.45753002},
    {lng:-43.79940033, lat:-9.4796648},
    {lng:-43.81838608, lat:-9.49425316},
    {lng:-43.84964752, lat:-9.54806423},
    {lng:-43.85253525, lat:-9.56214714},
    {lng:-43.8414917, lat:-9.58606243},
    {lng:-43.84260178, lat:-9.61268234},
    {lng:-43.83393097, lat:-9.61794186},
    {lng:-43.83426285, lat:-9.62259769},
    {lng:-43.84012604, lat:-9.62653446},
    {lng:-43.8419075, lat:-9.63743782},
    {lng:-43.82660294, lat:-9.64984989},
    {lng:-43.79867172, lat:-9.69515514},
    {lng:-43.7947998, lat:-9.70756245},
    {lng:-43.7937355, lat:-9.71311378},
    {lng:-43.79761505, lat:-9.72768879},
    {lng:-43.78487396, lat:-9.76239395},
    {lng:-43.76712799, lat:-9.77070618},
    {lng:-43.76152039, lat:-9.77789211},
    {lng:-43.72138214, lat:-9.79336929},
    {lng:-43.71777344, lat:-9.80243111},
    {lng:-43.70835114, lat:-9.80571842},
    {lng:-43.69341278, lat:-9.80526638},
    {lng:-43.68282318, lat:-9.81575298},
    {lng:-43.66479874, lat:-9.82366562},
    {lng:-43.65319824, lat:-9.83906555},
    {lng:-43.65349197, lat:-9.84526825},
    {lng:-43.66521454, lat:-9.85588837},
    {lng:-43.66635132, lat:-9.86905956},
    {lng:-43.67739868, lat:-9.88653564},
    {lng:-43.69457626, lat:-9.8912611},
    {lng:-43.69638062, lat:-9.90121555},
    {lng:-43.70542908, lat:-9.90638924},
    {lng:-43.708992, lat:-9.91322899},
    {lng:-43.70613098, lat:-9.92206287},
    {lng:-43.6927948, lat:-9.92553616},
    {lng:-43.6904068, lat:-9.92950916},
    {lng:-43.68951797, lat:-9.93907547},
    {lng:-43.70290375, lat:-9.96612644},
    {lng:-43.68462753, lat:-9.98277473},
    {lng:-43.66597748, lat:-9.99023724},
    {lng:-43.66222763, lat:-10.00434685},
    {lng:-43.66942596, lat:-10.03074074},
    {lng:-43.69023514, lat:-10.04464626},
    {lng:-43.69141769, lat:-10.05932426},
    {lng:-43.69287109, lat:-10.07740211},
    {lng:-43.72988129, lat:-10.07226276},
    {lng:-43.75918198, lat:-10.07461452},
    {lng:-43.76598358, lat:-10.08006382},
    {lng:-43.77306747, lat:-10.09879398},
    {lng:-43.76695633, lat:-10.11468887},
    {lng:-43.76654434, lat:-10.13426876},
    {lng:-43.77904129, lat:-10.18047619},
    {lng:-43.79780197, lat:-10.20885086},
    {lng:-43.8360939, lat:-10.24890041},
    {lng:-43.8372879, lat:-10.25115013},
    {lng:-43.83797073, lat:-10.26136875},
    {lng:-43.83803558, lat:-10.26607132},
    {lng:-43.83400345, lat:-10.27770615},
    {lng:-43.83811951, lat:-10.30383205},
    {lng:-43.8476944, lat:-10.31630802},
    {lng:-43.87163544, lat:-10.33044529},
    {lng:-43.88485336, lat:-10.34403419},
    {lng:-43.89505386, lat:-10.35451508},
    {lng:-43.90022278, lat:-10.36890411},
    {lng:-43.91474152, lat:-10.38411713},
    {lng:-43.91575241, lat:-10.42044353},
    {lng:-43.91717529, lat:-10.42441559},
    {lng:-43.91960526, lat:-10.42523479},
    {lng:-43.94169235, lat:-10.42604637},
    {lng:-43.96326828, lat:-10.42501354},
    {lng:-43.99187088, lat:-10.41234589},
    {lng:-44.00765991, lat:-10.40535355},
    {lng:-44.01802444, lat:-10.40515995},
    {lng:-44.02927399, lat:-10.41639805},
    {lng:-44.03023911, lat:-10.41882324},
    {lng:-44.03571701, lat:-10.44472122},
    {lng:-44.02579498, lat:-10.47548103},
    {lng:-44.02957153, lat:-10.48409081},
    {lng:-44.04150772, lat:-10.49324417},
    {lng:-44.05096054, lat:-10.5062418},
    {lng:-44.06967163, lat:-10.57157612},
    {lng:-44.07254028, lat:-10.58034134},
    {lng:-44.07296753, lat:-10.58071327},
    {lng:-44.08223724, lat:-10.58879185},
    {lng:-44.10070801, lat:-10.59173012},
    {lng:-44.11057281, lat:-10.59720516},
    {lng:-44.12329483, lat:-10.62091732},
    {lng:-44.13017654, lat:-10.63298035},
    {lng:-44.13444519, lat:-10.63624191},
    {lng:-44.14666748, lat:-10.64143562},
    {lng:-44.15742493, lat:-10.64366531},
    {lng:-44.16549301, lat:-10.6429081},
    {lng:-44.17694855, lat:-10.63261795},
    {lng:-44.17803574, lat:-10.63234425},
    {lng:-44.1929245, lat:-10.62859058},
    {lng:-44.20859909, lat:-10.61533546},
    {lng:-44.21553421, lat:-10.61522961},
    {lng:-44.23729706, lat:-10.62656212},
    {lng:-44.24310684, lat:-10.62714577},
    {lng:-44.26397324, lat:-10.62467957},
    {lng:-44.28299713, lat:-10.60684776},
    {lng:-44.30366898, lat:-10.56980324},
    {lng:-44.31167984, lat:-10.560606},
    {lng:-44.31635666, lat:-10.55650806},
    {lng:-44.32185364, lat:-10.55396271},
    {lng:-44.33560181, lat:-10.54897785},
    {lng:-44.34445572, lat:-10.54981041},
    {lng:-44.35335922, lat:-10.5566473},
    {lng:-44.39626694, lat:-10.60351562},
    {lng:-44.40132904, lat:-10.6070118},
    {lng:-44.4235878, lat:-10.61327267},
    {lng:-44.44904327, lat:-10.60727215},
    {lng:-44.45323944, lat:-10.60775948},
    {lng:-44.46358109, lat:-10.6152668},
    {lng:-44.47183228, lat:-10.63040161},
    {lng:-44.47950363, lat:-10.64047432},
    {lng:-44.50242233, lat:-10.64990997},
    {lng:-44.50862122, lat:-10.65053368},
    {lng:-44.51791, lat:-10.65004635},
    {lng:-44.5250473, lat:-10.64773464},
    {lng:-44.54930115, lat:-10.62985992},
    {lng:-44.57773209, lat:-10.6267786},
    {lng:-44.58946991, lat:-10.63242912},
    {lng:-44.60702133, lat:-10.65960979},
    {lng:-44.61263275, lat:-10.66524792},
    {lng:-44.62519073, lat:-10.67431736},
    {lng:-44.6281395, lat:-10.67572975},
    {lng:-44.63917542, lat:-10.67703819},
    {lng:-44.64512634, lat:-10.67730713},
    {lng:-44.66008377, lat:-10.6779747},
    {lng:-44.66766739, lat:-10.68595028},
    {lng:-44.66889572, lat:-10.68997669},
    {lng:-44.66902542, lat:-10.69253922},
    {lng:-44.66910553, lat:-10.69416428},
    {lng:-44.66127396, lat:-10.73270416},
    {lng:-44.66273499, lat:-10.7505703},
    {lng:-44.66763687, lat:-10.76006508},
    {lng:-44.68716049, lat:-10.76921272},
    {lng:-44.71336365, lat:-10.76205158},
    {lng:-44.72385406, lat:-10.76771641},
    {lng:-44.73088837, lat:-10.77084732},
    {lng:-44.75115967, lat:-10.78213406},
    {lng:-44.75744629, lat:-10.78818035},
    {lng:-44.75887299, lat:-10.80480194},
    {lng:-44.77812195, lat:-10.80403614},
    {lng:-44.78801346, lat:-10.80853081},
    {lng:-44.81027603, lat:-10.84659195},
    {lng:-44.80839539, lat:-10.86501408},
    {lng:-44.80975723, lat:-10.86774921},
    {lng:-44.81311417, lat:-10.87137318},
    {lng:-44.82282639, lat:-10.87588978},
    {lng:-44.84580612, lat:-10.89975262},
    {lng:-44.8487587, lat:-10.89920616},
    {lng:-44.85152435, lat:-10.89604473},
    {lng:-44.85498428, lat:-10.88450146},
    {lng:-44.86208344, lat:-10.8850956},
    {lng:-44.86360931, lat:-10.88627434},
    {lng:-44.88438034, lat:-10.90231895},
    {lng:-44.89739609, lat:-10.90294838},
    {lng:-44.90113068, lat:-10.91002464},
    {lng:-44.909935, lat:-10.91196537},
    {lng:-44.93117142, lat:-10.92876625},
    {lng:-44.96834183, lat:-10.90049839},
    {lng:-44.97385025, lat:-10.89326668},
    {lng:-44.97571182, lat:-10.89082336},
    {lng:-44.99499893, lat:-10.88390446},
    {lng:-45.00208282, lat:-10.88702869},
    {lng:-45.01654816, lat:-10.88460827},
    {lng:-45.03064346, lat:-10.86666012},
    {lng:-45.04542542, lat:-10.85965443},
    {lng:-45.04995346, lat:-10.85215282},
    {lng:-45.06323242, lat:-10.84827423},
    {lng:-45.07318497, lat:-10.84043217},
    {lng:-45.08682251, lat:-10.8399868},
    {lng:-45.1052475, lat:-10.84682941},
    {lng:-45.11647034, lat:-10.84078312},
    {lng:-45.13395309, lat:-10.83865929},
    {lng:-45.15374374, lat:-10.83908939},
    {lng:-45.20860291, lat:-10.83122444},
    {lng:-45.21634674, lat:-10.82929802},
    {lng:-45.21809387, lat:-10.82730389},
    {lng:-45.21917343, lat:-10.81739616},
    {lng:-45.24800491, lat:-10.82197762},
    {lng:-45.25743484, lat:-10.81170082},
    {lng:-45.26722336, lat:-10.78008747},
    {lng:-45.27173996, lat:-10.7745533},
    {lng:-45.28927231, lat:-10.76565838},
    {lng:-45.32232285, lat:-10.76027203},
    {lng:-45.35816956, lat:-10.73221588},
    {lng:-45.37053299, lat:-10.67687416},
    {lng:-45.37484741, lat:-10.66777992},
    {lng:-45.37982559, lat:-10.65999699},
    {lng:-45.38835144, lat:-10.65035629},
    {lng:-45.39847565, lat:-10.64627171},
    {lng:-45.41275406, lat:-10.64455414},
    {lng:-45.4160881, lat:-10.64415264},
    {lng:-45.42183685, lat:-10.64085007},
    {lng:-45.42779922, lat:-10.63503075},
    {lng:-45.43405533, lat:-10.62543869},
    {lng:-45.43587112, lat:-10.61988354},
    {lng:-45.43678665, lat:-10.57669735},
    {lng:-45.44728088, lat:-10.55634403},
    {lng:-45.44032288, lat:-10.54167271},
    {lng:-45.43812943, lat:-10.52553272},
    {lng:-45.4472084, lat:-10.50743198},
    {lng:-45.4310379, lat:-10.48838043},
    {lng:-45.40296936, lat:-10.46534061},
    {lng:-45.39814377, lat:-10.45432568},
    {lng:-45.39638901, lat:-10.44690704},
    {lng:-45.40094376, lat:-10.44177723},
    {lng:-45.42444992, lat:-10.42649746},
    {lng:-45.42988205, lat:-10.40391254},
    {lng:-45.42617798, lat:-10.37396145},
    {lng:-45.43027115, lat:-10.35947704},
    {lng:-45.45677567, lat:-10.33858013},
    {lng:-45.47321701, lat:-10.31534195},
    {lng:-45.48478699, lat:-10.30479145},
    {lng:-45.49105072, lat:-10.30125427},
    {lng:-45.51708221, lat:-10.28655624},
    {lng:-45.52230453, lat:-10.27666187},
    {lng:-45.52280807, lat:-10.24715233},
    {lng:-45.52624512, lat:-10.23686409},
    {lng:-45.55652237, lat:-10.21691036},
    {lng:-45.56721878, lat:-10.20155811},
    {lng:-45.57079697, lat:-10.18474865},
    {lng:-45.56538391, lat:-10.15998936},
    {lng:-45.56740952, lat:-10.13952923},
    {lng:-45.57929993, lat:-10.12194633},
    {lng:-45.5931778, lat:-10.11030769},
    {lng:-45.60313416, lat:-10.10799503},
    {lng:-45.63919067, lat:-10.12621212},
    {lng:-45.64871597, lat:-10.12734318},
    {lng:-45.6692543, lat:-10.14537525},
    {lng:-45.68652725, lat:-10.15368271},
    {lng:-45.70385742, lat:-10.15699863},
    {lng:-45.71619415, lat:-10.15262318},
    {lng:-45.72283936, lat:-10.15531731},
    {lng:-45.7265892, lat:-10.15686417},
    {lng:-45.7349472, lat:-10.17217541},
    {lng:-45.73420715, lat:-10.18504333},
    {lng:-45.72677231, lat:-10.20711517},
    {lng:-45.7338028, lat:-10.22860527},
    {lng:-45.74397659, lat:-10.23996353},
    {lng:-45.79369354, lat:-10.26768303},
    {lng:-45.84317017, lat:-10.25926304},
    {lng:-45.87780762, lat:-10.23934555},
    {lng:-45.92572784, lat:-10.25027466},
    {lng:-45.94632721, lat:-10.25857735},
    {lng:-45.95524597, lat:-10.21845341},
    {lng:-45.94568253, lat:-10.20683002},
    {lng:-45.94556808, lat:-10.19645309},
    {lng:-45.93826294, lat:-10.19090271},
    {lng:-45.93113708, lat:-10.19083691},
    {lng:-45.92421722, lat:-10.17116833},
    {lng:-45.9153595, lat:-10.16417313},
    {lng:-45.91345596, lat:-10.15839577},
    {lng:-45.89997101, lat:-10.15277767},
    {lng:-45.89769745, lat:-10.13658047},
    {lng:-45.88622665, lat:-10.1140728},
    {lng:-45.87849426, lat:-10.11031055},
    {lng:-45.86988831, lat:-10.06930161},
    {lng:-45.88014603, lat:-10.05860424},
    {lng:-45.87505722, lat:-10.05514622},
    {lng:-45.87541962, lat:-10.04029274},
    {lng:-45.86582947, lat:-10.0149107},
    {lng:-45.86616898, lat:-10.00851536},
    {lng:-45.85477066, lat:-9.99634743},
    {lng:-45.85698318, lat:-9.9847641},
    {lng:-45.85263062, lat:-9.98217964},
    {lng:-45.84696579, lat:-9.96229172},
    {lng:-45.84896088, lat:-9.95630264},
    {lng:-45.84223557, lat:-9.94156837},
    {lng:-45.84644699, lat:-9.92455578},
    {lng:-45.85260773, lat:-9.91980934},
    {lng:-45.85800171, lat:-9.90752411},
    {lng:-45.86001205, lat:-9.88652229},
    {lng:-45.86349869, lat:-9.88143253},
    {lng:-45.86151505, lat:-9.87445354},
    {lng:-45.86623001, lat:-9.87072754},
    {lng:-45.86437988, lat:-9.8614769},
    {lng:-45.85531998, lat:-9.84792995},
    {lng:-45.85605621, lat:-9.84214973},
    {lng:-45.85137177, lat:-9.83882236},
    {lng:-45.84606552, lat:-9.81060219},
    {lng:-45.84451294, lat:-9.80662346},
    {lng:-45.8386879, lat:-9.79690933},
    {lng:-45.82843018, lat:-9.79171181},
    {lng:-45.82137299, lat:-9.77313519},
    {lng:-45.82307434, lat:-9.7632618},
    {lng:-45.82062912, lat:-9.756814},
    {lng:-45.82696533, lat:-9.74650383},
    {lng:-45.82030487, lat:-9.74013329},
    {lng:-45.82854843, lat:-9.72481823},
    {lng:-45.82589722, lat:-9.71754265},
    {lng:-45.83132172, lat:-9.71261978},
    {lng:-45.82874298, lat:-9.70397663},
    {lng:-45.83797073, lat:-9.6964674},
    {lng:-45.82911682, lat:-9.6801424},
    {lng:-45.83231735, lat:-9.65315723},
    {lng:-45.83251953, lat:-9.65146828},
    {lng:-45.82487488, lat:-9.63676453},
    {lng:-45.82571411, lat:-9.62650681},
    {lng:-45.81948853, lat:-9.62497807},
    {lng:-45.81990433, lat:-9.61836624},
    {lng:-45.8253212, lat:-9.60749912},
    {lng:-45.83653641, lat:-9.60229969},
    {lng:-45.83764267, lat:-9.5916748},
    {lng:-45.83340454, lat:-9.59082508},
    {lng:-45.83361053, lat:-9.58740616},
    {lng:-45.84109116, lat:-9.5776329},
    {lng:-45.84194565, lat:-9.5749464},
    {lng:-45.84137344, lat:-9.56231308},
    {lng:-45.82733536, lat:-9.54595566},
    {lng:-45.83189392, lat:-9.53680325},
    {lng:-45.82072067, lat:-9.52640057},
    {lng:-45.82165527, lat:-9.51944733},
    {lng:-45.81003952, lat:-9.50389576},
    {lng:-45.79810333, lat:-9.49560928},
    {lng:-45.79654694, lat:-9.48751926},
    {lng:-45.78884888, lat:-9.48258877},
    {lng:-45.78377533, lat:-9.4801178},
    {lng:-45.78943634, lat:-9.4703064},
    {lng:-45.78887939, lat:-9.46462536},
    {lng:-45.79508209, lat:-9.46051979},
    {lng:-45.78787994, lat:-9.4584322},
    {lng:-45.79460144, lat:-9.45035744},
    {lng:-45.79327393, lat:-9.44538879},
    {lng:-45.79775238, lat:-9.44248962},
    {lng:-45.79394531, lat:-9.43843269},
    {lng:-45.80128479, lat:-9.43506241},
    {lng:-45.80269241, lat:-9.42530727},
    {lng:-45.79779434, lat:-9.41726398},
    {lng:-45.81793976, lat:-9.38939476},
    {lng:-45.82411575, lat:-9.37495708},
    {lng:-45.84030533, lat:-9.36455917},
    {lng:-45.84708786, lat:-9.35638618},
    {lng:-45.86316299, lat:-9.35916424},
    {lng:-45.87497711, lat:-9.35382175},
    {lng:-45.87944412, lat:-9.34621906},
    {lng:-45.88733673, lat:-9.34881878},
    {lng:-45.89362717, lat:-9.3421917},
    {lng:-45.89088821, lat:-9.33154583},
    {lng:-45.89620209, lat:-9.32798958},
    {lng:-45.89736176, lat:-9.31902027},
    {lng:-45.90223694, lat:-9.31788158},
    {lng:-45.9002037, lat:-9.31296635},
    {lng:-45.90701675, lat:-9.29802418},
    {lng:-45.90581512, lat:-9.29206371},
    {lng:-45.89704132, lat:-9.29039764},
    {lng:-45.89588547, lat:-9.28153706},
    {lng:-45.90368271, lat:-9.26724243},
    {lng:-45.89845276, lat:-9.26316261},
    {lng:-45.90182114, lat:-9.25216389},
    {lng:-45.89655685, lat:-9.23535538},
    {lng:-45.90314865, lat:-9.23156738},
    {lng:-45.89860916, lat:-9.20968723},
    {lng:-45.90560913, lat:-9.19118309},
    {lng:-45.89964676, lat:-9.19144344},
    {lng:-45.89702606, lat:-9.18652916},
    {lng:-45.90521622, lat:-9.17483711},
    {lng:-45.91327667, lat:-9.16755962},
    {lng:-45.92120361, lat:-9.14618778},
    {lng:-45.92802811, lat:-9.1379261},
    {lng:-45.92526627, lat:-9.11253929},
    {lng:-45.92508316, lat:-9.11203766},
    {lng:-45.92754364, lat:-9.10267735},
    {lng:-45.92251205, lat:-9.09887123},
    {lng:-45.92308044, lat:-9.09032154},
    {lng:-45.93131256, lat:-9.08806419},
    {lng:-45.92733765, lat:-9.08074284},
    {lng:-45.92921066, lat:-9.07013798},
    {lng:-45.93782806, lat:-9.06368446},
    {lng:-45.94036865, lat:-9.05618477},
    {lng:-45.93574905, lat:-9.03918743},
    {lng:-45.94535828, lat:-9.02498817},
    {lng:-45.94341278, lat:-9.01532459},
    {lng:-45.95907593, lat:-9.00174809},
    {lng:-45.967659, lat:-8.97908211},
    {lng:-45.98077774, lat:-8.96682739},
    {lng:-45.98537064, lat:-8.95925617},
    {lng:-45.99225235, lat:-8.94048023},
    {lng:-45.99424362, lat:-8.92687798},
    {lng:-45.98512268, lat:-8.91853237},
    {lng:-45.98588562, lat:-8.91043186},
    {lng:-45.97962189, lat:-8.90284538},
    {lng:-45.98293304, lat:-8.89006138},
    {lng:-45.98001862, lat:-8.88408279},
    {lng:-45.96756744, lat:-8.87590122},
    {lng:-45.97264862, lat:-8.86914253},
    {lng:-45.9715004, lat:-8.86241817},
    {lng:-45.95986557, lat:-8.85101986},
    {lng:-45.95728302, lat:-8.84053135},
    {lng:-45.94893265, lat:-8.84495735},
    {lng:-45.94548035, lat:-8.84039211},
    {lng:-45.94530869, lat:-8.83148289},
    {lng:-45.95862198, lat:-8.82618904},
    {lng:-45.96071625, lat:-8.81889343},
    {lng:-45.95346069, lat:-8.80729008},
    {lng:-45.93912506, lat:-8.7958622},
    {lng:-45.93839645, lat:-8.78494835},
    {lng:-45.9349556, lat:-8.77911282},
    {lng:-45.92797089, lat:-8.77736855},
    {lng:-45.90757751, lat:-8.75867844},
    {lng:-45.89156342, lat:-8.76280117},
    {lng:-45.88929749, lat:-8.73966599},
    {lng:-45.87433624, lat:-8.73140621},
    {lng:-45.86327744, lat:-8.72981834},
    {lng:-45.86457062, lat:-8.71589661},
    {lng:-45.85325241, lat:-8.70982742},
    {lng:-45.83989716, lat:-8.71528816},
    {lng:-45.82092285, lat:-8.66563511},
    {lng:-45.8115654, lat:-8.65609169},
    {lng:-45.81893158, lat:-8.65402031},
    {lng:-45.82098389, lat:-8.64956474},
    {lng:-45.81549835, lat:-8.63323689},
    {lng:-45.80378342, lat:-8.62198734},
    {lng:-45.79862213, lat:-8.62096786},
    {lng:-45.79742432, lat:-8.61304569},
    {lng:-45.7780838, lat:-8.61783028},
    {lng:-45.76558685, lat:-8.60958862},
    {lng:-45.79389572, lat:-8.59243393},
    {lng:-45.79372787, lat:-8.58441067},
    {lng:-45.76831436, lat:-8.57027435},
    {lng:-45.76131821, lat:-8.56185246},
    {lng:-45.76075363, lat:-8.54964733},
    {lng:-45.7550354, lat:-8.54385757},
    {lng:-45.75377274, lat:-8.54096222},
    {lng:-45.75677872, lat:-8.52776337},
    {lng:-45.75393677, lat:-8.52137947},
    {lng:-45.73841095, lat:-8.50118446},
    {lng:-45.74596024, lat:-8.49371147},
    {lng:-45.74057007, lat:-8.47541142},
    {lng:-45.74225998, lat:-8.45114994},
    {lng:-45.73649216, lat:-8.44021034},
    {lng:-45.728508, lat:-8.42987442},
    {lng:-45.73275375, lat:-8.42042923},
    {lng:-45.73168182, lat:-8.41565037},
    {lng:-45.73059082, lat:-8.41237545},
    {lng:-45.71918106, lat:-8.40323257},
    {lng:-45.72151947, lat:-8.39439869},
    {lng:-45.71139908, lat:-8.38803768},
    {lng:-45.70556641, lat:-8.38761044},
    {lng:-45.7051506, lat:-8.38757801},
    {lng:-45.70029449, lat:-8.38134003},
    {lng:-45.70344925, lat:-8.36851311},
    {lng:-45.69156265, lat:-8.36303425},
    {lng:-45.68748474, lat:-8.35556316},
    {lng:-45.68745422, lat:-8.33677578},
    {lng:-45.67895508, lat:-8.322855},
    {lng:-45.67651367, lat:-8.30445957},
    {lng:-45.66450882, lat:-8.28849316},
    {lng:-45.66150665, lat:-8.25003242},
    {lng:-45.60808945, lat:-8.20496464},
    {lng:-45.61281204, lat:-8.19473362},
    {lng:-45.61108398, lat:-8.18700027},
    {lng:-45.60686493, lat:-8.18570805},
    {lng:-45.59951019, lat:-8.17508125},
    {lng:-45.59122849, lat:-8.17337799},
    {lng:-45.58141708, lat:-8.15605736},
    {lng:-45.58654404, lat:-8.13658428},
    {lng:-45.58538818, lat:-8.1290102},
    {lng:-45.5750618, lat:-8.11396599},
    {lng:-45.58351135, lat:-8.09827423},
    {lng:-45.56856918, lat:-8.07384586},
    {lng:-45.56768036, lat:-8.05366898},
    {lng:-45.56138229, lat:-8.04791355},
    {lng:-45.57624054, lat:-8.02910233},
    {lng:-45.56290054, lat:-8.01458645},
    {lng:-45.55410767, lat:-8.01724815},
    {lng:-45.54978561, lat:-8.01450157},
    {lng:-45.5511322, lat:-8.00806332},
    {lng:-45.56703568, lat:-7.99714184},
    {lng:-45.55680847, lat:-7.97369385},
    {lng:-45.54863358, lat:-7.96929312},
    {lng:-45.54502869, lat:-7.96073484},
    {lng:-45.55610657, lat:-7.95433521},
    {lng:-45.54740524, lat:-7.94734001},
    {lng:-45.54453278, lat:-7.93971205},
    {lng:-45.5412941, lat:-7.92902279},
    {lng:-45.54383087, lat:-7.92097521},
    {lng:-45.53914642, lat:-7.9194231},
    {lng:-45.53202438, lat:-7.92322206},
    {lng:-45.52358246, lat:-7.91220522},
    {lng:-45.52415085, lat:-7.90843821},
    {lng:-45.54296875, lat:-7.8977232},
    {lng:-45.53984451, lat:-7.89336586},
    {lng:-45.52079773, lat:-7.88809586},
    {lng:-45.52198792, lat:-7.88316202},
    {lng:-45.53399658, lat:-7.87645006},
    {lng:-45.54032516, lat:-7.86471224},
    {lng:-45.53523254, lat:-7.86214399},
    {lng:-45.5249176, lat:-7.85694504},
    {lng:-45.52635193, lat:-7.84002304},
    {lng:-45.51573563, lat:-7.83432484},
    {lng:-45.50999832, lat:-7.82031918},
    {lng:-45.51086044, lat:-7.80240822},
    {lng:-45.49884033, lat:-7.79801321},
    {lng:-45.50059128, lat:-7.78565598},
    {lng:-45.49383545, lat:-7.78867579},
    {lng:-45.48989487, lat:-7.78654909},
    {lng:-45.49277878, lat:-7.77715302},
    {lng:-45.48465347, lat:-7.76366711},
    {lng:-45.4964447, lat:-7.75031281},
    {lng:-45.48983383, lat:-7.74601316},
    {lng:-45.48661423, lat:-7.75089502},
    {lng:-45.48219299, lat:-7.751369},
    {lng:-45.48145676, lat:-7.74347782},
    {lng:-45.48685074, lat:-7.72904205},
    {lng:-45.48007202, lat:-7.71461821},
    {lng:-45.46861649, lat:-7.71329594},
    {lng:-45.46928406, lat:-7.7070241},
    {lng:-45.46886444, lat:-7.68914413},
    {lng:-45.45732117, lat:-7.68967676},
    {lng:-45.44920731, lat:-7.68356895},
    {lng:-45.46068954, lat:-7.67799187},
    {lng:-45.45907211, lat:-7.67386007},
    {lng:-45.45594788, lat:-7.67068005},
    {lng:-45.43989182, lat:-7.67801523},
    {lng:-45.43520737, lat:-7.67573595},
    {lng:-45.43701935, lat:-7.6676898},
    {lng:-45.4326973, lat:-7.66151619},
    {lng:-45.4177742, lat:-7.65857077},
    {lng:-45.41423416, lat:-7.65463114},
    {lng:-45.41562653, lat:-7.6451292},
    {lng:-45.40403366, lat:-7.64405107},
    {lng:-45.39898682, lat:-7.64005804},
    {lng:-45.39860535, lat:-7.62349987},
    {lng:-45.39402771, lat:-7.61302519},
    {lng:-45.38196182, lat:-7.613132},
    {lng:-45.37359619, lat:-7.61879778},
    {lng:-45.34321213, lat:-7.59349298},
    {lng:-45.33971786, lat:-7.58025789},
    {lng:-45.32302856, lat:-7.57492495},
    {lng:-45.30299759, lat:-7.5748539},
    {lng:-45.29631042, lat:-7.57346582},
    {lng:-45.28501892, lat:-7.56636381},
    {lng:-45.26131821, lat:-7.57086611},
    {lng:-45.2522049, lat:-7.56048393},
    {lng:-45.24397659, lat:-7.55536795},
    {lng:-45.23303986, lat:-7.54993916},
    {lng:-45.22299957, lat:-7.56045198},
    {lng:-45.22264099, lat:-7.56662893},
    {lng:-45.2181015, lat:-7.56786203},
    {lng:-45.20422745, lat:-7.55179214},
    {lng:-45.18353653, lat:-7.54339123},
    {lng:-45.17438507, lat:-7.52886391},
    {lng:-45.15540314, lat:-7.51349497},
    {lng:-45.15370941, lat:-7.51360703},
    {lng:-45.14652252, lat:-7.52097797},
    {lng:-45.13711166, lat:-7.52155685},
    {lng:-45.1264534, lat:-7.51403284},
    {lng:-45.08482361, lat:-7.50263977},
    {lng:-45.08439636, lat:-7.5025239},
    {lng:-45.06932831, lat:-7.50381994},
    {lng:-45.05770493, lat:-7.50841522},
    {lng:-45.04487228, lat:-7.51124811},
    {lng:-45.01854706, lat:-7.49557018},
    {lng:-45.00435638, lat:-7.49676418},
    {lng:-44.98867798, lat:-7.48235083},
    {lng:-44.98351669, lat:-7.48233318},
    {lng:-44.96912766, lat:-7.48344278},
    {lng:-44.95740891, lat:-7.47573185},
    {lng:-44.93717957, lat:-7.47003412},
    {lng:-44.92840195, lat:-7.47139692},
    {lng:-44.92439651, lat:-7.47030306},
    {lng:-44.91942596, lat:-7.45353413},
    {lng:-44.90982437, lat:-7.44327497},
    {lng:-44.90134811, lat:-7.42604923},
    {lng:-44.89658737, lat:-7.42424011},
    {lng:-44.88262939, lat:-7.42756701},
    {lng:-44.86889648, lat:-7.42229986},
    {lng:-44.86296082, lat:-7.41129017},
    {lng:-44.8526268, lat:-7.40205479},
    {lng:-44.85401154, lat:-7.39644098},
    {lng:-44.84844208, lat:-7.38635111},
    {lng:-44.8224411, lat:-7.37720823},
    {lng:-44.81668472, lat:-7.36121893},
    {lng:-44.78672409, lat:-7.3714819},
    {lng:-44.78091049, lat:-7.37823296},
    {lng:-44.74292755, lat:-7.36223412},
    {lng:-44.72984695, lat:-7.39105606},
    {lng:-44.71216965, lat:-7.39789486},
    {lng:-44.70469666, lat:-7.39265823},
    {lng:-44.70026398, lat:-7.39541292},
    {lng:-44.68793106, lat:-7.39454889},
    {lng:-44.67895508, lat:-7.35895205},
    {lng:-44.6720047, lat:-7.35247707},
    {lng:-44.66330338, lat:-7.33182096},
    {lng:-44.65631104, lat:-7.32705688},
    {lng:-44.64616394, lat:-7.32590914},
    {lng:-44.64022064, lat:-7.31486416},
    {lng:-44.61668396, lat:-7.30791283},
    {lng:-44.59606552, lat:-7.27695322},
    {lng:-44.59554672, lat:-7.26905584},
    {lng:-44.57970428, lat:-7.25762081},
    {lng:-44.57290268, lat:-7.24829102},
    {lng:-44.56435013, lat:-7.22794724},
    {lng:-44.56402206, lat:-7.22754622},
    {lng:-44.5279007, lat:-7.22249794},
    {lng:-44.52499771, lat:-7.22084522},
    {lng:-44.51463318, lat:-7.19637203},
    {lng:-44.50079346, lat:-7.18474579},
    {lng:-44.49084473, lat:-7.18283415},
    {lng:-44.48617935, lat:-7.17644501},
    {lng:-44.46401978, lat:-7.16167879},
    {lng:-44.4376564, lat:-7.15574217},
    {lng:-44.41217804, lat:-7.13560104},
    {lng:-44.39767838, lat:-7.12716103},
    {lng:-44.37998962, lat:-7.11903811},
    {lng:-44.36400986, lat:-7.12128115},
    {lng:-44.33300018, lat:-7.10874414},
    {lng:-44.31585312, lat:-7.11800385},
    {lng:-44.30615234, lat:-7.11718607},
    {lng:-44.28754044, lat:-7.08871889},
    {lng:-44.27516937, lat:-7.06938314},
    {lng:-44.27422333, lat:-7.06565714},
    {lng:-44.278759, lat:-7.04602623},
    {lng:-44.27484512, lat:-7.03141022},
    {lng:-44.26429367, lat:-7.01742315},
    {lng:-44.26193619, lat:-6.99873877},
    {lng:-44.24882889, lat:-6.99874306},
    {lng:-44.2358551, lat:-6.99875021},
    {lng:-44.20596313, lat:-6.9634738},
    {lng:-44.20137787, lat:-6.93252993},
    {lng:-44.19282532, lat:-6.92606211},
    {lng:-44.17598724, lat:-6.92792416},
    {lng:-44.17349243, lat:-6.92434978},
    {lng:-44.17549896, lat:-6.89939404},
    {lng:-44.17445374, lat:-6.89356613},
    {lng:-44.16084671, lat:-6.87281418},
    {lng:-44.13912582, lat:-6.86412382},
    {lng:-44.12817764, lat:-6.84189606},
    {lng:-44.11985016, lat:-6.83280182},
    {lng:-44.11512756, lat:-6.83836699},
    {lng:-44.11413193, lat:-6.8528862},
    {lng:-44.10896301, lat:-6.85762596},
    {lng:-44.10318375, lat:-6.85315418},
    {lng:-44.09866333, lat:-6.83995819},
    {lng:-44.11389542, lat:-6.81832504},
    {lng:-44.11536407, lat:-6.81045294},
    {lng:-44.11428452, lat:-6.80507183},
    {lng:-44.10995483, lat:-6.80345106},
    {lng:-44.08882904, lat:-6.80331707},
    {lng:-44.07693863, lat:-6.8211422},
    {lng:-44.06965256, lat:-6.82139206},
    {lng:-44.05901718, lat:-6.80845213},
    {lng:-44.06018448, lat:-6.78476191},
    {lng:-44.05332565, lat:-6.76832485},
    {lng:-44.04285049, lat:-6.76944923},
    {lng:-44.03334808, lat:-6.76041889},
    {lng:-43.98768616, lat:-6.75729418},
    {lng:-43.97068787, lat:-6.74423504},
    {lng:-43.96116257, lat:-6.7419138},
    {lng:-43.94929504, lat:-6.7517581},
    {lng:-43.94505692, lat:-6.76552391},
    {lng:-43.933815, lat:-6.77124882},
    {lng:-43.92933655, lat:-6.7706728},
    {lng:-43.91886902, lat:-6.75580597},
    {lng:-43.91374969, lat:-6.75267696},
    {lng:-43.87982941, lat:-6.75772715},
    {lng:-43.85371399, lat:-6.73562622},
    {lng:-43.8200798, lat:-6.72729206},
    {lng:-43.80717468, lat:-6.71868992},
    {lng:-43.80068207, lat:-6.70763922},
    {lng:-43.79782486, lat:-6.70375681},
    {lng:-43.79668808, lat:-6.70308018},
    {lng:-43.79398346, lat:-6.70274305},
    {lng:-43.77479553, lat:-6.71495199},
    {lng:-43.76068878, lat:-6.70245123},
    {lng:-43.75390244, lat:-6.70295477},
    {lng:-43.7286644, lat:-6.70481682},
    {lng:-43.7159729, lat:-6.69920588},
    {lng:-43.71121979, lat:-6.69954109},
    {lng:-43.70598602, lat:-6.70065784},
    {lng:-43.69849396, lat:-6.70956421},
    {lng:-43.67267227, lat:-6.70628023},
    {lng:-43.65802383, lat:-6.71074486},
    {lng:-43.63746643, lat:-6.71957922},
    {lng:-43.621521, lat:-6.73502684},
    {lng:-43.59888077, lat:-6.74370623},
    {lng:-43.5843277, lat:-6.75749922},
    {lng:-43.57636261, lat:-6.75690222},
    {lng:-43.57561493, lat:-6.75642586},
    {lng:-43.57154083, lat:-6.74910116},
    {lng:-43.5656929, lat:-6.74915123},
    {lng:-43.56079483, lat:-6.74994802},
    {lng:-43.55762863, lat:-6.75270605},
    {lng:-43.55385971, lat:-6.7570138},
    {lng:-43.55078888, lat:-6.76241112},
    {lng:-43.54623032, lat:-6.78309822},
    {lng:-43.53860855, lat:-6.79085922},
    {lng:-43.50684357, lat:-6.80041981},
    {lng:-43.4952507, lat:-6.80928612},
    {lng:-43.48964691, lat:-6.82013702},
    {lng:-43.48190689, lat:-6.83511496},
    {lng:-43.45725632, lat:-6.8463378},
    {lng:-43.45444107, lat:-6.84465981},
    {lng:-43.44431305, lat:-6.83862686},
    {lng:-43.41999435, lat:-6.84384918},
    {lng:-43.40909958, lat:-6.84167719},
    {lng:-43.39943314, lat:-6.83326721},
    {lng:-43.39154434, lat:-6.83441782},
    {lng:-43.38782501, lat:-6.81767321},
    {lng:-43.36404419, lat:-6.81932783},
    {lng:-43.34893799, lat:-6.79809284},
    {lng:-43.30727386, lat:-6.80089617},
    {lng:-43.27867889, lat:-6.79663181},
    {lng:-43.26291656, lat:-6.78565121},
    {lng:-43.25009155, lat:-6.76858521},
    {lng:-43.24464798, lat:-6.76636696},
    {lng:-43.20385361, lat:-6.76420212},
    {lng:-43.16868591, lat:-6.76974678},
    {lng:-43.15262222, lat:-6.78279114},
    {lng:-43.14598465, lat:-6.78311682},
    {lng:-43.13076782, lat:-6.78101301},
    {lng:-43.10506821, lat:-6.77076387},
    {lng:-43.0820694, lat:-6.74809504},
    {lng:-43.06573486, lat:-6.74925613},
    {lng:-43.04862595, lat:-6.76030922},
    {lng:-43.0333519, lat:-6.76267099},
    {lng:-43.01190567, lat:-6.75778389},
    {lng:-43.00112152, lat:-6.75447512},
    {lng:-42.99131393, lat:-6.74545383},
    {lng:-42.97898865, lat:-6.71877193},
    {lng:-42.9496727, lat:-6.70490122},
    {lng:-42.91972733, lat:-6.67032194},
    {lng:-42.91308212, lat:-6.64733887},
    {lng:-42.91717529, lat:-6.63732004},
    {lng:-42.90406036, lat:-6.59766579},
    {lng:-42.88549423, lat:-6.5736618},
    {lng:-42.88455582, lat:-6.56050682},
    {lng:-42.88939667, lat:-6.53852177},
    {lng:-42.87177658, lat:-6.51195621},
    {lng:-42.88506699, lat:-6.50893021},
    {lng:-42.88545609, lat:-6.50536108},
    {lng:-42.88577652, lat:-6.50244093},
    {lng:-42.88318634, lat:-6.49442816},
    {lng:-42.88165283, lat:-6.49339104},
    {lng:-42.86775589, lat:-6.48487377},
    {lng:-42.87104034, lat:-6.46626902},
    {lng:-42.86951065, lat:-6.45035124},
    {lng:-42.87717438, lat:-6.42877913},
    {lng:-42.87770844, lat:-6.41788101},
    {lng:-42.85770798, lat:-6.39009285},
    {lng:-42.85725403, lat:-6.38946199},
    {lng:-42.85647964, lat:-6.37060404},
    {lng:-42.85231781, lat:-6.35912418},
    {lng:-42.83182144, lat:-6.34277391},
    {lng:-42.82928848, lat:-6.33743906},
    {lng:-42.83703232, lat:-6.32536793},
    {lng:-42.85467148, lat:-6.33367586},
    {lng:-42.86014175, lat:-6.33056021},
    {lng:-42.85065079, lat:-6.30736494},
    {lng:-42.84695435, lat:-6.28250885},
    {lng:-42.85542297, lat:-6.26711416},
    {lng:-42.85517502, lat:-6.25357819},
    {lng:-42.85748291, lat:-6.2495122},
    {lng:-42.86708832, lat:-6.23467922},
    {lng:-42.86862946, lat:-6.23283815},
    {lng:-42.87432861, lat:-6.22813606},
    {lng:-42.89531708, lat:-6.2249198},
    {lng:-42.91659164, lat:-6.21342182},
    {lng:-42.93385696, lat:-6.19305515},
    {lng:-42.95182037, lat:-6.18771505},
    {lng:-42.96854019, lat:-6.17827082},
    {lng:-42.97540665, lat:-6.16755915},
    {lng:-42.98179626, lat:-6.13040876},
    {lng:-42.98247528, lat:-6.1295042},
    {lng:-42.9852829, lat:-6.12574816},
    {lng:-42.99296951, lat:-6.11776876},
    {lng:-43.01128769, lat:-6.11102676},
    {lng:-43.03404999, lat:-6.11136198},
    {lng:-43.04993057, lat:-6.09976292},
    {lng:-43.05998993, lat:-6.071527},
    {lng:-43.07493973, lat:-6.05474091},
    {lng:-43.07529068, lat:-6.04216719},
    {lng:-43.07284164, lat:-6.03860521},
    {lng:-43.05881882, lat:-6.0291419},
    {lng:-43.0544548, lat:-6.02394104},
    {lng:-43.05263138, lat:-6.02028322},
    {lng:-43.05017471, lat:-6.01310396},
    {lng:-43.04970551, lat:-5.99377918},
    {lng:-43.05028534, lat:-5.99215603},
    {lng:-43.05541229, lat:-5.98641491},
    {lng:-43.07247925, lat:-5.97496891},
    {lng:-43.08148575, lat:-5.96141815},
    {lng:-43.08156586, lat:-5.96120596},
    {lng:-43.08684921, lat:-5.94731903},
    {lng:-43.0876236, lat:-5.92180204},
    {lng:-43.09498978, lat:-5.91041088},
    {lng:-43.09937668, lat:-5.90363216},
    {lng:-43.09937668, lat:-5.90110493},
    {lng:-43.07872009, lat:-5.87038422},
    {lng:-43.07756042, lat:-5.86516285},
    {lng:-43.09659576, lat:-5.82996416},
    {lng:-43.09695816, lat:-5.82770109},
    {lng:-43.09165192, lat:-5.80643415},
    {lng:-43.09798813, lat:-5.79313803},
    {lng:-43.10128784, lat:-5.76549578},
    {lng:-43.0969696, lat:-5.74573183},
    {lng:-43.09473419, lat:-5.74213314},
    {lng:-43.08012772, lat:-5.74194098},
    {lng:-43.07749939, lat:-5.73163509},
    {lng:-43.0880127, lat:-5.6832099},
    {lng:-43.08264923, lat:-5.64729118},
    {lng:-43.08331299, lat:-5.64439678},
    {lng:-43.09104156, lat:-5.63378},
    {lng:-43.09895325, lat:-5.6332078},
    {lng:-43.09449005, lat:-5.61445808},
    {lng:-43.09108734, lat:-5.60805607},
    {lng:-43.08059692, lat:-5.59986687},
    {lng:-43.04875946, lat:-5.59197903},
    {lng:-43.03455353, lat:-5.59227324},
    {lng:-43.02737427, lat:-5.57911301},
    {lng:-43.02434158, lat:-5.56066418},
    {lng:-43.00522995, lat:-5.54192209},
    {lng:-42.99520493, lat:-5.50695801},
    {lng:-42.97538757, lat:-5.48562479},
    {lng:-42.97322845, lat:-5.48059702},
    {lng:-42.96757126, lat:-5.45289516},
    {lng:-42.96710205, lat:-5.45059299},
    {lng:-42.96242905, lat:-5.44648123},
    {lng:-42.93112183, lat:-5.43790197},
    {lng:-42.92297745, lat:-5.42806101},
    {lng:-42.91320419, lat:-5.3988452},
    {lng:-42.91001511, lat:-5.39485884},
    {lng:-42.90467834, lat:-5.39194822},
    {lng:-42.88245392, lat:-5.38970804},
    {lng:-42.86953735, lat:-5.37727308},
    {lng:-42.86484528, lat:-5.36805105},
    {lng:-42.83716202, lat:-5.35536385},
    {lng:-42.82626724, lat:-5.34696484},
    {lng:-42.82131958, lat:-5.33257914},
    {lng:-42.81321716, lat:-5.30005312},
    {lng:-42.81173325, lat:-5.28812408},
    {lng:-42.81230927, lat:-5.28221893},

    {lng:-42.824334, lat:-5.261662},

    {lng:-42.829330, lat:-5.239369},

    {lng:-42.82744598, lat:-5.23382902},
    {lng:-42.808904, lat:-5.213035},

    {lng:-42.80020905, lat:-5.19939089},
    {lng:-42.80016708, lat:-5.19910622},
    {lng:-42.798993, lat:-5.189672},

    {lng:-42.799452, lat:-5.183042},

    {lng:-42.801365, lat:-5.174469},

    {lng:-42.804250, lat:-5.154038},

    {lng:-42.805404, lat:-5.148629},
    {lng:-42.812040, lat:-5.138286},

    {lng:-42.813214, lat:-5.132969},
    {lng:-42.815489, lat:-5.125706},
    {lng:-42.816777, lat:-5.113304},

    {lng:-42.817264, lat:-5.101723},
    {lng:-42.818225, lat:-5.097614},

    {lng:-42.821814, lat:-5.091120},
    {lng:-42.822479, lat:-5.089791},
    {lng:-42.823526, lat:-5.088348},

    {lng:-42.827430, lat:-5.084267},
    {lng:-42.830867, lat:-5.079346},
    {lng:-42.835416, lat:-5.073965},
    // -5.101952, -42.913712

    {lng:-42.83733368, lat:-5.07032824},
    {lng:-42.84173203, lat:-5.0558672},
    {lng:-42.84148026, lat:-5.03080511},
    {lng:-42.8595314, lat:-4.98225784},
    {lng:-42.86128998, lat:-4.97353315},
    {lng:-42.85474014, lat:-4.93703508},
    {lng:-42.86786652, lat:-4.92771816},
    {lng:-42.86973953, lat:-4.92234087},
    {lng:-42.890625, lat:-4.89484978},
    {lng:-42.89623642, lat:-4.8879261},
    {lng:-42.89367294, lat:-4.85822916},
    {lng:-42.89746475, lat:-4.84270811},
    {lng:-42.93764114, lat:-4.81048822},
    {lng:-42.93975449, lat:-4.80824089},
    {lng:-42.94973755, lat:-4.79070997},
    {lng:-42.95016098, lat:-4.78840113},
    {lng:-42.94842148, lat:-4.76687717},
    {lng:-42.92583084, lat:-4.75002718},
    {lng:-42.92063141, lat:-4.73642302},
    {lng:-42.92299652, lat:-4.72168922},
    {lng:-42.94255447, lat:-4.70857906},
    {lng:-42.95022964, lat:-4.7003541},
    {lng:-42.95454407, lat:-4.68948221},
    {lng:-42.94765854, lat:-4.674932},
    {lng:-42.93236923, lat:-4.66363382},
    {lng:-42.91903305, lat:-4.65343523},
    {lng:-42.91829681, lat:-4.65271091},
    {lng:-42.91070938, lat:-4.64363718},
    {lng:-42.88289642, lat:-4.59688807},
    {lng:-42.87462997, lat:-4.58209419},
    {lng:-42.86899185, lat:-4.57027006},
    {lng:-42.86787415, lat:-4.56358004},
    {lng:-42.87467194, lat:-4.53564501},
    {lng:-42.86034393, lat:-4.51522398},
    {lng:-42.85943222, lat:-4.50089312},
    {lng:-42.85273743, lat:-4.49539089},
    {lng:-42.8513031, lat:-4.49205208},
    {lng:-42.8499527, lat:-4.48564291},
    {lng:-42.85039139, lat:-4.48137379},
    {lng:-42.85400391, lat:-4.4772191},
    {lng:-42.87635803, lat:-4.46406221},
    {lng:-42.87856674, lat:-4.45189381},
    {lng:-42.8719902, lat:-4.4285779},
    {lng:-42.88765335, lat:-4.41182423},
    {lng:-42.92692566, lat:-4.38458204},
    {lng:-42.93040085, lat:-4.38235283},
    {lng:-42.93225479, lat:-4.38202906},
    {lng:-42.95075607, lat:-4.38685417},
    {lng:-42.95862198, lat:-4.38324594},
    {lng:-42.96326447, lat:-4.37643385},
    {lng:-42.96271515, lat:-4.35408688},
    {lng:-42.96223068, lat:-4.33454084},
    {lng:-42.98089981, lat:-4.30091},
    {lng:-42.98369598, lat:-4.28789377},
    {lng:-42.98724747, lat:-4.25704098},
    {lng:-42.98914719, lat:-4.23406982},
    {lng:-42.98195648, lat:-4.21469021},
    {lng:-42.94073486, lat:-4.1669488},
    {lng:-42.93727875, lat:-4.16295195},
    {lng:-42.93593979, lat:-4.16176224},
    {lng:-42.92647934, lat:-4.15676403},
    {lng:-42.88813019, lat:-4.15562677},
    {lng:-42.88748932, lat:-4.14765882},
    {lng:-42.9040947, lat:-4.13260984},
    {lng:-42.90301132, lat:-4.12436581},
    {lng:-42.89587402, lat:-4.11690903},
    {lng:-42.87678528, lat:-4.11005116},
    {lng:-42.86288834, lat:-4.09288883},
    {lng:-42.85716248, lat:-4.07704592},
    {lng:-42.84291077, lat:-4.03763103},
    {lng:-42.83796692, lat:-4.02845478},
    {lng:-42.82360077, lat:-3.99221492},
    {lng:-42.81531906, lat:-3.98770189},
    {lng:-42.80570984, lat:-3.99715805},
    {lng:-42.79787064, lat:-3.99662709},
    {lng:-42.79313278, lat:-3.98093796},
    {lng:-42.78714752, lat:-3.96111608},
    {lng:-42.78508377, lat:-3.95798206},
    {lng:-42.7825737, lat:-3.95584702},
    {lng:-42.73886108, lat:-3.92564988},
    {lng:-42.72615814, lat:-3.91002488},
    {lng:-42.72326279, lat:-3.89405704},
    {lng:-42.72198486, lat:-3.88293505},
    {lng:-42.72111893, lat:-3.87541795},
    {lng:-42.68570328, lat:-3.80726504},
    {lng:-42.6795845, lat:-3.80187988},
    {lng:-42.67150116, lat:-3.793782},
    {lng:-42.66865158, lat:-3.79092598},
    {lng:-42.67900848, lat:-3.77857089},
    {lng:-42.68318176, lat:-3.76338506},
    {lng:-42.68269348, lat:-3.76100111},
    {lng:-42.67838669, lat:-3.75416398},
    {lng:-42.67102051, lat:-3.7416029},
    {lng:-42.66881943, lat:-3.72936702},
    {lng:-42.68273163, lat:-3.703439},
    {lng:-42.68274689, lat:-3.6941359},
    {lng:-42.68157578, lat:-3.69066},
    {lng:-42.67570496, lat:-3.67561793},
    {lng:-42.65703201, lat:-3.65347099},
    {lng:-42.6358223, lat:-3.63197207},
    {lng:-42.62458801, lat:-3.62630391},
    {lng:-42.61850357, lat:-3.61613011},
    {lng:-42.61731339, lat:-3.6120851},
    {lng:-42.60968018, lat:-3.58614993},
    {lng:-42.59113693, lat:-3.57666206},
    {lng:-42.57242584, lat:-3.56951308},
    {lng:-42.5651474, lat:-3.55959797},
    {lng:-42.56233597, lat:-3.55576706},
    {lng:-42.5369606, lat:-3.52391791},
    {lng:-42.53333282, lat:-3.51794004},
    {lng:-42.53377914, lat:-3.50727391},
    {lng:-42.53492355, lat:-3.500525},
    {lng:-42.52950668, lat:-3.49251699},
    {lng:-42.50650787, lat:-3.47883511},
    {lng:-42.50442505, lat:-3.45620298},
    {lng:-42.4983139, lat:-3.447752},
    {lng:-42.49199677, lat:-3.44842911},
    {lng:-42.48728561, lat:-3.44893289},
    {lng:-42.48683167, lat:-3.46957707},
    {lng:-42.48619461, lat:-3.47104311},
    {lng:-42.47317123, lat:-3.48374391},
    {lng:-42.46905899, lat:-3.48481989},
    {lng:-42.46643066, lat:-3.4850359},
    {lng:-42.45864868, lat:-3.48567891},
    {lng:-42.44820023, lat:-3.47835398},
    {lng:-42.43222427, lat:-3.4546299},
    {lng:-42.42311478, lat:-3.45428205},
    {lng:-42.41722488, lat:-3.45829797},
    {lng:-42.41576004, lat:-3.47282696},
    {lng:-42.40962982, lat:-3.47523189},
    {lng:-42.3990593, lat:-3.47291589},
    {lng:-42.39894104, lat:-3.47269011},
    {lng:-42.39237213, lat:-3.46028495},
    {lng:-42.39260864, lat:-3.44760203},
    {lng:-42.37373352, lat:-3.45293498},
    {lng:-42.35425568, lat:-3.44848394},
    {lng:-42.33076096, lat:-3.43388104},
    {lng:-42.32081223, lat:-3.43601394},
    {lng:-42.29874802, lat:-3.45295811},
    {lng:-42.28908157, lat:-3.45176601},
    {lng:-42.27271652, lat:-3.44448805},
    {lng:-42.24287796, lat:-3.43305397},
    {lng:-42.21004105, lat:-3.43632007},
    {lng:-42.20251465, lat:-3.42883492},
    {lng:-42.20432663, lat:-3.43578696},
    {lng:-42.19764328, lat:-3.42502189},
    {lng:-42.19816971, lat:-3.4055829},
    {lng:-42.19031525, lat:-3.39559197},
    {lng:-42.18556213, lat:-3.3925879},
    {lng:-42.15214539, lat:-3.38749409},
    {lng:-42.14242554, lat:-3.35975909},
    {lng:-42.1244812, lat:-3.35289001},
    {lng:-42.1247139, lat:-3.35035801},
    {lng:-42.12838745, lat:-3.34300089},
    {lng:-42.12544632, lat:-3.33061409},
    {lng:-42.12223434, lat:-3.32189989},
    {lng:-42.11360931, lat:-3.31452703},
    {lng:-42.1000824, lat:-3.31140709},
    {lng:-42.09638596, lat:-3.30404997},
    {lng:-42.09651947, lat:-3.30116296},
    {lng:-42.0976181, lat:-3.29842091},
    {lng:-42.10227203, lat:-3.29472399},
    {lng:-42.10725784, lat:-3.29294395},
    {lng:-42.1325264, lat:-3.29008389},
    {lng:-42.13513184, lat:-3.2809329},
    {lng:-42.1293602, lat:-3.27538991},
    {lng:-42.11577988, lat:-3.26234698},
    {lng:-42.07659149, lat:-3.25843596},
    {lng:-42.06666565, lat:-3.25322294},
    {lng:-42.03045273, lat:-3.24591589},
    {lng:-42.01025772, lat:-3.24633598},
    {lng:-42.00017548, lat:-3.24110699},
    {lng:-41.98370743, lat:-3.223526},
    {lng:-41.97900009, lat:-3.21850491},
    {lng:-41.97464752, lat:-3.21223307},
    {lng:-41.97153091, lat:-3.19279695},
    {lng:-41.96440506, lat:-3.17900491},
    {lng:-41.9560585, lat:-3.178509},
    {lng:-41.94322968, lat:-3.18977189},
    {lng:-41.93900299, lat:-3.18738389},
    {lng:-41.9380722, lat:-3.17083359},
    {lng:-41.93722534, lat:-3.15577888},
    {lng:-41.93449402, lat:-3.14938593},
    {lng:-41.92451477, lat:-3.13780594},
    {lng:-41.9259758, lat:-3.11548805},
    {lng:-41.92269897, lat:-3.10794902},
    {lng:-41.91378021, lat:-3.09985089},
    {lng:-41.89972305, lat:-3.0977931},
    {lng:-41.88981628, lat:-3.08978891},
    {lng:-41.86994171, lat:-3.05974293},
    {lng:-41.8616066, lat:-3.04715109},
    {lng:-41.83248138, lat:-3.03268504},
    {lng:-41.82422638, lat:-3.02451706},
    {lng:-41.81468201, lat:-2.98807311},
    {lng:-41.81135178, lat:-2.98244596},
    {lng:-41.7967453, lat:-2.9665761},
    {lng:-41.79665756, lat:-2.96335411},
    {lng:-41.80324936, lat:-2.94531202},
    {lng:-41.80788803, lat:-2.93803},
    {lng:-41.83601761, lat:-2.91604304},
    {lng:-41.84253311, lat:-2.91094995},
    {lng:-41.85785675, lat:-2.89192796},
    {lng:-41.86544418, lat:-2.8749001},
    {lng:-41.86092758, lat:-2.85440898},
    {lng:-41.86151886, lat:-2.83137608},
    {lng:-41.8436203, lat:-2.82392097},
    {lng:-41.84107208, lat:-2.81855798},
    {lng:-41.84675217, lat:-2.80545306},
    {lng:-41.84899902, lat:-2.77353597},
    {lng:-41.82452774, lat:-2.75623894},
    {lng:-41.81680679, lat:-2.7437501},
    {lng:-41.81680679, lat:-2.74430609},
    {lng:-41.81652832, lat:-2.74430609},
    {lng:-41.81652832, lat:-2.74486208},
    {lng:-41.81624985, lat:-2.74486208},
    {lng:-41.81624985, lat:-2.74541593},
    {lng:-41.81597137, lat:-2.74541593},
    {lng:-41.81597137, lat:-2.74597192},
    {lng:-41.8156929, lat:-2.74597192},
    {lng:-41.8156929, lat:-2.74652791},
    {lng:-41.81541824, lat:-2.74652791},
    {lng:-41.81541824, lat:-2.7470839},
    {lng:-41.81513977, lat:-2.7470839},
    {lng:-41.81513977, lat:-2.74763799},
    {lng:-41.8148613, lat:-2.74763799},
    {lng:-41.8148613, lat:-2.74819398},
    {lng:-41.81458282, lat:-2.74819398},
    {lng:-41.81458282, lat:-2.74847198},
    {lng:-41.81430435, lat:-2.74847198},
    {lng:-41.81430435, lat:-2.74902797},
    {lng:-41.81402588, lat:-2.74902797},
    {lng:-41.81402588, lat:-2.74958205},
    {lng:-41.81375122, lat:-2.74958205},
    {lng:-41.81375122, lat:-2.75013804},
    {lng:-41.81347275, lat:-2.75013804},
    {lng:-41.81347275, lat:-2.75069404},
    {lng:-41.81319427, lat:-2.75069404},
    {lng:-41.81319427, lat:-2.75125003},
    {lng:-41.8129158, lat:-2.75125003},
    {lng:-41.8129158, lat:-2.75180697},
    {lng:-41.81263733, lat:-2.75180697},
    {lng:-41.81263733, lat:-2.75236011},
    {lng:-41.81236267, lat:-2.75236011},
    {lng:-41.81236267, lat:-2.75291705},
    {lng:-41.8120842, lat:-2.75291705},
    {lng:-41.8120842, lat:-2.75347304},
    {lng:-41.81180573, lat:-2.75347304},
    {lng:-41.81180573, lat:-2.75402904},
    {lng:-41.81152725, lat:-2.75402904},
    {lng:-41.81152725, lat:-2.75458288},
    {lng:-41.81124878, lat:-2.75458288},
    {lng:-41.81124878, lat:-2.75513911},
    {lng:-41.81097412, lat:-2.75513911},
    {lng:-41.81097412, lat:-2.75541711},
    {lng:-41.81124878, lat:-2.75541711},
    {lng:-41.81124878, lat:-2.7556951},
    {lng:-41.81041718, lat:-2.7556951},
    {lng:-41.81041718, lat:-2.7559731},
    {lng:-41.8101387, lat:-2.7559731},
    {lng:-41.8101387, lat:-2.7562511},
    {lng:-41.80986023, lat:-2.75624895},
    {lng:-41.80986023, lat:-2.75652695},
    {lng:-41.80819321, lat:-2.75652695},
    {lng:-41.80819321, lat:-2.75624895},
    {lng:-41.80708313, lat:-2.7562511},
    {lng:-41.80708313, lat:-2.7559731},
    {lng:-41.80680466, lat:-2.7559731},
    {lng:-41.80680466, lat:-2.7556951},
    {lng:-41.80569458, lat:-2.7556951},
    {lng:-41.80569458, lat:-2.7559731},
    {lng:-41.80541611, lat:-2.7559731},
    {lng:-41.80541611, lat:-2.7562511},
    {lng:-41.80500793, lat:-2.7562511},
    {lng:-41.80374908, lat:-2.7562511},
    {lng:-41.80374908, lat:-2.7559731},
    {lng:-41.80291748, lat:-2.7559731},
    {lng:-41.80291748, lat:-2.7556951},
    {lng:-41.80208206, lat:-2.7556951},
    {lng:-41.80208206, lat:-2.75541711},
    {lng:-41.80152893, lat:-2.75541711},
    {lng:-41.80152893, lat:-2.75513911},
    {lng:-41.80097198, lat:-2.75513911},
    {lng:-41.80097198, lat:-2.75486112},
    {lng:-41.80014038, lat:-2.75486112},
    {lng:-41.80014038, lat:-2.75458288},
    {lng:-41.79958344, lat:-2.75458288},
    {lng:-41.79958344, lat:-2.75430489},
    {lng:-41.79875183, lat:-2.75430489},
    {lng:-41.79875183, lat:-2.75402904},
    {lng:-41.79819489, lat:-2.75402904},
    {lng:-41.79819489, lat:-2.75375104},
    {lng:-41.79763794, lat:-2.75375104},
    {lng:-41.79763794, lat:-2.75347304},
    {lng:-41.79624939, lat:-2.75347304},
    {lng:-41.79624939, lat:-2.75319505},
    {lng:-41.79458237, lat:-2.75319505},
    {lng:-41.79458237, lat:-2.75291705},
    {lng:-41.79152679, lat:-2.75291705},
    {lng:-41.79152679, lat:-2.75319505},
    {lng:-41.79097366, lat:-2.75319505},
    {lng:-41.79097366, lat:-2.75347304},
    {lng:-41.79041672, lat:-2.75347304},
    {lng:-41.79041672, lat:-2.75375104},
    {lng:-41.79013824, lat:-2.75375104},
    {lng:-41.79013824, lat:-2.75430489},
    {lng:-41.78985977, lat:-2.75430489},
    {lng:-41.78985977, lat:-2.75486112},
    {lng:-41.78958511, lat:-2.75486112},
    {lng:-41.78958511, lat:-2.75513911},
    {lng:-41.78930664, lat:-2.75513911},
    {lng:-41.78930664, lat:-2.7556951},
    {lng:-41.78902817, lat:-2.7556951},
    {lng:-41.78902817, lat:-2.7562511},
    {lng:-41.78874969, lat:-2.75624895},
    {lng:-41.78874969, lat:-2.75736094},
    {lng:-41.78847122, lat:-2.75736094},
    {lng:-41.78847122, lat:-2.75819492},
    {lng:-41.78819275, lat:-2.75819492},
    {lng:-41.78819275, lat:-2.759027},
    {lng:-41.78791809, lat:-2.759027},
    {lng:-41.78791809, lat:-2.75986099},
    {lng:-41.78763962, lat:-2.75986099},
    {lng:-41.78763962, lat:-2.76041698},
    {lng:-41.78736115, lat:-2.76041698},
    {lng:-41.78736115, lat:-2.76097298},
    {lng:-41.78708267, lat:-2.76097298},
    {lng:-41.78708267, lat:-2.76152706},
    {lng:-41.7868042, lat:-2.76152706},
    {lng:-41.7868042, lat:-2.76208305},
    {lng:-41.78652954, lat:-2.76208305},
    {lng:-41.78652954, lat:-2.762218},
    {lng:-41.78652954, lat:-2.76263905},
    {lng:-41.78625107, lat:-2.76263905},
    {lng:-41.78625107, lat:-2.76319504},
    {lng:-41.7859726, lat:-2.76319504},
    {lng:-41.7859726, lat:-2.76374888},
    {lng:-41.78569412, lat:-2.76374888},
    {lng:-41.78569412, lat:-2.76430511},
    {lng:-41.78541565, lat:-2.76430511},
    {lng:-41.78541565, lat:-2.76486111},
    {lng:-41.78513718, lat:-2.76486111},
    {lng:-41.78513718, lat:-2.76541805},
    {lng:-41.78486252, lat:-2.76541805},
    {lng:-41.78486252, lat:-2.76597095},
    {lng:-41.78458405, lat:-2.76597095},
    {lng:-41.78458405, lat:-2.76652789},
    {lng:-41.78430557, lat:-2.76652789},
    {lng:-41.78430557, lat:-2.76708388},
    {lng:-41.7840271, lat:-2.76708388},
    {lng:-41.7840271, lat:-2.76764011},
    {lng:-41.78374863, lat:-2.76764011},
    {lng:-41.78374863, lat:-2.76791811},
    {lng:-41.7831955, lat:-2.76791811},
    {lng:-41.7831955, lat:-2.76819396},
    {lng:-41.78291702, lat:-2.76819396},
    {lng:-41.78291702, lat:-2.76874995},
    {lng:-41.78263855, lat:-2.76874995},
    {lng:-41.78263855, lat:-2.76902795},
    {lng:-41.78236008, lat:-2.76902795},
    {lng:-41.78236008, lat:-2.76930594},
    {lng:-41.7820816, lat:-2.76930594},
    {lng:-41.7820816, lat:-2.76986194},
    {lng:-41.78180695, lat:-2.76986194},
    {lng:-41.78180695, lat:-2.77013993},
    {lng:-41.78152847, lat:-2.77013993},
    {lng:-41.78152847, lat:-2.77041602},
    {lng:-41.78125, lat:-2.77041602},
    {lng:-41.78125, lat:-2.77097201},
    {lng:-41.78097153, lat:-2.77097201},
    {lng:-41.78097153, lat:-2.77152801},
    {lng:-41.78069305, lat:-2.77152801},
    {lng:-41.78069305, lat:-2.772084},
    {lng:-41.7804184, lat:-2.772084},
    {lng:-41.7804184, lat:-2.77263808},
    {lng:-41.78013992, lat:-2.77263808},
    {lng:-41.78013992, lat:-2.77319407},
    {lng:-41.77986145, lat:-2.77319407},
    {lng:-41.77986145, lat:-2.77375007},
    {lng:-41.77958298, lat:-2.77375007},
    {lng:-41.77958298, lat:-2.77430606},
    {lng:-41.7793045, lat:-2.77430606},
    {lng:-41.7793045, lat:-2.77485991},
    {lng:-41.77902603, lat:-2.77485991},
    {lng:-41.77902603, lat:-2.7754159},
    {lng:-41.77875137, lat:-2.7754159},
    {lng:-41.77875137, lat:-2.77597189},
    {lng:-41.7784729, lat:-2.77597189},
    {lng:-41.7784729, lat:-2.77624989},
    {lng:-41.77791595, lat:-2.77624989},
    {lng:-41.77791595, lat:-2.77652788},
    {lng:-41.77763748, lat:-2.77652788},
    {lng:-41.77763748, lat:-2.77680612},
    {lng:-41.77736282, lat:-2.77680612},
    {lng:-41.77736282, lat:-2.77708411},
    {lng:-41.77680588, lat:-2.77708411},
    {lng:-41.77680588, lat:-2.77735996},
    {lng:-41.7765274, lat:-2.77735996},
    {lng:-41.7765274, lat:-2.77763796},
    {lng:-41.77624893, lat:-2.77763796},
    {lng:-41.77624893, lat:-2.77791595},
    {lng:-41.7756958, lat:-2.77791595},
    {lng:-41.7756958, lat:-2.77819395},
    {lng:-41.77541733, lat:-2.77819395},
    {lng:-41.77541733, lat:-2.77847195},
    {lng:-41.77513885, lat:-2.77847195},
    {lng:-41.77513885, lat:-2.7787509},
    {lng:-41.77486038, lat:-2.7787509},
    {lng:-41.77486038, lat:-2.77902889},
    {lng:-41.77458191, lat:-2.77902889},
    {lng:-41.77458191, lat:-2.77930403},
    {lng:-41.77430725, lat:-2.77930403},
    {lng:-41.77430725, lat:-2.77986002},
    {lng:-41.77402878, lat:-2.77986002},
    {lng:-41.77402878, lat:-2.78013897},
    {lng:-41.77375031, lat:-2.78013897},
    {lng:-41.77375031, lat:-2.78041697},
    {lng:-41.77347183, lat:-2.78041697},
    {lng:-41.77347183, lat:-2.78069496},
    {lng:-41.77319336, lat:-2.78069496},
    {lng:-41.77319336, lat:-2.78097296},
    {lng:-41.77291489, lat:-2.78097296},
    {lng:-41.77291489, lat:-2.78125095},
    {lng:-41.77236176, lat:-2.78125095},
    {lng:-41.77236176, lat:-2.78152895},
    {lng:-41.77180481, lat:-2.78152895},
    {lng:-41.77180481, lat:-2.78180504},
    {lng:-41.77097321, lat:-2.78180504},
    {lng:-41.77097321, lat:-2.78263903},
    {lng:-41.77069473, lat:-2.78263903},
    {lng:-41.77069473, lat:-2.78347301},
    {lng:-41.77055359, lat:-2.78347301},
    {lng:-41.77041626, lat:-2.78347301},
    {lng:-41.77041626, lat:-2.7840271},
    {lng:-41.77013779, lat:-2.7840271},
    {lng:-41.77013779, lat:-2.78486109},
    {lng:-41.76958466, lat:-2.78486109},
    {lng:-41.76958466, lat:-2.78513908},
    {lng:-41.76930618, lat:-2.78513908},
    {lng:-41.76930618, lat:-2.78541708},
    {lng:-41.76902771, lat:-2.78541708},
    {lng:-41.76902771, lat:-2.78569508},
    {lng:-41.76874924, lat:-2.78569508},
    {lng:-41.76874924, lat:-2.78597307},
    {lng:-41.76847076, lat:-2.78597307},
    {lng:-41.76847076, lat:-2.78625107},
    {lng:-41.76819611, lat:-2.78625107},
    {lng:-41.76819611, lat:-2.78680491},
    {lng:-41.76791763, lat:-2.78680491},
    {lng:-41.76791763, lat:-2.78708291},
    {lng:-41.76763916, lat:-2.78708291},
    {lng:-41.76763916, lat:-2.78736091},
    {lng:-41.76736069, lat:-2.78736091},
    {lng:-41.76736069, lat:-2.7876389},
    {lng:-41.76708221, lat:-2.7876389},
    {lng:-41.76708221, lat:-2.7879169},
    {lng:-41.76680374, lat:-2.7879169},
    {lng:-41.76680374, lat:-2.78819489},
    {lng:-41.76652908, lat:-2.78819489},
    {lng:-41.76652908, lat:-2.78847289},
    {lng:-41.76625061, lat:-2.78847289},
    {lng:-41.76625061, lat:-2.78874898},
    {lng:-41.76597214, lat:-2.78874898},
    {lng:-41.76597214, lat:-2.78902698},
    {lng:-41.76569366, lat:-2.78902698},
    {lng:-41.76569366, lat:-2.78930497},
    {lng:-41.76541519, lat:-2.78930497},
    {lng:-41.76541519, lat:-2.78958297},
    {lng:-41.76514053, lat:-2.78958297},
    {lng:-41.76514053, lat:-2.78986096},
    {lng:-41.76486206, lat:-2.78986096},
    {lng:-41.76486206, lat:-2.79013896},
    {lng:-41.76458359, lat:-2.79013896},
    {lng:-41.76458359, lat:-2.79041696},
    {lng:-41.76430511, lat:-2.79041696},
    {lng:-41.76430511, lat:-2.79069495},
    {lng:-41.76402664, lat:-2.79069495},
    {lng:-41.76402664, lat:-2.79097104},
    {lng:-41.76374817, lat:-2.79097104},
    {lng:-41.76374817, lat:-2.79124904},
    {lng:-41.76347351, lat:-2.79124904},
    {lng:-41.76347351, lat:-2.79152703},
    {lng:-41.76319504, lat:-2.79152703},
    {lng:-41.76319504, lat:-2.79180503},
    {lng:-41.76291656, lat:-2.79180503},
    {lng:-41.76291656, lat:-2.79208302},
    {lng:-41.76263809, lat:-2.79208302},
    {lng:-41.76263809, lat:-2.79236197},
    {lng:-41.76235962, lat:-2.79236197},
    {lng:-41.76235962, lat:-2.79263997},
    {lng:-41.76208496, lat:-2.79263997},
    {lng:-41.76208496, lat:-2.79291797},
    {lng:-41.76152802, lat:-2.79291797},
    {lng:-41.76152802, lat:-2.7931931},
    {lng:-41.76124954, lat:-2.7931931},
    {lng:-41.76124954, lat:-2.7934711},
    {lng:-41.76097107, lat:-2.7934711},
    {lng:-41.76097107, lat:-2.79375005},
    {lng:-41.7606926, lat:-2.79375005},
    {lng:-41.7606926, lat:-2.79402804},
    {lng:-41.76041794, lat:-2.79402804},
    {lng:-41.76041794, lat:-2.79430604},
    {lng:-41.76013947, lat:-2.79430604},
    {lng:-41.76013947, lat:-2.79458404},
    {lng:-41.75986099, lat:-2.79458404},
    {lng:-41.75986099, lat:-2.79486203},
    {lng:-41.75958252, lat:-2.79486203},
    {lng:-41.75958252, lat:-2.79514003},
    {lng:-41.75930405, lat:-2.79513788},
    {lng:-41.75930405, lat:-2.79541612},
    {lng:-41.75902939, lat:-2.79541612},
    {lng:-41.75902939, lat:-2.79569411},
    {lng:-41.75875092, lat:-2.79569411},
    {lng:-41.75875092, lat:-2.79597211},
    {lng:-41.75847244, lat:-2.79597211},
    {lng:-41.75847244, lat:-2.7962501},
    {lng:-41.75819397, lat:-2.7962501},
    {lng:-41.75819397, lat:-2.7965281},
    {lng:-41.7579155, lat:-2.7965281},
    {lng:-41.7579155, lat:-2.7968061},
    {lng:-41.75763702, lat:-2.7968061},
    {lng:-41.75763702, lat:-2.79708409},
    {lng:-41.75736237, lat:-2.79708409},
    {lng:-41.75736237, lat:-2.79736209},
    {lng:-41.75708389, lat:-2.79736209},
    {lng:-41.75708389, lat:-2.79764009},
    {lng:-41.75680542, lat:-2.79763794},
    {lng:-41.75680542, lat:-2.79791594},
    {lng:-41.75652695, lat:-2.79791594},
    {lng:-41.75652695, lat:-2.79819393},
    {lng:-41.75597382, lat:-2.79819393},
    {lng:-41.75597382, lat:-2.79847193},
    {lng:-41.75569534, lat:-2.79847193},
    {lng:-41.75569534, lat:-2.79874992},
    {lng:-41.75541687, lat:-2.79874992},
    {lng:-41.75541687, lat:-2.79902792},
    {lng:-41.75485992, lat:-2.79902792},
    {lng:-41.75485992, lat:-2.79930592},
    {lng:-41.75458145, lat:-2.79930592},
    {lng:-41.75458145, lat:-2.79958391},
    {lng:-41.75430679, lat:-2.79958391},
    {lng:-41.75430679, lat:-2.79986191},
    {lng:-41.75402832, lat:-2.79986191},
    {lng:-41.75402832, lat:-2.800138},
    {lng:-41.75347137, lat:-2.800138},
    {lng:-41.75347137, lat:-2.80041599},
    {lng:-41.7531929, lat:-2.80041599},
    {lng:-41.7531929, lat:-2.80069399},
    {lng:-41.75291824, lat:-2.80069399},
    {lng:-41.75291824, lat:-2.80097198},
    {lng:-41.7523613, lat:-2.80097198},
    {lng:-41.7523613, lat:-2.80124998},
    {lng:-41.75222778, lat:-2.80124998},
    {lng:-41.75208282, lat:-2.80124998},
    {lng:-41.75208282, lat:-2.80152798},
    {lng:-41.75180435, lat:-2.80152798},
    {lng:-41.75180435, lat:-2.80180597},
    {lng:-41.75152588, lat:-2.80180597},
    {lng:-41.75152588, lat:-2.80208397},
    {lng:-41.75097275, lat:-2.80208397},
    {lng:-41.75097275, lat:-2.80236006},
    {lng:-41.75069427, lat:-2.80236006},
    {lng:-41.75069427, lat:-2.80263805},
    {lng:-41.7504158, lat:-2.80263805},
    {lng:-41.7504158, lat:-2.80291605},
    {lng:-41.75013733, lat:-2.80291605},
    {lng:-41.75013733, lat:-2.80319405},
    {lng:-41.7495842, lat:-2.80319405},
    {lng:-41.7495842, lat:-2.80347204},
    {lng:-41.74930573, lat:-2.80347204},
    {lng:-41.74930573, lat:-2.80375004},
    {lng:-41.74902725, lat:-2.80375004},
    {lng:-41.74902725, lat:-2.80402803},
    {lng:-41.74847412, lat:-2.80402803},
    {lng:-41.74847412, lat:-2.80430603},
    {lng:-41.74819565, lat:-2.80430603},
    {lng:-41.74819565, lat:-2.80458212},
    {lng:-41.74791718, lat:-2.80458212},
    {lng:-41.74791718, lat:-2.80486012},
    {lng:-41.7476387, lat:-2.80486012},
    {lng:-41.7476387, lat:-2.80513811},
    {lng:-41.74708176, lat:-2.80513811},
    {lng:-41.74708176, lat:-2.80535507},
    {lng:-41.74686813, lat:-2.80541611},
    {lng:-41.7468071, lat:-2.8056941},
    {lng:-41.74652863, lat:-2.8056941},
    {lng:-41.74652863, lat:-2.80597305},
    {lng:-41.74597168, lat:-2.80597305},
    {lng:-41.74597168, lat:-2.80625105},
    {lng:-41.74569321, lat:-2.80625105},
    {lng:-41.74569321, lat:-2.80652905},
    {lng:-41.74514008, lat:-2.80652905},
    {lng:-41.74514008, lat:-2.80680704},
    {lng:-41.74458313, lat:-2.80680704},
    {lng:-41.74458313, lat:-2.80708504},
    {lng:-41.74402618, lat:-2.80708504},
    {lng:-41.74402618, lat:-2.80736089},
    {lng:-41.74347305, lat:-2.80736089},
    {lng:-41.74347305, lat:-2.80763888},
    {lng:-41.74291611, lat:-2.80763888},
    {lng:-41.74291611, lat:-2.80791712},
    {lng:-41.74236298, lat:-2.80791712},
    {lng:-41.74236298, lat:-2.80819511},
    {lng:-41.74152756, lat:-2.80819511},
    {lng:-41.74152756, lat:-2.80847311},
    {lng:-41.74097061, lat:-2.80847311},
    {lng:-41.74097061, lat:-2.80875111},
    {lng:-41.74041748, lat:-2.80875111},
    {lng:-41.74041748, lat:-2.80902696},
    {lng:-41.73986053, lat:-2.80902696},
    {lng:-41.73986053, lat:-2.80930495},
    {lng:-41.7393074, lat:-2.80930495},
    {lng:-41.7393074, lat:-2.80958295},
    {lng:-41.73847198, lat:-2.80958295},
    {lng:-41.73847198, lat:-2.80986094},
    {lng:-41.73791504, lat:-2.80986094},
    {lng:-41.73791504, lat:-2.81013894},
    {lng:-41.73736191, lat:-2.81013894},
    {lng:-41.73736191, lat:-2.81041694},
    {lng:-41.73680496, lat:-2.81041694},
    {lng:-41.73680496, lat:-2.81069493},
    {lng:-41.73625183, lat:-2.81069493},
    {lng:-41.73625183, lat:-2.81097293},
    {lng:-41.73569489, lat:-2.81097293},
    {lng:-41.73569489, lat:-2.81125093},
    {lng:-41.73513794, lat:-2.81125093},
    {lng:-41.73513794, lat:-2.81097293},
    {lng:-41.73485947, lat:-2.81097293},
    {lng:-41.73485947, lat:-2.81069493},
    {lng:-41.73430634, lat:-2.81069493},
    {lng:-41.73430634, lat:-2.81041694},
    {lng:-41.73402786, lat:-2.81041694},
    {lng:-41.73402786, lat:-2.81013894},
    {lng:-41.73374939, lat:-2.81013894},
    {lng:-41.73374939, lat:-2.80986094},
    {lng:-41.73319626, lat:-2.80986094},
    {lng:-41.73319626, lat:-2.80958295},
    {lng:-41.73291779, lat:-2.80958295},
    {lng:-41.73291779, lat:-2.80942106},
    {lng:-41.73291779, lat:-2.80930495},
    {lng:-41.73263931, lat:-2.80930495},
    {lng:-41.73263931, lat:-2.80875111},
    {lng:-41.73236084, lat:-2.80875111},
    {lng:-41.73236084, lat:-2.80847311},
    {lng:-41.73208237, lat:-2.80847311},
    {lng:-41.73208237, lat:-2.80791712},
    {lng:-41.73180389, lat:-2.80791712},
    {lng:-41.73180389, lat:-2.80763888},
    {lng:-41.73152924, lat:-2.80763888},
    {lng:-41.73152924, lat:-2.80708504},
    {lng:-41.73125076, lat:-2.80708504},
    {lng:-41.73125076, lat:-2.80680704},
    {lng:-41.73097229, lat:-2.80680704},
    {lng:-41.73097229, lat:-2.80625105},
    {lng:-41.73069382, lat:-2.80625105},
    {lng:-41.73069382, lat:-2.80597305},
    {lng:-41.73041534, lat:-2.80597305},
    {lng:-41.73041534, lat:-2.80541611},
    {lng:-41.73014069, lat:-2.80541611},
    {lng:-41.73014069, lat:-2.80513811},
    {lng:-41.72874832, lat:-2.80513811},
    {lng:-41.72874832, lat:-2.80541611},
    {lng:-41.72847366, lat:-2.80541611},
    {lng:-41.72847366, lat:-2.8056941},
    {lng:-41.72819519, lat:-2.8056941},
    {lng:-41.72819519, lat:-2.80597305},
    {lng:-41.72791672, lat:-2.80597305},
    {lng:-41.72791672, lat:-2.80625105},
    {lng:-41.72763824, lat:-2.80625105},
    {lng:-41.72763824, lat:-2.80680704},
    {lng:-41.72735977, lat:-2.80680704},
    {lng:-41.72735977, lat:-2.80708504},
    {lng:-41.72708511, lat:-2.80708504},
    {lng:-41.72708511, lat:-2.80736089},
    {lng:-41.72680664, lat:-2.80736089},
    {lng:-41.72680664, lat:-2.80763888},
    {lng:-41.72652817, lat:-2.80763888},
    {lng:-41.72652817, lat:-2.80791712},
    {lng:-41.72624969, lat:-2.80791712},
    {lng:-41.72624969, lat:-2.80819511},
    {lng:-41.72597122, lat:-2.80819511},
    {lng:-41.72597122, lat:-2.80847311},
    {lng:-41.72569275, lat:-2.80847311},
    {lng:-41.72569275, lat:-2.80875111},
    {lng:-41.72541809, lat:-2.80875111},
    {lng:-41.72541809, lat:-2.80902696},
    {lng:-41.72513962, lat:-2.80902696},
    {lng:-41.72513962, lat:-2.80930495},
    {lng:-41.72486115, lat:-2.80930495},
    {lng:-41.72486115, lat:-2.80958295},
    {lng:-41.72458267, lat:-2.80958295},
    {lng:-41.72458267, lat:-2.80986094},
    {lng:-41.7243042, lat:-2.80986094},
    {lng:-41.7243042, lat:-2.81013894},
    {lng:-41.72402954, lat:-2.81013894},
    {lng:-41.72402954, lat:-2.81041694},
    {lng:-41.72375107, lat:-2.81041694},
    {lng:-41.72375107, lat:-2.81069493},
    {lng:-41.72319412, lat:-2.81069493},
    {lng:-41.72319412, lat:-2.81097293},
    {lng:-41.72291565, lat:-2.81097293},
    {lng:-41.72291565, lat:-2.81125093},
    {lng:-41.72263718, lat:-2.81125093},
    {lng:-41.72263718, lat:-2.81152701},
    {lng:-41.72236252, lat:-2.81152701},
    {lng:-41.72236252, lat:-2.81180501},
    {lng:-41.72208405, lat:-2.81180501},
    {lng:-41.72208405, lat:-2.81208301},
    {lng:-41.72180557, lat:-2.81208301},
    {lng:-41.72180557, lat:-2.812361},
    {lng:-41.7215271, lat:-2.812361},
    {lng:-41.7215271, lat:-2.812639},
    {lng:-41.72124863, lat:-2.812639},
    {lng:-41.72124863, lat:-2.81291699},
    {lng:-41.72097397, lat:-2.81291699},
    {lng:-41.72097397, lat:-2.81319499},
    {lng:-41.7206955, lat:-2.81319499},
    {lng:-41.7206955, lat:-2.81347299},
    {lng:-41.72041702, lat:-2.81347299},
    {lng:-41.72041702, lat:-2.81374907},
    {lng:-41.72013855, lat:-2.81374907},
    {lng:-41.72013855, lat:-2.81402707},
    {lng:-41.71986008, lat:-2.81402707},
    {lng:-41.71986008, lat:-2.81430507},
    {lng:-41.7195816, lat:-2.81430507},
    {lng:-41.7195816, lat:-2.81458306},
    {lng:-41.71930695, lat:-2.81458306},
    {lng:-41.71930695, lat:-2.81486106},
    {lng:-41.71902847, lat:-2.81486106},
    {lng:-41.71902847, lat:-2.81513906},
    {lng:-41.71875, lat:-2.81513906},
    {lng:-41.71875, lat:-2.81537199},
    {lng:-41.71847153, lat:-2.81541705},
    {lng:-41.71847153, lat:-2.815552},
    {lng:-41.71847153, lat:-2.81569505},
    {lng:-41.71819305, lat:-2.81569505},
    {lng:-41.71819305, lat:-2.81597304},
    {lng:-41.7179184, lat:-2.81597304},
    {lng:-41.7179184, lat:-2.81624889},
    {lng:-41.71763992, lat:-2.81624889},
    {lng:-41.71763992, lat:-2.81652689},
    {lng:-41.71708298, lat:-2.81652689},
    {lng:-41.71708298, lat:-2.81680489},
    {lng:-41.7168045, lat:-2.81680489},
    {lng:-41.7168045, lat:-2.81708288},
    {lng:-41.71652603, lat:-2.81708288},
    {lng:-41.71652603, lat:-2.81736112},
    {lng:-41.71625137, lat:-2.81736112},
    {lng:-41.71625137, lat:-2.81763911},
    {lng:-41.7159729, lat:-2.81763911},
    {lng:-41.7159729, lat:-2.81791711},
    {lng:-41.71569443, lat:-2.81791711},
    {lng:-41.71569443, lat:-2.81819606},
    {lng:-41.71541595, lat:-2.81819606},
    {lng:-41.71541595, lat:-2.81847095},
    {lng:-41.71513748, lat:-2.81847095},
    {lng:-41.71513748, lat:-2.81874895},
    {lng:-41.71486282, lat:-2.81874895},
    {lng:-41.71486282, lat:-2.81902695},
    {lng:-41.71458435, lat:-2.81902695},
    {lng:-41.71458435, lat:-2.81930494},
    {lng:-41.71430588, lat:-2.81930494},
    {lng:-41.71430588, lat:-2.81958389},
    {lng:-41.7140274, lat:-2.81958389},
    {lng:-41.7140274, lat:-2.81986189},
    {lng:-41.71374893, lat:-2.81986189},
    {lng:-41.71374893, lat:-2.82013988},
    {lng:-41.71347046, lat:-2.82013988},
    {lng:-41.71347046, lat:-2.82041788},
    {lng:-41.7131958, lat:-2.82041788},
    {lng:-41.7131958, lat:-2.82069302},
    {lng:-41.71291733, lat:-2.82069302},
    {lng:-41.71291733, lat:-2.82097197},
    {lng:-41.71263885, lat:-2.82097197},
    {lng:-41.71263885, lat:-2.82124996},
    {lng:-41.71208191, lat:-2.82124996},
    {lng:-41.71208191, lat:-2.82152796},
    {lng:-41.71180725, lat:-2.82152796},
    {lng:-41.71180725, lat:-2.82180595},
    {lng:-41.71152878, lat:-2.82180595},
    {lng:-41.71152878, lat:-2.82208395},
    {lng:-41.71125031, lat:-2.82208395},
    {lng:-41.71125031, lat:-2.82236195},
    {lng:-41.71097183, lat:-2.82236195},
    {lng:-41.71097183, lat:-2.82263994},
    {lng:-41.71069336, lat:-2.82263994},
    {lng:-41.71069336, lat:-2.82291603},
    {lng:-41.71041489, lat:-2.82291603},
    {lng:-41.71041489, lat:-2.82319403},
    {lng:-41.71014023, lat:-2.82319403},
    {lng:-41.71014023, lat:-2.82347202},
    {lng:-41.70986176, lat:-2.82347202},
    {lng:-41.70986176, lat:-2.82375002},
    {lng:-41.70958328, lat:-2.82375002},
    {lng:-41.70958328, lat:-2.82402802},
    {lng:-41.70930481, lat:-2.82402802},
    {lng:-41.70930481, lat:-2.82430601},
    {lng:-41.70902634, lat:-2.82430601},
    {lng:-41.70902634, lat:-2.82458401},
    {lng:-41.70875168, lat:-2.82458401},
    {lng:-41.70875168, lat:-2.824862},
    {lng:-41.70847321, lat:-2.824862},
    {lng:-41.70847321, lat:-2.82513809},
    {lng:-41.70819473, lat:-2.82513809},
    {lng:-41.70819473, lat:-2.82541609},
    {lng:-41.70763779, lat:-2.82541609},
    {lng:-41.70763779, lat:-2.82569408},
    {lng:-41.70735931, lat:-2.82569408},
    {lng:-41.70735931, lat:-2.82597208},
    {lng:-41.70708466, lat:-2.82597208},
    {lng:-41.70708466, lat:-2.82625008},
    {lng:-41.70680618, lat:-2.82625008},
    {lng:-41.70680618, lat:-2.82652807},
    {lng:-41.70652771, lat:-2.82652807},
    {lng:-41.70652771, lat:-2.82680607},
    {lng:-41.70624924, lat:-2.82680607},
    {lng:-41.70624924, lat:-2.82708406},
    {lng:-41.70597076, lat:-2.82708406},
    {lng:-41.70597076, lat:-2.82736206},
    {lng:-41.70569611, lat:-2.82736206},
    {lng:-41.70569611, lat:-2.82763791},
    {lng:-41.70541763, lat:-2.82763791},
    {lng:-41.70541763, lat:-2.82791591},
    {lng:-41.70513916, lat:-2.82791591},
    {lng:-41.70513916, lat:-2.8281939},
    {lng:-41.70486069, lat:-2.8281939},
    {lng:-41.70486069, lat:-2.8284719},
    {lng:-41.70458221, lat:-2.8284719},
    {lng:-41.70458221, lat:-2.8287499},
    {lng:-41.70430374, lat:-2.8287499},
    {lng:-41.70430374, lat:-2.82902789},
    {lng:-41.70402908, lat:-2.82902789},
    {lng:-41.70402908, lat:-2.82930589},
    {lng:-41.70375061, lat:-2.82930589},
    {lng:-41.70375061, lat:-2.82958388},
    {lng:-41.70347214, lat:-2.82958388},
    {lng:-41.70347214, lat:-2.82985997},
    {lng:-41.70319366, lat:-2.82985997},
    {lng:-41.70319366, lat:-2.83013797},
    {lng:-41.70291519, lat:-2.83013797},
    {lng:-41.70291519, lat:-2.83041596},
    {lng:-41.70264053, lat:-2.83041596},
    {lng:-41.70264053, lat:-2.83069396},
    {lng:-41.70236206, lat:-2.83069396},
    {lng:-41.70236206, lat:-2.83097196},
    {lng:-41.70208359, lat:-2.83097196},
    {lng:-41.70208359, lat:-2.83124995},
    {lng:-41.70180511, lat:-2.83124995},
    {lng:-41.70180511, lat:-2.83152795},
    {lng:-41.70152664, lat:-2.83152795},
    {lng:-41.70152664, lat:-2.8318069},
    {lng:-41.70124817, lat:-2.8318069},
    {lng:-41.70124817, lat:-2.83208203},
    {lng:-41.70097351, lat:-2.83208203},
    {lng:-41.70097351, lat:-2.83236003},
    {lng:-41.70069504, lat:-2.83236003},
    {lng:-41.70069504, lat:-2.83263803},
    {lng:-41.70041656, lat:-2.83263803},
    {lng:-41.70041656, lat:-2.83291602},
    {lng:-41.70013809, lat:-2.83291602},
    {lng:-41.70013809, lat:-2.83319497},
    {lng:-41.69985962, lat:-2.83319497},
    {lng:-41.69985962, lat:-2.83347297},
    {lng:-41.69958496, lat:-2.83347297},
    {lng:-41.69958496, lat:-2.83375096},
    {lng:-41.69930649, lat:-2.83375096},
    {lng:-41.69930649, lat:-2.83402896},
    {lng:-41.69902802, lat:-2.83402896},
    {lng:-41.69902802, lat:-2.83430409},
    {lng:-41.69874954, lat:-2.83430409},
    {lng:-41.69874954, lat:-2.83458304},
    {lng:-41.69847107, lat:-2.83458304},
    {lng:-41.69847107, lat:-2.83486104},
    {lng:-41.6981926, lat:-2.83486104},
    {lng:-41.6981926, lat:-2.83513904},
    {lng:-41.69791794, lat:-2.83513904},
    {lng:-41.69791794, lat:-2.83541703},
    {lng:-41.69763947, lat:-2.83541703},
    {lng:-41.69763947, lat:-2.83569503},
    {lng:-41.69736099, lat:-2.83569503},
    {lng:-41.69736099, lat:-2.83597302},
    {lng:-41.69708252, lat:-2.83597302},
    {lng:-41.69708252, lat:-2.83625102},
    {lng:-41.69680405, lat:-2.83625102},
    {lng:-41.69680405, lat:-2.83652902},
    {lng:-41.69652939, lat:-2.83652711},
    {lng:-41.69652939, lat:-2.83680511},
    {lng:-41.69625092, lat:-2.83680511},
    {lng:-41.69625092, lat:-2.8370831},
    {lng:-41.69597244, lat:-2.8370831},
    {lng:-41.69597244, lat:-2.8373611},
    {lng:-41.69569397, lat:-2.8373611},
    {lng:-41.69569397, lat:-2.83763909},
    {lng:-41.6954155, lat:-2.83763909},
    {lng:-41.6954155, lat:-2.83791709},
    {lng:-41.69486237, lat:-2.83791709},
    {lng:-41.69486237, lat:-2.83819509},
    {lng:-41.69458389, lat:-2.83819509},
    {lng:-41.69458389, lat:-2.83847308},
    {lng:-41.69430542, lat:-2.83847308},
    {lng:-41.69430542, lat:-2.83874893},
    {lng:-41.69374847, lat:-2.83874893},
    {lng:-41.69374847, lat:-2.83902693},
    {lng:-41.69347382, lat:-2.83902693},
    {lng:-41.69347382, lat:-2.83930492},
    {lng:-41.69319534, lat:-2.83930492},
    {lng:-41.69319534, lat:-2.83958292},
    {lng:-41.69291687, lat:-2.83958292},
    {lng:-41.69291687, lat:-2.83986092},
    {lng:-41.69235992, lat:-2.83986092},
    {lng:-41.69235992, lat:-2.84013891},
    {lng:-41.69208145, lat:-2.84013891},
    {lng:-41.69208145, lat:-2.84041691},
    {lng:-41.69180679, lat:-2.84041691},
    {lng:-41.69180679, lat:-2.8406949},
    {lng:-41.69124985, lat:-2.8406949},
    {lng:-41.69124985, lat:-2.8409729},
    {lng:-41.69097137, lat:-2.8409729},
    {lng:-41.69097137, lat:-2.84124899},
    {lng:-41.6906929, lat:-2.84124899},
    {lng:-41.6906929, lat:-2.84152699},
    {lng:-41.69041824, lat:-2.84152699},
    {lng:-41.69041824, lat:-2.84180498},
    {lng:-41.6898613, lat:-2.84180498},
    {lng:-41.6898613, lat:-2.84208298},
    {lng:-41.68958282, lat:-2.84208298},
    {lng:-41.68958282, lat:-2.84236097},
    {lng:-41.68930435, lat:-2.84236097},
    {lng:-41.68930435, lat:-2.84263897},
    {lng:-41.68875122, lat:-2.84263897},
    {lng:-41.68875122, lat:-2.84291697},
    {lng:-41.68847275, lat:-2.84291697},
    {lng:-41.68847275, lat:-2.84319496},
    {lng:-41.68819427, lat:-2.84319496},
    {lng:-41.68819427, lat:-2.84347105},
    {lng:-41.68763733, lat:-2.84347105},
    {lng:-41.68763733, lat:-2.84374905},
    {lng:-41.68736267, lat:-2.84374905},
    {lng:-41.68736267, lat:-2.84402704},
    {lng:-41.6870842, lat:-2.84402704},
    {lng:-41.6870842, lat:-2.84430504},
    {lng:-41.68680573, lat:-2.84430504},
    {lng:-41.68680573, lat:-2.84458303},
    {lng:-41.68624878, lat:-2.84458303},
    {lng:-41.68624878, lat:-2.84486103},
    {lng:-41.68597412, lat:-2.84486103},
    {lng:-41.68597412, lat:-2.84513903},
    {lng:-41.68569565, lat:-2.84513903},
    {lng:-41.68569565, lat:-2.84541798},
    {lng:-41.6851387, lat:-2.84541798},
    {lng:-41.6851387, lat:-2.84569597},
    {lng:-41.68486023, lat:-2.84569597},
    {lng:-41.68486023, lat:-2.84597111},
    {lng:-41.68458176, lat:-2.84597111},
    {lng:-41.68458176, lat:-2.8462491},
    {lng:-41.6843071, lat:-2.8462491},
    {lng:-41.6843071, lat:-2.8465271},
    {lng:-41.68375015, lat:-2.8465271},
    {lng:-41.68375015, lat:-2.84680605},
    {lng:-41.68347168, lat:-2.84680605},
    {lng:-41.68347168, lat:-2.84708405},
    {lng:-41.68319321, lat:-2.84708405},
    {lng:-41.68319321, lat:-2.84736204},
    {lng:-41.68264008, lat:-2.84736204},
    {lng:-41.68264008, lat:-2.84764004},
    {lng:-41.6823616, lat:-2.84764004},
    {lng:-41.6823616, lat:-2.84791803},
    {lng:-41.68208313, lat:-2.84791803},
    {lng:-41.68208313, lat:-2.84819388},
    {lng:-41.68152618, lat:-2.84819388},
    {lng:-41.68152618, lat:-2.84847212},
    {lng:-41.68125153, lat:-2.84847212},
    {lng:-41.68125153, lat:-2.84875011},
    {lng:-41.68069458, lat:-2.84875011},
    {lng:-41.68069458, lat:-2.84902811},
    {lng:-41.68041611, lat:-2.84902811},
    {lng:-41.68041611, lat:-2.84930611},
    {lng:-41.67986298, lat:-2.84930611},
    {lng:-41.67986298, lat:-2.8495841},
    {lng:-41.6795845, lat:-2.8495841},
    {lng:-41.6795845, lat:-2.8498621},
    {lng:-41.67902756, lat:-2.8498621},
    {lng:-41.67902756, lat:-2.85014009},
    {lng:-41.67874908, lat:-2.85013795},
    {lng:-41.67874908, lat:-2.85041595},
    {lng:-41.67819595, lat:-2.85041595},
    {lng:-41.67819595, lat:-2.85069394},
    {lng:-41.67791748, lat:-2.85069394},
    {lng:-41.67791748, lat:-2.85097194},
    {lng:-41.67736053, lat:-2.85097194},
    {lng:-41.67736053, lat:-2.85124993},
    {lng:-41.67708206, lat:-2.85124993},
    {lng:-41.67708206, lat:-2.85152793},
    {lng:-41.6768074, lat:-2.85152793},
    {lng:-41.6768074, lat:-2.85180593},
    {lng:-41.67625046, lat:-2.85180593},
    {lng:-41.67625046, lat:-2.85208392},
    {lng:-41.67597198, lat:-2.85208392},
    {lng:-41.67597198, lat:-2.85236192},
    {lng:-41.67541504, lat:-2.85236192},
    {lng:-41.67541504, lat:-2.85263991},
    {lng:-41.67514038, lat:-2.85263991},
    {lng:-41.67514038, lat:-2.852916},
    {lng:-41.67458344, lat:-2.852916},
    {lng:-41.67458344, lat:-2.853194},
    {lng:-41.67430496, lat:-2.853194},
    {lng:-41.67430496, lat:-2.85347199},
    {lng:-41.67375183, lat:-2.85347199},
    {lng:-41.67375183, lat:-2.85374999},
    {lng:-41.67347336, lat:-2.85374999},
    {lng:-41.67347336, lat:-2.85402799},
    {lng:-41.67291641, lat:-2.85402799},
    {lng:-41.67291641, lat:-2.85430598},
    {lng:-41.67263794, lat:-2.85430598},
    {lng:-41.67263794, lat:-2.85458398},
    {lng:-41.67208481, lat:-2.85458398},
    {lng:-41.67208481, lat:-2.85486007},
    {lng:-41.67152786, lat:-2.85486007},
    {lng:-41.67152786, lat:-2.85513806},
    {lng:-41.67097092, lat:-2.85513806},
    {lng:-41.67097092, lat:-2.85541606},
    {lng:-41.67074585, lat:-2.85541606},
    {lng:-41.67041779, lat:-2.85541606},
    {lng:-41.67041779, lat:-2.85569406},
    {lng:-41.66958237, lat:-2.85569406},
    {lng:-41.66958237, lat:-2.85597205},
    {lng:-41.66902924, lat:-2.85597205},
    {lng:-41.66902924, lat:-2.85625005},
    {lng:-41.66847229, lat:-2.85625005},
    {lng:-41.66847229, lat:-2.85652804},
    {lng:-41.66791534, lat:-2.85652804},
    {lng:-41.66791534, lat:-2.85680604},
    {lng:-41.66708374, lat:-2.85680604},
    {lng:-41.66708374, lat:-2.85708404},
    {lng:-41.66652679, lat:-2.85708404},
    {lng:-41.66652679, lat:-2.85735989},
    {lng:-41.66597366, lat:-2.85735989},
    {lng:-41.66597366, lat:-2.85763788},
    {lng:-41.66513824, lat:-2.85763788},
    {lng:-41.66513824, lat:-2.85791612},
    {lng:-41.66458511, lat:-2.85791612},
    {lng:-41.66458511, lat:-2.85819411},
    {lng:-41.66402817, lat:-2.85819411},
    {lng:-41.66402817, lat:-2.85847211},
    {lng:-41.66319275, lat:-2.85847211},
    {lng:-41.66319275, lat:-2.8587501},
    {lng:-41.66208267, lat:-2.8587501},
    {lng:-41.66208267, lat:-2.85902905},
    {lng:-41.6609726, lat:-2.85902905},
    {lng:-41.6609726, lat:-2.85930705},
    {lng:-41.65986252, lat:-2.85930705},
    {lng:-41.65986252, lat:-2.85958195},
    {lng:-41.65874863, lat:-2.85958195},
    {lng:-41.65874863, lat:-2.85985994},
    {lng:-41.65763855, lat:-2.85985994},
    {lng:-41.65763855, lat:-2.86013794},
    {lng:-41.65652847, lat:-2.86013794},
    {lng:-41.65652847, lat:-2.86041689},
    {lng:-41.6554184, lat:-2.86041689},
    {lng:-41.6554184, lat:-2.86069489},
    {lng:-41.65402603, lat:-2.86069489},
    {lng:-41.65402603, lat:-2.86097288},
    {lng:-41.65208435, lat:-2.86097288},
    {lng:-41.65208435, lat:-2.86125112},
    {lng:-41.64958191, lat:-2.86125112},
    {lng:-41.64958191, lat:-2.86152911},
    {lng:-41.64930725, lat:-2.86152911},
    {lng:-41.64930725, lat:-2.86263895},
    {lng:-41.64958191, lat:-2.86263895},
    {lng:-41.64958191, lat:-2.86347294},
    {lng:-41.64986038, lat:-2.86347294},
    {lng:-41.64986038, lat:-2.86430502},
    {lng:-41.65013885, lat:-2.86430502},
    {lng:-41.65013885, lat:-2.865417},
    {lng:-41.65041733, lat:-2.865417},
    {lng:-41.65041733, lat:-2.865973},
    {lng:-41.6506958, lat:-2.865973},
    {lng:-41.6506958, lat:-2.86652708},
    {lng:-41.65097046, lat:-2.86652708},
    {lng:-41.65097046, lat:-2.86708307},
    {lng:-41.65124893, lat:-2.86708307},
    {lng:-41.65124893, lat:-2.86736107},
    {lng:-41.6515274, lat:-2.86736107},
    {lng:-41.6515274, lat:-2.86791706},
    {lng:-41.65180588, lat:-2.86791706},
    {lng:-41.65180588, lat:-2.86819506},
    {lng:-41.65208435, lat:-2.86819506},
    {lng:-41.65208435, lat:-2.8687489},
    {lng:-41.65236282, lat:-2.8687489},
    {lng:-41.65236282, lat:-2.8693049},
    {lng:-41.65263748, lat:-2.8693049},
    {lng:-41.65263748, lat:-2.86958289},
    {lng:-41.65291595, lat:-2.86958289},
    {lng:-41.65291595, lat:-2.87013888},
    {lng:-41.65319443, lat:-2.87013888},
    {lng:-41.65319443, lat:-2.87041712},
    {lng:-41.6534729, lat:-2.87041712},
    {lng:-41.6534729, lat:-2.87097096},
    {lng:-41.65375137, lat:-2.87097096},
    {lng:-41.65375137, lat:-2.87152696},
    {lng:-41.65402603, lat:-2.87152696},
    {lng:-41.65402603, lat:-2.87180495},
    {lng:-41.6543045, lat:-2.87180495},
    {lng:-41.6543045, lat:-2.87208295},
    {lng:-41.65486145, lat:-2.87208295},
    {lng:-41.65486145, lat:-2.87236094},
    {lng:-41.6554184, lat:-2.87236094},
    {lng:-41.6554184, lat:-2.87263989},
    {lng:-41.65597153, lat:-2.87263989},
    {lng:-41.65597153, lat:-2.87291789},
    {lng:-41.65958405, lat:-2.87291789},
    {lng:-41.65958405, lat:-2.87263989},
    {lng:-41.66125107, lat:-2.87263989},
    {lng:-41.66125107, lat:-2.87236094},
    {lng:-41.66291809, lat:-2.87236094},
    {lng:-41.66291809, lat:-2.87208295},
    {lng:-41.66458511, lat:-2.87208295},
    {lng:-41.66458511, lat:-2.87180495},
    {lng:-41.66652679, lat:-2.87180495},
    {lng:-41.66652679, lat:-2.87152696},
    {lng:-41.66819382, lat:-2.87152696},
    {lng:-41.66819382, lat:-2.87124896},
    {lng:-41.66986084, lat:-2.87124896},
    {lng:-41.66986084, lat:-2.87097096},
    {lng:-41.67041779, lat:-2.87097096},
    {lng:-41.67041779, lat:-2.87124896},
    {lng:-41.67069626, lat:-2.87124896},
    {lng:-41.67069626, lat:-2.87180495},
    {lng:-41.67097092, lat:-2.87180495},
    {lng:-41.67097092, lat:-2.87236094},
    {lng:-41.67041779, lat:-2.87236094},
    {lng:-41.67041779, lat:-2.87263989},
    {lng:-41.67013931, lat:-2.87263989},
    {lng:-41.67013931, lat:-2.87291789},
    {lng:-41.66986084, lat:-2.87291789},
    {lng:-41.66986084, lat:-2.87319303},
    {lng:-41.66930389, lat:-2.87319303},
    {lng:-41.66930389, lat:-2.87347102},
    {lng:-41.66902924, lat:-2.87347102},
    {lng:-41.66902924, lat:-2.87374902},
    {lng:-41.66875076, lat:-2.87374902},
    {lng:-41.66875076, lat:-2.87402797},
    {lng:-41.66847229, lat:-2.87402797},
    {lng:-41.66847229, lat:-2.87430596},
    {lng:-41.66791534, lat:-2.87430596},
    {lng:-41.66791534, lat:-2.87458396},
    {lng:-41.66764069, lat:-2.87458396},
    {lng:-41.66764069, lat:-2.87486196},
    {lng:-41.66736221, lat:-2.87486196},
    {lng:-41.66736221, lat:-2.87513995},
    {lng:-41.66680527, lat:-2.87513995},
    {lng:-41.66680527, lat:-2.87541795},
    {lng:-41.66652679, lat:-2.87541795},
    {lng:-41.66652679, lat:-2.87569404},
    {lng:-41.66624832, lat:-2.87569404},
    {lng:-41.66624832, lat:-2.87597203},
    {lng:-41.66597366, lat:-2.87597203},
    {lng:-41.66597366, lat:-2.87625003},
    {lng:-41.66541672, lat:-2.87625003},
    {lng:-41.66541672, lat:-2.87652802},
    {lng:-41.66513824, lat:-2.87652802},
    {lng:-41.66513824, lat:-2.87680602},
    {lng:-41.66430664, lat:-2.87680602},
    {lng:-41.66430664, lat:-2.87708402},
    {lng:-41.66402817, lat:-2.87708402},
    {lng:-41.66402817, lat:-2.87680602},
    {lng:-41.66263962, lat:-2.87680602},
    {lng:-41.66263962, lat:-2.87708402},
    {lng:-41.66208267, lat:-2.87708402},
    {lng:-41.66208267, lat:-2.87680602},
    {lng:-41.6618042, lat:-2.87680602},
    {lng:-41.6618042, lat:-2.87708402},
    {lng:-41.66125107, lat:-2.87708402},
    {lng:-41.66125107, lat:-2.87736201},
    {lng:-41.66041565, lat:-2.87736201},
    {lng:-41.66041565, lat:-2.87764001},
    {lng:-41.66013718, lat:-2.8776381},
    {lng:-41.66013718, lat:-2.8779161},
    {lng:-41.65986252, lat:-2.8779161},
    {lng:-41.65986252, lat:-2.87847209},
    {lng:-41.65958405, lat:-2.87847209},
    {lng:-41.65958405, lat:-2.87902808},
    {lng:-41.65930557, lat:-2.87902808},
    {lng:-41.65930557, lat:-2.87986207},
    {lng:-41.6590271, lat:-2.87986207},
    {lng:-41.6590271, lat:-2.87958407},
    {lng:-41.65847397, lat:-2.87958407},
    {lng:-41.65847397, lat:-2.87986207},
    {lng:-41.6581955, lat:-2.87986207},
    {lng:-41.6581955, lat:-2.88013792},
    {lng:-41.65763855, lat:-2.88013792},
    {lng:-41.65763855, lat:-2.88041592},
    {lng:-41.65736008, lat:-2.88041592},
    {lng:-41.65736008, lat:-2.88013792},
    {lng:-41.6570816, lat:-2.88013792},
    {lng:-41.6570816, lat:-2.87986207},
    {lng:-41.65652847, lat:-2.87986207},
    {lng:-41.65652847, lat:-2.88013792},
    {lng:-41.65625, lat:-2.88013792},
    {lng:-41.65625, lat:-2.87986207},
    {lng:-41.65513992, lat:-2.87986207},
    {lng:-41.65513992, lat:-2.87958407},
    {lng:-41.65486145, lat:-2.87958407},
    {lng:-41.65486145, lat:-2.87930608},
    {lng:-41.6543045, lat:-2.87930608},
    {lng:-41.6543045, lat:-2.87875009},
    {lng:-41.65402603, lat:-2.87875009},
    {lng:-41.65402603, lat:-2.8776381},
    {lng:-41.6554184, lat:-2.8776381},
    {lng:-41.6554184, lat:-2.8779161},
    {lng:-41.65597153, lat:-2.8779161},
    {lng:-41.65597153, lat:-2.87819409},
    {lng:-41.65791702, lat:-2.87819409},
    {lng:-41.65791702, lat:-2.8779161},
    {lng:-41.6581955, lat:-2.8779161},
    {lng:-41.6581955, lat:-2.8776381},
    {lng:-41.65791702, lat:-2.87764001},
    {lng:-41.65791702, lat:-2.87736201},
    {lng:-41.65597153, lat:-2.87736201},
    {lng:-41.65597153, lat:-2.87708402},
    {lng:-41.6554184, lat:-2.87708402},
    {lng:-41.6554184, lat:-2.87680602},
    {lng:-41.65402603, lat:-2.87680602},
    {lng:-41.65402603, lat:-2.87652802},
    {lng:-41.65375137, lat:-2.87652802},
    {lng:-41.65375137, lat:-2.87625003},
    {lng:-41.6534729, lat:-2.87625003},
    {lng:-41.6534729, lat:-2.87597203},
    {lng:-41.65319443, lat:-2.87597203},
    {lng:-41.65319443, lat:-2.87569404},
    {lng:-41.65263748, lat:-2.87569404},
    {lng:-41.65263748, lat:-2.87541795},
    {lng:-41.65236282, lat:-2.87541795},
    {lng:-41.65236282, lat:-2.87458396},
    {lng:-41.65208435, lat:-2.87458396},
    {lng:-41.65208435, lat:-2.87430596},
    {lng:-41.65180588, lat:-2.87430596},
    {lng:-41.65180588, lat:-2.87402797},
    {lng:-41.6515274, lat:-2.87402797},
    {lng:-41.6515274, lat:-2.87319303},
    {lng:-41.65124893, lat:-2.87319303},
    {lng:-41.65124893, lat:-2.8730731},
    {lng:-41.65124893, lat:-2.87263989},
    {lng:-41.65097046, lat:-2.87263989},
    {lng:-41.65097046, lat:-2.87208295},
    {lng:-41.6506958, lat:-2.87208295},
    {lng:-41.6506958, lat:-2.87180495},
    {lng:-41.65041733, lat:-2.87180495},
    {lng:-41.65041733, lat:-2.87069511},
    {lng:-41.65013885, lat:-2.87069511},
    {lng:-41.65013885, lat:-2.8693049},
    {lng:-41.64986038, lat:-2.8693049},
    {lng:-41.64986038, lat:-2.86819506},
    {lng:-41.64958191, lat:-2.86819506},
    {lng:-41.64958191, lat:-2.86763906},
    {lng:-41.64930725, lat:-2.86763906},
    {lng:-41.64930725, lat:-2.86708307},
    {lng:-41.64902878, lat:-2.86708307},
    {lng:-41.64902878, lat:-2.865973},
    {lng:-41.64875031, lat:-2.865973},
    {lng:-41.64875031, lat:-2.865695},
    {lng:-41.64847183, lat:-2.865695},
    {lng:-41.64847183, lat:-2.86513901},
    {lng:-41.64819336, lat:-2.86513901},
    {lng:-41.64819336, lat:-2.86458302},
    {lng:-41.64791489, lat:-2.86458302},
    {lng:-41.64791489, lat:-2.86347294},
    {lng:-41.64764023, lat:-2.86347294},
    {lng:-41.64764023, lat:-2.86263895},
    {lng:-41.64736176, lat:-2.86263895},
    {lng:-41.64736176, lat:-2.86180401},
    {lng:-41.64708328, lat:-2.86180711},
    {lng:-41.64708328, lat:-2.86125112},
    {lng:-41.64680481, lat:-2.86125112},
    {lng:-41.64680481, lat:-2.86013794},
    {lng:-41.64652634, lat:-2.86013794},
    {lng:-41.64652634, lat:-2.85902905},
    {lng:-41.64625168, lat:-2.85902905},
    {lng:-41.64625168, lat:-2.85847211},
    {lng:-41.64597321, lat:-2.85847211},
    {lng:-41.64597321, lat:-2.85791612},
    {lng:-41.64569473, lat:-2.85791612},
    {lng:-41.64569473, lat:-2.85735989},
    {lng:-41.64541626, lat:-2.85735989},
    {lng:-41.64541626, lat:-2.85625005},
    {lng:-41.64625168, lat:-2.85625005},
    {lng:-41.64625168, lat:-2.85597205},
    {lng:-41.64680481, lat:-2.85597205},
    {lng:-41.64680481, lat:-2.85569406},
    {lng:-41.64764023, lat:-2.85569406},
    {lng:-41.64764023, lat:-2.85541606},
    {lng:-41.64791489, lat:-2.85541606},
    {lng:-41.64791489, lat:-2.85513806},
    {lng:-41.64847183, lat:-2.85513806},
    {lng:-41.64847183, lat:-2.85486007},
    {lng:-41.64875031, lat:-2.85486007},
    {lng:-41.64875031, lat:-2.85458398},
    {lng:-41.64902878, lat:-2.85458398},
    {lng:-41.64902878, lat:-2.85430598},
    {lng:-41.64930725, lat:-2.85430598},
    {lng:-41.64930725, lat:-2.85374999},
    {lng:-41.64902878, lat:-2.85374999},
    {lng:-41.64902878, lat:-2.85347199},
    {lng:-41.64847183, lat:-2.85347199},
    {lng:-41.64847183, lat:-2.85374999},
    {lng:-41.64791489, lat:-2.85374999},
    {lng:-41.64791489, lat:-2.85402799},
    {lng:-41.64736176, lat:-2.85402799},
    {lng:-41.64736176, lat:-2.85430598},
    {lng:-41.64708328, lat:-2.85430598},
    {lng:-41.64708328, lat:-2.85458398},
    {lng:-41.64652634, lat:-2.85458398},
    {lng:-41.64652634, lat:-2.85486007},
    {lng:-41.64625168, lat:-2.85486007},
    {lng:-41.64625168, lat:-2.85513806},
    {lng:-41.64569473, lat:-2.85513806},
    {lng:-41.64569473, lat:-2.85541606},
    {lng:-41.64485931, lat:-2.85541606},
    {lng:-41.64485931, lat:-2.85569406},
    {lng:-41.64458466, lat:-2.85569406},
    {lng:-41.64458466, lat:-2.85541606},
    {lng:-41.64430618, lat:-2.85541606},
    {lng:-41.64430618, lat:-2.85402799},
    {lng:-41.64402771, lat:-2.85402799},
    {lng:-41.64402771, lat:-2.853194},
    {lng:-41.64374924, lat:-2.853194},
    {lng:-41.64374924, lat:-2.85236192},
    {lng:-41.64347076, lat:-2.85236192},
    {lng:-41.64347076, lat:-2.85152793},
    {lng:-41.64319611, lat:-2.85152793},
    {lng:-41.64319611, lat:-2.85124993},
    {lng:-41.64291763, lat:-2.85124993},
    {lng:-41.64291763, lat:-2.85041595},
    {lng:-41.64319611, lat:-2.85041595},
    {lng:-41.64319611, lat:-2.85013795},
    {lng:-41.64374924, lat:-2.85014009},
    {lng:-41.64374924, lat:-2.8498621},
    {lng:-41.64402771, lat:-2.8498621},
    {lng:-41.64402771, lat:-2.8495841},
    {lng:-41.64430618, lat:-2.8495841},
    {lng:-41.64430618, lat:-2.84930611},
    {lng:-41.64485931, lat:-2.84930611},
    {lng:-41.64485931, lat:-2.84902811},
    {lng:-41.64541626, lat:-2.84902811},
    {lng:-41.64541626, lat:-2.84875011},
    {lng:-41.64597321, lat:-2.84875011},
    {lng:-41.64597321, lat:-2.84847212},
    {lng:-41.64652634, lat:-2.84847212},
    {lng:-41.64652634, lat:-2.84819388},
    {lng:-41.64680481, lat:-2.84819388},
    {lng:-41.64680481, lat:-2.84764004},
    {lng:-41.64708328, lat:-2.84764004},
    {lng:-41.64708328, lat:-2.84736204},
    {lng:-41.64680481, lat:-2.84736204},
    {lng:-41.64680481, lat:-2.84708405},
    {lng:-41.64652634, lat:-2.84708405},
    {lng:-41.64652634, lat:-2.84736204},
    {lng:-41.64597321, lat:-2.84736204},
    {lng:-41.64597321, lat:-2.84764004},
    {lng:-41.64541626, lat:-2.84764004},
    {lng:-41.64541626, lat:-2.84791803},
    {lng:-41.64485931, lat:-2.84791803},
    {lng:-41.64485931, lat:-2.84819388},
    {lng:-41.64430618, lat:-2.84819388},
    {lng:-41.64430618, lat:-2.84847212},
    {lng:-41.64402771, lat:-2.84847212},
    {lng:-41.64402771, lat:-2.84875011},
    {lng:-41.64347076, lat:-2.84875011},
    {lng:-41.64347076, lat:-2.84902811},
    {lng:-41.64291763, lat:-2.84902811},
    {lng:-41.64291763, lat:-2.84930611},
    {lng:-41.64263916, lat:-2.84930611},
    {lng:-41.64263916, lat:-2.8495841},
    {lng:-41.64236069, lat:-2.8495841},
    {lng:-41.64236069, lat:-2.8498621},
    {lng:-41.64208221, lat:-2.8498621},
    {lng:-41.64208221, lat:-2.85124993},
    {lng:-41.64236069, lat:-2.85124993},
    {lng:-41.64236069, lat:-2.85152793},
    {lng:-41.64263916, lat:-2.85152793},
    {lng:-41.64263916, lat:-2.85236192},
    {lng:-41.64291763, lat:-2.85236192},
    {lng:-41.64291763, lat:-2.85347199},
    {lng:-41.64319611, lat:-2.85347199},
    {lng:-41.64319611, lat:-2.85402799},
    {lng:-41.64347076, lat:-2.85402799},
    {lng:-41.64347076, lat:-2.85541606},
    {lng:-41.64374924, lat:-2.85541606},
    {lng:-41.64374924, lat:-2.85597205},
    {lng:-41.64402771, lat:-2.85597205},
    {lng:-41.64402771, lat:-2.85652804},
    {lng:-41.64430618, lat:-2.85652804},
    {lng:-41.64430618, lat:-2.85680604},
    {lng:-41.64458466, lat:-2.85680604},
    {lng:-41.64458466, lat:-2.85735989},
    {lng:-41.64485931, lat:-2.85735989},
    {lng:-41.64485931, lat:-2.85791612},
    {lng:-41.64513779, lat:-2.85791612},
    {lng:-41.64513779, lat:-2.85847211},
    {lng:-41.64541626, lat:-2.85847211},
    {lng:-41.64541626, lat:-2.85902905},
    {lng:-41.64569473, lat:-2.85902905},
    {lng:-41.64569473, lat:-2.86013794},
    {lng:-41.64597321, lat:-2.86013794},
    {lng:-41.64597321, lat:-2.86125112},
    {lng:-41.64625168, lat:-2.86125112},
    {lng:-41.64625168, lat:-2.86236095},
    {lng:-41.64652634, lat:-2.86236095},
    {lng:-41.64652634, lat:-2.86263895},
    {lng:-41.64680481, lat:-2.86263895},
    {lng:-41.64680481, lat:-2.86375093},
    {lng:-41.64708328, lat:-2.86375093},
    {lng:-41.64708328, lat:-2.86458302},
    {lng:-41.64736176, lat:-2.86458302},
    {lng:-41.64736176, lat:-2.86513901},
    {lng:-41.64764023, lat:-2.86513901},
    {lng:-41.64764023, lat:-2.865695},
    {lng:-41.64791489, lat:-2.865695},
    {lng:-41.64791489, lat:-2.86652708},
    {lng:-41.64819336, lat:-2.86652708},
    {lng:-41.64819336, lat:-2.86736107},
    {lng:-41.64847183, lat:-2.86736107},
    {lng:-41.64847183, lat:-2.86847305},
    {lng:-41.64819336, lat:-2.86847305},
    {lng:-41.64819336, lat:-2.86819506},
    {lng:-41.64791489, lat:-2.86819506},
    {lng:-41.64791489, lat:-2.86847305},
    {lng:-41.64764023, lat:-2.86847305},
    {lng:-41.64764023, lat:-2.8690269},
    {lng:-41.64736176, lat:-2.8690269},
    {lng:-41.64736176, lat:-2.8693049},
    {lng:-41.64708328, lat:-2.8693049},
    {lng:-41.64708328, lat:-2.86958289},
    {lng:-41.64680481, lat:-2.86958289},
    {lng:-41.64680481, lat:-2.87013888},
    {lng:-41.64652634, lat:-2.87013888},
    {lng:-41.64652634, lat:-2.87041712},
    {lng:-41.64625168, lat:-2.87041712},
    {lng:-41.64625168, lat:-2.87069511},
    {lng:-41.64597321, lat:-2.87069511},
    {lng:-41.64597321, lat:-2.87097096},
    {lng:-41.64569473, lat:-2.87097096},
    {lng:-41.64569473, lat:-2.87124896},
    {lng:-41.64541626, lat:-2.87124896},
    {lng:-41.64541626, lat:-2.87152696},
    {lng:-41.64513779, lat:-2.87152696},
    {lng:-41.64513779, lat:-2.87208295},
    {lng:-41.64541626, lat:-2.87208295},
    {lng:-41.64541626, lat:-2.87263989},
    {lng:-41.64513779, lat:-2.87263989},
    {lng:-41.64513779, lat:-2.87291789},
    {lng:-41.64485931, lat:-2.87291789},
    {lng:-41.64485931, lat:-2.87319303},
    {lng:-41.64458466, lat:-2.87319303},
    {lng:-41.64458466, lat:-2.87347102},
    {lng:-41.64430618, lat:-2.87347102},
    {lng:-41.64430618, lat:-2.87374902},
    {lng:-41.64402771, lat:-2.87374902},
    {lng:-41.64402771, lat:-2.87402797},
    {lng:-41.64374924, lat:-2.87402797},
    {lng:-41.64374924, lat:-2.87430596},
    {lng:-41.64347076, lat:-2.87430596},
    {lng:-41.64347076, lat:-2.87458396},
    {lng:-41.64319611, lat:-2.87458396},
    {lng:-41.64319611, lat:-2.87486196},
    {lng:-41.64291763, lat:-2.87486196},
    {lng:-41.64291763, lat:-2.87513995},
    {lng:-41.64263916, lat:-2.87513995},
    {lng:-41.64263916, lat:-2.87541795},
    {lng:-41.64208221, lat:-2.87541795},
    {lng:-41.64208221, lat:-2.87569404},
    {lng:-41.64180374, lat:-2.87569404},
    {lng:-41.64180374, lat:-2.87597203},
    {lng:-41.64152908, lat:-2.87597203},
    {lng:-41.64152908, lat:-2.87625003},
    {lng:-41.64125061, lat:-2.87625003},
    {lng:-41.64125061, lat:-2.87652802},
    {lng:-41.64097214, lat:-2.87652802},
    {lng:-41.64097214, lat:-2.87680602},
    {lng:-41.64069366, lat:-2.87680602},
    {lng:-41.64069366, lat:-2.87708402},
    {lng:-41.64041519, lat:-2.87708402},
    {lng:-41.64041519, lat:-2.87736201},
    {lng:-41.64014053, lat:-2.87736201},
    {lng:-41.64014053, lat:-2.87764001},
    {lng:-41.63986206, lat:-2.8776381},
    {lng:-41.63986206, lat:-2.8779161},
    {lng:-41.63958359, lat:-2.8779161},
    {lng:-41.63958359, lat:-2.87819409},
    {lng:-41.63930511, lat:-2.87819409},
    {lng:-41.63930511, lat:-2.87847209},
    {lng:-41.63902664, lat:-2.87847209},
    {lng:-41.63902664, lat:-2.87875009},
    {lng:-41.63847351, lat:-2.87875009},
    {lng:-41.63847351, lat:-2.87902808},
    {lng:-41.63819504, lat:-2.87902808},
    {lng:-41.63819504, lat:-2.87930608},
    {lng:-41.63791656, lat:-2.87930608},
    {lng:-41.63791656, lat:-2.87958407},
    {lng:-41.63763809, lat:-2.87958407},
    {lng:-41.63763809, lat:-2.87986207},
    {lng:-41.63708496, lat:-2.87986207},
    {lng:-41.63708496, lat:-2.88013792},
    {lng:-41.63680649, lat:-2.88013792},
    {lng:-41.63680649, lat:-2.88041592},
    {lng:-41.63652802, lat:-2.88041592},
    {lng:-41.63652802, lat:-2.88069391},
    {lng:-41.63624954, lat:-2.88069391},
    {lng:-41.63624954, lat:-2.88097191},
    {lng:-41.63597107, lat:-2.88097191},
    {lng:-41.63597107, lat:-2.8812499},
    {lng:-41.6356926, lat:-2.8812499},
    {lng:-41.6356926, lat:-2.8815279},
    {lng:-41.63541794, lat:-2.8815279},
    {lng:-41.63541794, lat:-2.8818059},
    {lng:-41.63513947, lat:-2.8818059},
    {lng:-41.63513947, lat:-2.88208389},
    {lng:-41.63486099, lat:-2.88208389},
    {lng:-41.63486099, lat:-2.88236189},
    {lng:-41.63430405, lat:-2.88236189},
    {lng:-41.63430405, lat:-2.88263798},
    {lng:-41.63402939, lat:-2.88263798},
    {lng:-41.63402939, lat:-2.88291597},
    {lng:-41.63375092, lat:-2.88291597},
    {lng:-41.63375092, lat:-2.88319397},
    {lng:-41.63347244, lat:-2.88319397},
    {lng:-41.63347244, lat:-2.88347197},
    {lng:-41.6329155, lat:-2.88347197},
    {lng:-41.6329155, lat:-2.88374996},
    {lng:-41.63208389, lat:-2.88374996},
    {lng:-41.63208389, lat:-2.88402796},
    {lng:-41.63152695, lat:-2.88402796},
    {lng:-41.63152695, lat:-2.88430595},
    {lng:-41.63097382, lat:-2.88430595},
    {lng:-41.63097382, lat:-2.88458204},
    {lng:-41.63069534, lat:-2.88458204},
    {lng:-41.63069534, lat:-2.88486004},
    {lng:-41.6301384, lat:-2.88486004},
    {lng:-41.6301384, lat:-2.88513803},
    {lng:-41.62958145, lat:-2.88513803},
    {lng:-41.62958145, lat:-2.88541603},
    {lng:-41.62874985, lat:-2.88541603},
    {lng:-41.62874985, lat:-2.88569403},
    {lng:-41.6281929, lat:-2.88569403},
    {lng:-41.6281929, lat:-2.88597202},
    {lng:-41.62791824, lat:-2.88597202},
    {lng:-41.62791824, lat:-2.88652897},
    {lng:-41.62763977, lat:-2.88652897},
    {lng:-41.62763977, lat:-2.8870821},
    {lng:-41.62708282, lat:-2.8870821},
    {lng:-41.62708282, lat:-2.8873601},
    {lng:-41.62652588, lat:-2.8873601},
    {lng:-41.62652588, lat:-2.88763905},
    {lng:-41.62569427, lat:-2.88763905},
    {lng:-41.62569427, lat:-2.88791704},
    {lng:-41.62513733, lat:-2.88791704},
    {lng:-41.62513733, lat:-2.88819504},
    {lng:-41.62486267, lat:-2.88819504},
    {lng:-41.62486267, lat:-2.88847303},
    {lng:-41.6245842, lat:-2.88847303},
    {lng:-41.6245842, lat:-2.88875103},
    {lng:-41.62430573, lat:-2.88875103},
    {lng:-41.62430573, lat:-2.88902903},
    {lng:-41.62402725, lat:-2.88902593},
    {lng:-41.62402725, lat:-2.88930511},
    {lng:-41.62374878, lat:-2.88930511},
    {lng:-41.62374878, lat:-2.88958311},
    {lng:-41.62319565, lat:-2.88958311},
    {lng:-41.62319565, lat:-2.88986111},
    {lng:-41.62291718, lat:-2.88986111},
    {lng:-41.62291718, lat:-2.8901391},
    {lng:-41.62236023, lat:-2.8901391},
    {lng:-41.62236023, lat:-2.8904171},
    {lng:-41.6218071, lat:-2.8904171},
    {lng:-41.6218071, lat:-2.8906951},
    {lng:-41.62125015, lat:-2.8906951},
    {lng:-41.62125015, lat:-2.89097309},
    {lng:-41.62069321, lat:-2.89097309},
    {lng:-41.62069321, lat:-2.89125109},
    {lng:-41.62014008, lat:-2.89124894},
    {lng:-41.62014008, lat:-2.89152694},
    {lng:-41.61930466, lat:-2.89152694},
    {lng:-41.61930466, lat:-2.89180493},
    {lng:-41.61847305, lat:-2.89180493},
    {lng:-41.61847305, lat:-2.89208293},
    {lng:-41.61791611, lat:-2.89208293},
    {lng:-41.61791611, lat:-2.89236093},
    {lng:-41.61763763, lat:-2.89236093},
    {lng:-41.61763763, lat:-2.89291692},
    {lng:-41.61736298, lat:-2.89291692},
    {lng:-41.61736298, lat:-2.89347291},
    {lng:-41.61680603, lat:-2.89347291},
    {lng:-41.61680603, lat:-2.893749},
    {lng:-41.61624908, lat:-2.893749},
    {lng:-41.61624908, lat:-2.89402699},
    {lng:-41.61569595, lat:-2.89402699},
    {lng:-41.61569595, lat:-2.89430499},
    {lng:-41.61513901, lat:-2.89430499},
    {lng:-41.61513901, lat:-2.89458299},
    {lng:-41.61458206, lat:-2.89458299},
    {lng:-41.61458206, lat:-2.89486098},
    {lng:-41.61402893, lat:-2.89486098},
    {lng:-41.61402893, lat:-2.89513898},
    {lng:-41.61347198, lat:-2.89513898},
    {lng:-41.61347198, lat:-2.89541698},
    {lng:-41.61291504, lat:-2.89541698},
    {lng:-41.61291504, lat:-2.89569497},
    {lng:-41.61236191, lat:-2.89569497},
    {lng:-41.61236191, lat:-2.89597297},
    {lng:-41.61180496, lat:-2.89597297},
    {lng:-41.61180496, lat:-2.89624906},
    {lng:-41.61125183, lat:-2.89624906},
    {lng:-41.61125183, lat:-2.89652705},
    {lng:-41.61069489, lat:-2.89652705},
    {lng:-41.61069489, lat:-2.89680505},
    {lng:-41.61013794, lat:-2.89680505},
    {lng:-41.61013794, lat:-2.89708304},
    {lng:-41.60958481, lat:-2.89708304},
    {lng:-41.60958481, lat:-2.89736104},
    {lng:-41.60902786, lat:-2.89736104},
    {lng:-41.60902786, lat:-2.89763904},
    {lng:-41.60847092, lat:-2.89763904},
    {lng:-41.60847092, lat:-2.89791703},
    {lng:-41.60791779, lat:-2.89791703},
    {lng:-41.60791779, lat:-2.89819503},
    {lng:-41.60708237, lat:-2.89819503},
    {lng:-41.60708237, lat:-2.89847112},
    {lng:-41.60625076, lat:-2.89847112},
    {lng:-41.60625076, lat:-2.89874911},
    {lng:-41.60541534, lat:-2.89874911},
    {lng:-41.60541534, lat:-2.89902711},
    {lng:-41.60458374, lat:-2.89902711},
    {lng:-41.60458374, lat:-2.89930511},
    {lng:-41.60347366, lat:-2.89930511},
    {lng:-41.60347366, lat:-2.8995831},
    {lng:-41.60263824, lat:-2.8995831},
    {lng:-41.60263824, lat:-2.89986205},
    {lng:-41.60180664, lat:-2.89986205},
    {lng:-41.60180664, lat:-2.90014005},
    {lng:-41.60097122, lat:-2.90014005},
    {lng:-41.60097122, lat:-2.89986205},
    {lng:-41.60041809, lat:-2.89986205},
    {lng:-41.60041809, lat:-2.90014005},
    {lng:-41.59986115, lat:-2.90014005},
    {lng:-41.59986115, lat:-2.90041804},
    {lng:-41.5993042, lat:-2.90041804},
    {lng:-41.5993042, lat:-2.90069294},
    {lng:-41.59875107, lat:-2.90069294},
    {lng:-41.59875107, lat:-2.90097094},
    {lng:-41.59819412, lat:-2.90097094},
    {lng:-41.59819412, lat:-2.90124989},
    {lng:-41.59791565, lat:-2.90124989},
    {lng:-41.59791565, lat:-2.90152788},
    {lng:-41.59736252, lat:-2.90152788},
    {lng:-41.59736252, lat:-2.90180612},
    {lng:-41.59680557, lat:-2.90180612},
    {lng:-41.59680557, lat:-2.90208411},
    {lng:-41.5965271, lat:-2.90208411},
    {lng:-41.5965271, lat:-2.90236211},
    {lng:-41.59597397, lat:-2.90236211},
    {lng:-41.59597397, lat:-2.9026401},
    {lng:-41.59541702, lat:-2.9026401},
    {lng:-41.59541702, lat:-2.90291595},
    {lng:-41.59486008, lat:-2.90291595},
    {lng:-41.59486008, lat:-2.90319395},
    {lng:-41.5945816, lat:-2.90319395},
    {lng:-41.5945816, lat:-2.90347195},
    {lng:-41.59402847, lat:-2.90347195},
    {lng:-41.59402847, lat:-2.90374994},
    {lng:-41.59347153, lat:-2.90374994},
    {lng:-41.59347153, lat:-2.90402794},
    {lng:-41.5929184, lat:-2.90402794},
    {lng:-41.5929184, lat:-2.90430593},
    {lng:-41.5918045, lat:-2.90430593},
    {lng:-41.5918045, lat:-2.90458393},
    {lng:-41.59069443, lat:-2.90458393},
    {lng:-41.59069443, lat:-2.90486193},
    {lng:-41.58958435, lat:-2.90486193},
    {lng:-41.58958435, lat:-2.90513992},
    {lng:-41.58847046, lat:-2.90513992},
    {lng:-41.58847046, lat:-2.90541601},
    {lng:-41.58736038, lat:-2.90541601},
    {lng:-41.58736038, lat:-2.90569401},
    {lng:-41.58625031, lat:-2.90569401},
    {lng:-41.58625031, lat:-2.905972},
    {lng:-41.58514023, lat:-2.905972},
    {lng:-41.58514023, lat:-2.90625},
    {lng:-41.58402634, lat:-2.90625},
    {lng:-41.58402634, lat:-2.906528},
    {lng:-41.58319473, lat:-2.906528},
    {lng:-41.58319473, lat:-2.90680599},
    {lng:-41.58235931, lat:-2.90680599},
    {lng:-41.58235931, lat:-2.90708399},
    {lng:-41.58208466, lat:-2.90708399},
    {lng:-41.58208466, lat:-2.90680599},
    {lng:-41.58097076, lat:-2.90680599},
    {lng:-41.58097076, lat:-2.906528},
    {lng:-41.57930374, lat:-2.906528},
    {lng:-41.57930374, lat:-2.90625},
    {lng:-41.57902908, lat:-2.90625},
    {lng:-41.57902908, lat:-2.905972},
    {lng:-41.57847214, lat:-2.905972},
    {lng:-41.57847214, lat:-2.90569401},
    {lng:-41.57819366, lat:-2.90569401},
    {lng:-41.57819366, lat:-2.90541601},
    {lng:-41.57791519, lat:-2.90541601},
    {lng:-41.57791519, lat:-2.90513992},
    {lng:-41.57736206, lat:-2.90513992},
    {lng:-41.57736206, lat:-2.90486193},
    {lng:-41.57708359, lat:-2.90486193},
    {lng:-41.57708359, lat:-2.90458393},
    {lng:-41.57680511, lat:-2.90458393},
    {lng:-41.57680511, lat:-2.90430593},
    {lng:-41.57624817, lat:-2.90430593},
    {lng:-41.57624817, lat:-2.90402794},
    {lng:-41.57597351, lat:-2.90402794},
    {lng:-41.57597351, lat:-2.90374994},
    {lng:-41.57569504, lat:-2.90374994},
    {lng:-41.57569504, lat:-2.90347195},
    {lng:-41.57513809, lat:-2.90347195},
    {lng:-41.57513809, lat:-2.90319395},
    {lng:-41.57485962, lat:-2.90319395},
    {lng:-41.57485962, lat:-2.90291595},
    {lng:-41.57458496, lat:-2.90291595},
    {lng:-41.57458496, lat:-2.9026401},
    {lng:-41.57402802, lat:-2.9026401},
    {lng:-41.57402802, lat:-2.90180612},
    {lng:-41.57374954, lat:-2.90180612},
    {lng:-41.57374954, lat:-2.90152788},
    {lng:-41.57291794, lat:-2.90152788},
    {lng:-41.57291794, lat:-2.90180612},
    {lng:-41.57180405, lat:-2.90180612},
    {lng:-41.57180405, lat:-2.90208411},
    {lng:-41.56708145, lat:-2.90208411},
    {lng:-41.56708145, lat:-2.90236211},
    {lng:-41.56652832, lat:-2.90236211},
    {lng:-41.56652832, lat:-2.9026401},
    {lng:-41.5656929, lat:-2.9026401},
    {lng:-41.5656929, lat:-2.90291595},
    {lng:-41.56513977, lat:-2.90291595},
    {lng:-41.56513977, lat:-2.9026401},
    {lng:-41.56458282, lat:-2.9026401},
    {lng:-41.56458282, lat:-2.90236211},
    {lng:-41.56402588, lat:-2.90236211},
    {lng:-41.56402588, lat:-2.90208411},
    {lng:-41.56347275, lat:-2.90208411},
    {lng:-41.56347275, lat:-2.90180612},
    {lng:-41.5629158, lat:-2.90180612},
    {lng:-41.5629158, lat:-2.90152788},
    {lng:-41.56236267, lat:-2.90152788},
    {lng:-41.56236267, lat:-2.90124989},
    {lng:-41.56180573, lat:-2.90124989},
    {lng:-41.56180573, lat:-2.90097094},
    {lng:-41.56152725, lat:-2.90097094},
    {lng:-41.56152725, lat:-2.90069294},
    {lng:-41.56124878, lat:-2.90069294},
    {lng:-41.56124878, lat:-2.90041804},
    {lng:-41.56097412, lat:-2.90041804},
    {lng:-41.56097412, lat:-2.90014005},
    {lng:-41.56069565, lat:-2.90014005},
    {lng:-41.56069565, lat:-2.8995831},
    {lng:-41.56041718, lat:-2.8995831},
    {lng:-41.56041718, lat:-2.89930511},
    {lng:-41.5601387, lat:-2.89930511},
    {lng:-41.5601387, lat:-2.89902711},
    {lng:-41.55986023, lat:-2.89902711},
    {lng:-41.55986023, lat:-2.89874911},
    {lng:-41.55958176, lat:-2.89874911},
    {lng:-41.55958176, lat:-2.89847112},
    {lng:-41.5593071, lat:-2.89847112},
    {lng:-41.5593071, lat:-2.89819503},
    {lng:-41.55902863, lat:-2.89819503},
    {lng:-41.55902863, lat:-2.89763904},
    {lng:-41.55875015, lat:-2.89763904},
    {lng:-41.55875015, lat:-2.89736104},
    {lng:-41.55847168, lat:-2.89736104},
    {lng:-41.55847168, lat:-2.89708304},
    {lng:-41.55708313, lat:-2.89708304},
    {lng:-41.55708313, lat:-2.89736104},
    {lng:-41.55652618, lat:-2.89736104},
    {lng:-41.55652618, lat:-2.89763904},
    {lng:-41.55597305, lat:-2.89763904},
    {lng:-41.55597305, lat:-2.89791703},
    {lng:-41.55541611, lat:-2.89791703},
    {lng:-41.55541611, lat:-2.89819503},
    {lng:-41.55486298, lat:-2.89819503},
    {lng:-41.55486298, lat:-2.89847112},
    {lng:-41.5545845, lat:-2.89847112},
    {lng:-41.5545845, lat:-2.89874911},
    {lng:-41.55402756, lat:-2.89874911},
    {lng:-41.55402756, lat:-2.89902711},
    {lng:-41.55347061, lat:-2.89902711},
    {lng:-41.55347061, lat:-2.89930511},
    {lng:-41.55291748, lat:-2.89930511},
    {lng:-41.55291748, lat:-2.8995831},
    {lng:-41.55236053, lat:-2.8995831},
    {lng:-41.55236053, lat:-2.89986205},
    {lng:-41.5518074, lat:-2.89986205},
    {lng:-41.5518074, lat:-2.90014005},
    {lng:-41.55125046, lat:-2.90014005},
    {lng:-41.55125046, lat:-2.90041804},
    {lng:-41.55041504, lat:-2.90041804},
    {lng:-41.55041504, lat:-2.90069294},
    {lng:-41.54958344, lat:-2.90069294},
    {lng:-41.54958344, lat:-2.90097094},
    {lng:-41.54902649, lat:-2.90097094},
    {lng:-41.54902649, lat:-2.90124989},
    {lng:-41.54819489, lat:-2.90124989},
    {lng:-41.54819489, lat:-2.90152788},
    {lng:-41.54763794, lat:-2.90152788},
    {lng:-41.54763794, lat:-2.90180612},
    {lng:-41.54680634, lat:-2.90180612},
    {lng:-41.54680634, lat:-2.90208411},
    {lng:-41.54597092, lat:-2.90208411},
    {lng:-41.54597092, lat:-2.90236211},
    {lng:-41.54541779, lat:-2.90236211},
    {lng:-41.54541779, lat:-2.9026401},
    {lng:-41.54486084, lat:-2.9026401},
    {lng:-41.54486084, lat:-2.90291595},
    {lng:-41.54430389, lat:-2.90291595},
    {lng:-41.54430389, lat:-2.90319395},
    {lng:-41.54375076, lat:-2.90319395},
    {lng:-41.54375076, lat:-2.90347195},
    {lng:-41.54347229, lat:-2.90347195},
    {lng:-41.54347229, lat:-2.90374994},
    {lng:-41.54291534, lat:-2.90374994},
    {lng:-41.54291534, lat:-2.90402794},
    {lng:-41.54236221, lat:-2.90402794},
    {lng:-41.54236221, lat:-2.90430593},
    {lng:-41.54208374, lat:-2.90430593},
    {lng:-41.54208374, lat:-2.90458393},
    {lng:-41.54152679, lat:-2.90458393},
    {lng:-41.54152679, lat:-2.90486193},
    {lng:-41.54097366, lat:-2.90486193},
    {lng:-41.54097366, lat:-2.90513992},
    {lng:-41.54069519, lat:-2.90513992},
    {lng:-41.54069519, lat:-2.90541601},
    {lng:-41.54013824, lat:-2.90541601},
    {lng:-41.54013824, lat:-2.90569401},
    {lng:-41.53958511, lat:-2.90569401},
    {lng:-41.53958511, lat:-2.905972},
    {lng:-41.53902817, lat:-2.905972},
    {lng:-41.53902817, lat:-2.90625},
    {lng:-41.53874969, lat:-2.90625},
    {lng:-41.53874969, lat:-2.906528},
    {lng:-41.53819275, lat:-2.906528},
    {lng:-41.53819275, lat:-2.90680599},
    {lng:-41.53763962, lat:-2.90680599},
    {lng:-41.53763962, lat:-2.90708399},
    {lng:-41.53736115, lat:-2.90708399},
    {lng:-41.53736115, lat:-2.90736198},
    {lng:-41.5368042, lat:-2.90736198},
    {lng:-41.5368042, lat:-2.90763807},
    {lng:-41.53625107, lat:-2.90763807},
    {lng:-41.53625107, lat:-2.90791607},
    {lng:-41.53569412, lat:-2.90791607},
    {lng:-41.53569412, lat:-2.90819407},
    {lng:-41.53458405, lat:-2.90819407},
    {lng:-41.53458405, lat:-2.90847206},
    {lng:-41.53374863, lat:-2.90847206},
    {lng:-41.53374863, lat:-2.90875006},
    {lng:-41.5331955, lat:-2.90875006},
    {lng:-41.5331955, lat:-2.90902805},
    {lng:-41.53263855, lat:-2.90902805},
    {lng:-41.53263855, lat:-2.90930605},
    {lng:-41.5320816, lat:-2.90930605},
    {lng:-41.5320816, lat:-2.90958405},
    {lng:-41.53152847, lat:-2.90958405},
    {lng:-41.53152847, lat:-2.9098599},
    {lng:-41.53097153, lat:-2.9098599},
    {lng:-41.53097153, lat:-2.91013789},
    {lng:-41.52986145, lat:-2.91013789},
    {lng:-41.52986145, lat:-2.9098599},
    {lng:-41.52875137, lat:-2.9098599},
    {lng:-41.52875137, lat:-2.90958405},
    {lng:-41.52264023, lat:-2.90958405},
    {lng:-41.52264023, lat:-2.9098599},
    {lng:-41.52069473, lat:-2.9098599},
    {lng:-41.52069473, lat:-2.91013789},
    {lng:-41.51958466, lat:-2.91013789},
    {lng:-41.51958466, lat:-2.91041589},
    {lng:-41.51874924, lat:-2.91041589},
    {lng:-41.51874924, lat:-2.91069388},
    {lng:-41.51763916, lat:-2.91069388},
    {lng:-41.51763916, lat:-2.91097212},
    {lng:-41.51680374, lat:-2.91097212},
    {lng:-41.51680374, lat:-2.91069388},
    {lng:-41.51541519, lat:-2.91069388},
    {lng:-41.51541519, lat:-2.91097212},
    {lng:-41.51374817, lat:-2.91097212},
    {lng:-41.51374817, lat:-2.91125011},
    {lng:-41.51208496, lat:-2.91125011},
    {lng:-41.51208496, lat:-2.91152811},
    {lng:-41.51041794, lat:-2.91152811},
    {lng:-41.51041794, lat:-2.91180611},
    {lng:-41.50958252, lat:-2.91180611},
    {lng:-41.50958252, lat:-2.91152811},
    {lng:-41.50902939, lat:-2.91152811},
    {lng:-41.50902939, lat:-2.91125011},
    {lng:-41.50847244, lat:-2.91125011},
    {lng:-41.50847244, lat:-2.91097212},
    {lng:-41.5079155, lat:-2.91097212},
    {lng:-41.5079155, lat:-2.91069388},
    {lng:-41.50763702, lat:-2.91069388},
    {lng:-41.50763702, lat:-2.91041589},
    {lng:-41.50708389, lat:-2.91041589},
    {lng:-41.50708389, lat:-2.91013789},
    {lng:-41.50652695, lat:-2.91013789},
    {lng:-41.50652695, lat:-2.9098599},
    {lng:-41.50597382, lat:-2.9098599},
    {lng:-41.50597382, lat:-2.90958405},
    {lng:-41.50569534, lat:-2.90958405},
    {lng:-41.50569534, lat:-2.90930605},
    {lng:-41.5051384, lat:-2.90930605},
    {lng:-41.5051384, lat:-2.90902805},
    {lng:-41.50485992, lat:-2.90902805},
    {lng:-41.50485992, lat:-2.90875006},
    {lng:-41.50430679, lat:-2.90875006},
    {lng:-41.50430679, lat:-2.90847206},
    {lng:-41.50402832, lat:-2.90847206},
    {lng:-41.50402832, lat:-2.90819407},
    {lng:-41.50347137, lat:-2.90819407},
    {lng:-41.50347137, lat:-2.90791607},
    {lng:-41.5031929, lat:-2.90791607},
    {lng:-41.5031929, lat:-2.90763807},
    {lng:-41.50263977, lat:-2.90763807},
    {lng:-41.50263977, lat:-2.90736198},
    {lng:-41.5023613, lat:-2.90736198},
    {lng:-41.5023613, lat:-2.90708399},
    {lng:-41.50180435, lat:-2.90708399},
    {lng:-41.50180435, lat:-2.90680599},
    {lng:-41.50152588, lat:-2.90680599},
    {lng:-41.50152588, lat:-2.906528},
    {lng:-41.50097275, lat:-2.906528},
    {lng:-41.50097275, lat:-2.90680599},
    {lng:-41.5004158, lat:-2.90680599},
    {lng:-41.5004158, lat:-2.906528},
    {lng:-41.49986267, lat:-2.906528},
    {lng:-41.49986267, lat:-2.90625},
    {lng:-41.49930573, lat:-2.90625},
    {lng:-41.49930573, lat:-2.905972},
    {lng:-41.4995842, lat:-2.905972},
    {lng:-41.4995842, lat:-2.90569401},
    {lng:-41.49930573, lat:-2.90569401},
    {lng:-41.49930573, lat:-2.90541601},
    {lng:-41.49902725, lat:-2.90541601},
    {lng:-41.49902725, lat:-2.90513992},
    {lng:-41.49847412, lat:-2.90513992},
    {lng:-41.49847412, lat:-2.90486193},
    {lng:-41.49819565, lat:-2.90486193},
    {lng:-41.49819565, lat:-2.90458393},
    {lng:-41.49791718, lat:-2.90458393},
    {lng:-41.49791718, lat:-2.90430593},
    {lng:-41.4976387, lat:-2.90430593},
    {lng:-41.4976387, lat:-2.90402794},
    {lng:-41.49736023, lat:-2.90402794},
    {lng:-41.49736023, lat:-2.90374994},
    {lng:-41.4968071, lat:-2.90374994},
    {lng:-41.4968071, lat:-2.90347195},
    {lng:-41.49652863, lat:-2.90347195},
    {lng:-41.49652863, lat:-2.90319395},
    {lng:-41.49625015, lat:-2.90319395},
    {lng:-41.49625015, lat:-2.90291595},
    {lng:-41.49569321, lat:-2.90291595},
    {lng:-41.49569321, lat:-2.9026401},
    {lng:-41.49541855, lat:-2.9026401},
    {lng:-41.49541855, lat:-2.90180612},
    {lng:-41.49514008, lat:-2.90180612},
    {lng:-41.49514008, lat:-2.90150905},
    {lng:-41.49514008, lat:-2.90069294},
    {lng:-41.4948616, lat:-2.90069294},
    {lng:-41.4948616, lat:-2.90041804},
    {lng:-41.49458313, lat:-2.90041804},
    {lng:-41.49458313, lat:-2.90014005},
    {lng:-41.49430466, lat:-2.90014005},
    {lng:-41.49430466, lat:-2.89986205},
    {lng:-41.49180603, lat:-2.89986205},
    {lng:-41.49180603, lat:-2.8995831},
    {lng:-41.4895134, lat:-2.8995831},
    {lng:-41.4893074, lat:-2.8995831},
    {lng:-41.4893074, lat:-2.89930511},
    {lng:-41.48875046, lat:-2.89930511},
    {lng:-41.48875046, lat:-2.89902711},
    {lng:-41.48847198, lat:-2.89902711},
    {lng:-41.48847198, lat:-2.89874911},
    {lng:-41.48791504, lat:-2.89874911},
    {lng:-41.48791504, lat:-2.89847112},
    {lng:-41.48626709, lat:-2.89847112},
    {lng:-41.48485947, lat:-2.89847112},
    {lng:-41.48485947, lat:-2.89819503},
    {lng:-41.48208237, lat:-2.89819503},
    {lng:-41.48208237, lat:-2.89791703},
    {lng:-41.48180389, lat:-2.89791703},
    {lng:-41.48180389, lat:-2.89763904},
    {lng:-41.48152924, lat:-2.89763904},
    {lng:-41.48152924, lat:-2.89736104},
    {lng:-41.48125076, lat:-2.89736104},
    {lng:-41.48125076, lat:-2.89708304},
    {lng:-41.48069382, lat:-2.89708304},
    {lng:-41.48069382, lat:-2.89680505},
    {lng:-41.48041534, lat:-2.89680505},
    {lng:-41.48041534, lat:-2.89652705},
    {lng:-41.48014069, lat:-2.89652705},
    {lng:-41.48014069, lat:-2.89637399},
    {lng:-41.48014069, lat:-2.89624906},
    {lng:-41.47986221, lat:-2.89624906},
    {lng:-41.47986221, lat:-2.89597297},
    {lng:-41.47958374, lat:-2.89597297},
    {lng:-41.47958374, lat:-2.89624906},
    {lng:-41.47930527, lat:-2.89625096},
    {lng:-41.47930527, lat:-2.89652705},
    {lng:-41.47874832, lat:-2.89652705},
    {lng:-41.47874832, lat:-2.89680505},
    {lng:-41.47819519, lat:-2.89680505},
    {lng:-41.47819519, lat:-2.89708304},
    {lng:-41.47763824, lat:-2.89708304},
    {lng:-41.47763824, lat:-2.89736104},
    {lng:-41.47708511, lat:-2.89736104},
    {lng:-41.47708511, lat:-2.89763904},
    {lng:-41.47652817, lat:-2.89763904},
    {lng:-41.47652817, lat:-2.89791703},
    {lng:-41.47597122, lat:-2.89791703},
    {lng:-41.47597122, lat:-2.89819503},
    {lng:-41.47541809, lat:-2.89819503},
    {lng:-41.47541809, lat:-2.89791703},
    {lng:-41.47513962, lat:-2.89791703},
    {lng:-41.47513962, lat:-2.89819503},
    {lng:-41.47458267, lat:-2.89819503},
    {lng:-41.47458267, lat:-2.89847112},
    {lng:-41.4743042, lat:-2.89847112},
    {lng:-41.4743042, lat:-2.89874911},
    {lng:-41.47402954, lat:-2.89874911},
    {lng:-41.47402954, lat:-2.89902711},
    {lng:-41.47375107, lat:-2.89902711},
    {lng:-41.47375107, lat:-2.89930511},
    {lng:-41.47291565, lat:-2.89930511},
    {lng:-41.47291565, lat:-2.8995831},
    {lng:-41.47180557, lat:-2.8995831},
    {lng:-41.47180557, lat:-2.89986205},
    {lng:-41.47013855, lat:-2.89986205},
    {lng:-41.47013855, lat:-2.90014005},
    {lng:-41.46736145, lat:-2.90014005},
    {lng:-41.46736145, lat:-2.90041804},
    {lng:-41.46486282, lat:-2.90041804},
    {lng:-41.46486282, lat:-2.90069294},
    {lng:-41.46291733, lat:-2.90069294},
    {lng:-41.46291733, lat:-2.90097094},
    {lng:-41.46152878, lat:-2.90097094},
    {lng:-41.46152878, lat:-2.90124989},
    {lng:-41.46014023, lat:-2.90124989},
    {lng:-41.46014023, lat:-2.90152788},
    {lng:-41.45902634, lat:-2.90152788},
    {lng:-41.45902634, lat:-2.90180612},
    {lng:-41.45763779, lat:-2.90180612},
    {lng:-41.45763779, lat:-2.90208411},
    {lng:-41.45624924, lat:-2.90208411},
    {lng:-41.45624924, lat:-2.90236211},
    {lng:-41.45513916, lat:-2.90236211},
    {lng:-41.45513916, lat:-2.9026401},
    {lng:-41.45458221, lat:-2.9026401},
    {lng:-41.45458221, lat:-2.90291595},
    {lng:-41.45375061, lat:-2.90291595},
    {lng:-41.45375061, lat:-2.90319395},
    {lng:-41.45291519, lat:-2.90319395},
    {lng:-41.45291519, lat:-2.90347195},
    {lng:-41.45236206, lat:-2.90347195},
    {lng:-41.45236206, lat:-2.90374994},
    {lng:-41.45152664, lat:-2.90374994},
    {lng:-41.45152664, lat:-2.90402794},
    {lng:-41.45069504, lat:-2.90402794},
    {lng:-41.45069504, lat:-2.90430593},
    {lng:-41.45013809, lat:-2.90430593},
    {lng:-41.45013809, lat:-2.90458393},
    {lng:-41.44930649, lat:-2.90458393},
    {lng:-41.44930649, lat:-2.90486193},
    {lng:-41.44847107, lat:-2.90486193},
    {lng:-41.44847107, lat:-2.90513992},
    {lng:-41.44791794, lat:-2.90513992},
    {lng:-41.44791794, lat:-2.90541601},
    {lng:-41.44763947, lat:-2.90541601},
    {lng:-41.44763947, lat:-2.90513992},
    {lng:-41.44701385, lat:-2.90513992},
    {lng:-41.44680405, lat:-2.90513992},
    {lng:-41.44680405, lat:-2.90541601},
    {lng:-41.44458389, lat:-2.90541601},
    {lng:-41.44458389, lat:-2.90569401},
    {lng:-41.44235992, lat:-2.90569401},
    {lng:-41.44235992, lat:-2.905972},
    {lng:-41.44041824, lat:-2.905972},
    {lng:-41.44041824, lat:-2.90625},
    {lng:-41.43847275, lat:-2.90625},
    {lng:-41.43847275, lat:-2.906528},
    {lng:-41.43736267, lat:-2.906528},
    {lng:-41.43736267, lat:-2.90680599},
    {lng:-41.4370842, lat:-2.90680599},
    {lng:-41.4370842, lat:-2.906528},
    {lng:-41.43680573, lat:-2.906528},
    {lng:-41.43680573, lat:-2.90625},
    {lng:-41.43569565, lat:-2.90625},
    {lng:-41.43569565, lat:-2.905972},
    {lng:-41.4343071, lat:-2.905972},
    {lng:-41.4343071, lat:-2.90625},
    {lng:-41.43389893, lat:-2.90625},
    {lng:-41.43208313, lat:-2.90625},
    {lng:-41.43208313, lat:-2.906528},
    {lng:-41.43069458, lat:-2.906528},
    {lng:-41.43069458, lat:-2.90680599},
    {lng:-41.42986298, lat:-2.90680599},
    {lng:-41.42986298, lat:-2.90708399},
    {lng:-41.42874908, lat:-2.90708399},
    {lng:-41.42874908, lat:-2.90736198},
    {lng:-41.42791748, lat:-2.90736198},
    {lng:-41.42791748, lat:-2.90763807},
    {lng:-41.42708206, lat:-2.90763807},
    {lng:-41.42708206, lat:-2.90791607},
    {lng:-41.42597198, lat:-2.90791607},
    {lng:-41.42597198, lat:-2.90819407},
    {lng:-41.42514038, lat:-2.90819407},
    {lng:-41.42514038, lat:-2.90847206},
    {lng:-41.42430496, lat:-2.90847206},
    {lng:-41.42430496, lat:-2.90875006},
    {lng:-41.42319489, lat:-2.90875006},
    {lng:-41.42319489, lat:-2.90902805},
    {lng:-41.42235947, lat:-2.90902805},
    {lng:-41.42235947, lat:-2.90930605},
    {lng:-41.41920853, lat:-2.90930605},
    {lng:-41.41708374, lat:-2.90930605},
    {lng:-41.41708374, lat:-2.90902805},
    {lng:-41.41541672, lat:-2.90902805},
    {lng:-41.41541672, lat:-2.90875006},
    {lng:-41.41347122, lat:-2.90875006},
    {lng:-41.41347122, lat:-2.90847206},
    {lng:-41.41208267, lat:-2.90847206},
    {lng:-41.41208267, lat:-2.90819407},
    {lng:-41.41152954, lat:-2.90819407},
    {lng:-41.41152954, lat:-2.90791607},
    {lng:-41.4109726, lat:-2.90791607},
    {lng:-41.4109726, lat:-2.90763807},
    {lng:-41.41013718, lat:-2.90763807},
    {lng:-41.41013718, lat:-2.90736198},
    {lng:-41.40958405, lat:-2.90736198},
    {lng:-41.40958405, lat:-2.90708399},
    {lng:-41.40874863, lat:-2.90708399},
    {lng:-41.40874863, lat:-2.90680599},
    {lng:-41.4081955, lat:-2.90680599},
    {lng:-41.4081955, lat:-2.906528},
    {lng:-41.40763855, lat:-2.906528},
    {lng:-41.40763855, lat:-2.90625},
    {lng:-41.40597153, lat:-2.90625},
    {lng:-41.40597153, lat:-2.906528},
    {lng:-41.40458298, lat:-2.906528},
    {lng:-41.40458298, lat:-2.90625},
    {lng:-41.40402603, lat:-2.90625},
    {lng:-41.40402603, lat:-2.905972},
    {lng:-41.40375137, lat:-2.905972},
    {lng:-41.40375137, lat:-2.90569401},
    {lng:-41.40319443, lat:-2.90569401},
    {lng:-41.40319443, lat:-2.90558004},
    {lng:-41.40319443, lat:-2.90541601},
    {lng:-41.40208435, lat:-2.90541601},
    {lng:-41.40208435, lat:-2.90513992},
    {lng:-41.40097046, lat:-2.90513992},
    {lng:-41.40097046, lat:-2.90486193},
    {lng:-41.4006958, lat:-2.90486193},
    {lng:-41.4006958, lat:-2.90458393},
    {lng:-41.40041733, lat:-2.90458393},
    {lng:-41.40041733, lat:-2.90430593},
    {lng:-41.39819336, lat:-2.90430593},
    {lng:-41.39819336, lat:-2.90458393},
    {lng:-41.39708328, lat:-2.90458393},
    {lng:-41.39708328, lat:-2.90486193},
    {lng:-41.39569473, lat:-2.90486193},
    {lng:-41.39569473, lat:-2.90513992},
    {lng:-41.39513779, lat:-2.90513992},
    {lng:-41.39513779, lat:-2.90541601},
    {lng:-41.39458466, lat:-2.90541601},
    {lng:-41.39458466, lat:-2.90569401},
    {lng:-41.39402771, lat:-2.90569401},
    {lng:-41.39402771, lat:-2.905972},
    {lng:-41.39347076, lat:-2.905972},
    {lng:-41.39347076, lat:-2.90625},
    {lng:-41.39319611, lat:-2.90625},
    {lng:-41.39319611, lat:-2.906528},
    {lng:-41.39263916, lat:-2.906528},
    {lng:-41.39263916, lat:-2.90680599},
    {lng:-41.39236069, lat:-2.90680599},
    {lng:-41.39236069, lat:-2.90708399},
    {lng:-41.39180374, lat:-2.90708399},
    {lng:-41.39180374, lat:-2.90736198},
    {lng:-41.39125061, lat:-2.90736198},
    {lng:-41.39125061, lat:-2.90763807},
    {lng:-41.39097214, lat:-2.90763807},
    {lng:-41.39097214, lat:-2.90791607},
    {lng:-41.39041519, lat:-2.90791607},
    {lng:-41.39041519, lat:-2.90819407},
    {lng:-41.38986206, lat:-2.90819407},
    {lng:-41.38986206, lat:-2.90847206},
    {lng:-41.38958359, lat:-2.90847206},
    {lng:-41.38958359, lat:-2.90875006},
    {lng:-41.38902664, lat:-2.90875006},
    {lng:-41.38902664, lat:-2.90902805},
    {lng:-41.38874817, lat:-2.90902805},
    {lng:-41.38874817, lat:-2.90930605},
    {lng:-41.38819504, lat:-2.90930605},
    {lng:-41.38819504, lat:-2.90958405},
    {lng:-41.38763809, lat:-2.90958405},
    {lng:-41.38763809, lat:-2.9098599},
    {lng:-41.38735962, lat:-2.9098599},
    {lng:-41.38735962, lat:-2.91013789},
    {lng:-41.38680649, lat:-2.91013789},
    {lng:-41.38680649, lat:-2.91041589},
    {lng:-41.38652802, lat:-2.91041589},
    {lng:-41.38652802, lat:-2.91069388},
    {lng:-41.38597107, lat:-2.91069388},
    {lng:-41.38597107, lat:-2.91097212},
    {lng:-41.38541794, lat:-2.91097212},
    {lng:-41.38541794, lat:-2.91125011},
    {lng:-41.38513947, lat:-2.91125011},
    {lng:-41.38513947, lat:-2.91152811},
    {lng:-41.38458252, lat:-2.91152811},
    {lng:-41.38458252, lat:-2.91180611},
    {lng:-41.38402939, lat:-2.91180611},
    {lng:-41.38402939, lat:-2.91208506},
    {lng:-41.38375092, lat:-2.91208506},
    {lng:-41.38375092, lat:-2.91235995},
    {lng:-41.38319397, lat:-2.91235995},
    {lng:-41.38319397, lat:-2.91263795},
    {lng:-41.3829155, lat:-2.91263795},
    {lng:-41.3829155, lat:-2.91291595},
    {lng:-41.38236237, lat:-2.91291595},
    {lng:-41.38236237, lat:-2.91319394},
    {lng:-41.38180542, lat:-2.91319394},
    {lng:-41.38180542, lat:-2.91347289},
    {lng:-41.38152695, lat:-2.91347289},
    {lng:-41.38152695, lat:-2.91375089},
    {lng:-41.38097382, lat:-2.91375089},
    {lng:-41.38097382, lat:-2.91402888},
    {lng:-41.38069534, lat:-2.91402888},
    {lng:-41.38069534, lat:-2.91430402},
    {lng:-41.3801384, lat:-2.91430402},
    {lng:-41.3801384, lat:-2.91458201},
    {lng:-41.37958145, lat:-2.91458201},
    {lng:-41.37958145, lat:-2.91486001},
    {lng:-41.37902832, lat:-2.91486001},
    {lng:-41.37902832, lat:-2.91513896},
    {lng:-41.37847137, lat:-2.91513896},
    {lng:-41.37847137, lat:-2.91541696},
    {lng:-41.37791824, lat:-2.91541696},
    {lng:-41.37791824, lat:-2.91569495},
    {lng:-41.3773613, lat:-2.91569495},
    {lng:-41.3773613, lat:-2.91597295},
    {lng:-41.37680435, lat:-2.91597295},
    {lng:-41.37680435, lat:-2.91625094},
    {lng:-41.37669754, lat:-2.91625094},
    {lng:-41.37625122, lat:-2.91625094},
    {lng:-41.37625122, lat:-2.91652894},
    {lng:-41.37601089, lat:-2.91652894},
    {lng:-41.37569427, lat:-2.91652894},
    {lng:-41.37569427, lat:-2.91665411},
    {lng:-41.37569427, lat:-2.91680503},
    {lng:-41.37532043, lat:-2.91680503},
    {lng:-41.37513733, lat:-2.91680503},
    {lng:-41.37513733, lat:-2.91708302},
    {lng:-41.3745842, lat:-2.91708302},
    {lng:-41.3745842, lat:-2.91736102},
    {lng:-41.37402725, lat:-2.91736102},
    {lng:-41.37402725, lat:-2.91763902},
    {lng:-41.37325287, lat:-2.91763902},
    {lng:-41.37291718, lat:-2.91763902},
    {lng:-41.37291718, lat:-2.91777301},
    {lng:-41.37291718, lat:-2.91791701},
    {lng:-41.37256241, lat:-2.91791701},
    {lng:-41.37208176, lat:-2.91791701},
    {lng:-41.37208176, lat:-2.91819501},
    {lng:-41.37187195, lat:-2.91819501},
    {lng:-41.37097168, lat:-2.91819501},
    {lng:-41.37097168, lat:-2.91847301},
    {lng:-41.37014008, lat:-2.91847301},
    {lng:-41.37014008, lat:-2.91819501},
    {lng:-41.36958313, lat:-2.91819501},
    {lng:-41.36958313, lat:-2.91791701},
    {lng:-41.36902618, lat:-2.91791701},
    {lng:-41.36902618, lat:-2.91763902},
    {lng:-41.36875153, lat:-2.91763902},
    {lng:-41.36875153, lat:-2.91708302},
    {lng:-41.36847305, lat:-2.91708302},
    {lng:-41.36847305, lat:-2.91680503},
    {lng:-41.36819458, lat:-2.91680503},
    {lng:-41.36819458, lat:-2.91652894},
    {lng:-41.36791611, lat:-2.91652894},
    {lng:-41.36791611, lat:-2.91625094},
    {lng:-41.36763763, lat:-2.91625094},
    {lng:-41.36763763, lat:-2.91597295},
    {lng:-41.36680603, lat:-2.91597295},
    {lng:-41.36680603, lat:-2.91569495},
    {lng:-41.36652756, lat:-2.91569495},
    {lng:-41.36652756, lat:-2.91541696},
    {lng:-41.36458206, lat:-2.91541696},
    {lng:-41.36458206, lat:-2.91569495},
    {lng:-41.3643074, lat:-2.91569495},
    {lng:-41.3643074, lat:-2.91625094},
    {lng:-41.36402893, lat:-2.91625094},
    {lng:-41.36402893, lat:-2.91736102},
    {lng:-41.36375046, lat:-2.91736102},
    {lng:-41.36375046, lat:-2.91791701},
    {lng:-41.36347198, lat:-2.91791701},
    {lng:-41.36347198, lat:-2.91819501},
    {lng:-41.36319351, lat:-2.91819501},
    {lng:-41.36319351, lat:-2.91847301},
    {lng:-41.36347198, lat:-2.91847301},
    {lng:-41.36347198, lat:-2.918751},
    {lng:-41.36264038, lat:-2.918751},
    {lng:-41.36264038, lat:-2.91902709},
    {lng:-41.36208344, lat:-2.91902709},
    {lng:-41.36208344, lat:-2.91930509},
    {lng:-41.36152649, lat:-2.91930509},
    {lng:-41.36152649, lat:-2.91958308},
    {lng:-41.35985947, lat:-2.91958308},
    {lng:-41.35985947, lat:-2.91930509},
    {lng:-41.35819626, lat:-2.91930509},
    {lng:-41.35819626, lat:-2.91958308},
    {lng:-41.35763931, lat:-2.91958308},
    {lng:-41.35763931, lat:-2.91986108},
    {lng:-41.35708237, lat:-2.91986108},
    {lng:-41.35708237, lat:-2.92013907},
    {lng:-41.35652924, lat:-2.92013907},
    {lng:-41.35652924, lat:-2.92041707},
    {lng:-41.35597229, lat:-2.92041707},
    {lng:-41.35597229, lat:-2.92069507},
    {lng:-41.35541534, lat:-2.92069507},
    {lng:-41.35541534, lat:-2.92097306},
    {lng:-41.35486221, lat:-2.92097306},
    {lng:-41.35486221, lat:-2.92125106},
    {lng:-41.35402679, lat:-2.92125106},
    {lng:-41.35402679, lat:-2.92152691},
    {lng:-41.35291672, lat:-2.92152691},
    {lng:-41.35291672, lat:-2.9218049},
    {lng:-41.35180664, lat:-2.9218049},
    {lng:-41.35180664, lat:-2.9220829},
    {lng:-41.35069275, lat:-2.9220829},
    {lng:-41.35069275, lat:-2.9223609},
    {lng:-41.34958267, lat:-2.9223609},
    {lng:-41.34958267, lat:-2.92263889},
    {lng:-41.34902954, lat:-2.92263889},
    {lng:-41.34902954, lat:-2.9220829},
    {lng:-41.34875107, lat:-2.9220829},
    {lng:-41.34875107, lat:-2.92152691},
    {lng:-41.3484726, lat:-2.92152691},
    {lng:-41.3484726, lat:-2.92125106},
    {lng:-41.34819412, lat:-2.92125106},
    {lng:-41.34819412, lat:-2.92097306},
    {lng:-41.34736252, lat:-2.92097306},
    {lng:-41.34736252, lat:-2.92125106},
    {lng:-41.34680557, lat:-2.92125106},
    {lng:-41.34680557, lat:-2.92152691},
    {lng:-41.34624863, lat:-2.92152691},
    {lng:-41.34624863, lat:-2.9218049},
    {lng:-41.34597397, lat:-2.9218049},
    {lng:-41.34597397, lat:-2.92402697},
    {lng:-41.3456955, lat:-2.92402697},
    {lng:-41.3456955, lat:-2.92430496},
    {lng:-41.34513855, lat:-2.92430496},
    {lng:-41.34513855, lat:-2.92458296},
    {lng:-41.3445816, lat:-2.92458296},
    {lng:-41.3445816, lat:-2.92486095},
    {lng:-41.34402847, lat:-2.92486095},
    {lng:-41.34402847, lat:-2.92513895},
    {lng:-41.34347153, lat:-2.92513895},
    {lng:-41.34347153, lat:-2.92541695},
    {lng:-41.3429184, lat:-2.92541695},
    {lng:-41.3429184, lat:-2.9256959},
    {lng:-41.34236145, lat:-2.9256959},
    {lng:-41.34236145, lat:-2.92597103},
    {lng:-41.3418045, lat:-2.92597103},
    {lng:-41.3418045, lat:-2.92624903},
    {lng:-41.34125137, lat:-2.92624903},
    {lng:-41.34125137, lat:-2.92652702},
    {lng:-41.34069443, lat:-2.92652702},
    {lng:-41.34069443, lat:-2.92680502},
    {lng:-41.33791733, lat:-2.92680502},
    {lng:-41.33791733, lat:-2.92652702},
    {lng:-41.33736038, lat:-2.92652702},
    {lng:-41.33736038, lat:-2.92624903},
    {lng:-41.33708191, lat:-2.92624903},
    {lng:-41.33708191, lat:-2.92513895},
    {lng:-41.33680725, lat:-2.92513895},
    {lng:-41.33680725, lat:-2.92430496},
    {lng:-41.33652878, lat:-2.92430496},
    {lng:-41.33652878, lat:-2.92402697},
    {lng:-41.33625031, lat:-2.92402697},
    {lng:-41.33625031, lat:-2.92374897},
    {lng:-41.33569336, lat:-2.92374897},
    {lng:-41.33569336, lat:-2.92402697},
    {lng:-41.33541489, lat:-2.92402697},
    {lng:-41.33541489, lat:-2.92374897},
    {lng:-41.33514023, lat:-2.92374897},
    {lng:-41.33514023, lat:-2.92347097},
    {lng:-41.33430481, lat:-2.92347097},
    {lng:-41.33430481, lat:-2.92374897},
    {lng:-41.33402634, lat:-2.92374897},
    {lng:-41.33402634, lat:-2.92402697},
    {lng:-41.33319473, lat:-2.92402697},
    {lng:-41.33319473, lat:-2.92430496},
    {lng:-41.33263779, lat:-2.92430496},
    {lng:-41.33263779, lat:-2.92458296},
    {lng:-41.33208466, lat:-2.92458296},
    {lng:-41.33208466, lat:-2.92430496},
    {lng:-41.33180618, lat:-2.92430496},
    {lng:-41.33180618, lat:-2.9220829},
    {lng:-41.33152771, lat:-2.9220829},
    {lng:-41.33152771, lat:-2.92152691},
    {lng:-41.33124924, lat:-2.92152691},
    {lng:-41.33124924, lat:-2.92125106},
    {lng:-41.33097076, lat:-2.92125106},
    {lng:-41.33097076, lat:-2.92097306},
    {lng:-41.33041763, lat:-2.92097306},
    {lng:-41.33041763, lat:-2.92069507},
    {lng:-41.32958221, lat:-2.92069507},
    {lng:-41.32958221, lat:-2.92041707},
    {lng:-41.32902908, lat:-2.92041707},
    {lng:-41.32902908, lat:-2.92069507},
    {lng:-41.32847214, lat:-2.92069507},
    {lng:-41.32847214, lat:-2.92041707},
    {lng:-41.32764053, lat:-2.92041707},
    {lng:-41.32764053, lat:-2.92013907},
    {lng:-41.32652664, lat:-2.92013907},
    {lng:-41.32652664, lat:-2.91986108},
    {lng:-41.32569504, lat:-2.91986108},
    {lng:-41.32569504, lat:-2.91958308},
    {lng:-41.32485962, lat:-2.91958308},
    {lng:-41.32485962, lat:-2.91930509},
    {lng:-41.32402802, lat:-2.91930509},
    {lng:-41.32402802, lat:-2.91902709},
    {lng:-41.3231926, lat:-2.91902709},
    {lng:-41.3231926, lat:-2.918751},
    {lng:-41.32208252, lat:-2.918751},
    {lng:-41.32208252, lat:-2.91847301},
    {lng:-41.32125092, lat:-2.91847301},
    {lng:-41.32125092, lat:-2.91819501},
    {lng:-41.32090759, lat:-2.91819501},
    {lng:-41.32263565, lat:-2.92133999},
    {lng:-41.32278442, lat:-2.93796611},
    {lng:-41.32288742, lat:-2.94913912},
    {lng:-41.32158279, lat:-2.95349598},
    {lng:-41.3190155, lat:-2.95736408},
    {lng:-41.29841995, lat:-2.96841311},
    {lng:-41.28346252, lat:-2.96766806},
    {lng:-41.2722702, lat:-2.97129202},
    {lng:-41.26949692, lat:-2.98510098},
    {lng:-41.25707626, lat:-3.0046649},
    {lng:-41.25590897, lat:-3.01851296},
    {lng:-41.24973297, lat:-3.02905893},
    {lng:-41.25455093, lat:-3.03122211},
    {lng:-41.25371933, lat:-3.03760791},
    {lng:-41.26039505, lat:-3.04811192},
    {lng:-41.26073074, lat:-3.05508709},
    {lng:-41.26130295, lat:-3.0670929},
    {lng:-41.25648117, lat:-3.07171297},
    {lng:-41.25660324, lat:-3.08803606},
    {lng:-41.26791382, lat:-3.09385896},
    {lng:-41.2722435, lat:-3.10093594},
    {lng:-41.28577423, lat:-3.10329509},
    {lng:-41.28544617, lat:-3.11333203},
    {lng:-41.2998085, lat:-3.12796688},
    {lng:-41.31911087, lat:-3.14536309},
    {lng:-41.31930161, lat:-3.15009689},
    {lng:-41.32866287, lat:-3.16161299},
    {lng:-41.32550812, lat:-3.17083359},
    {lng:-41.32243729, lat:-3.17981195},
    {lng:-41.38675308, lat:-3.28876901},
    {lng:-41.40021515, lat:-3.31861806},
    {lng:-41.3979187, lat:-3.32756901},
    {lng:-41.41226959, lat:-3.34071898},
    {lng:-41.41586685, lat:-3.34948492},
    {lng:-41.42346954, lat:-3.36802602},
    {lng:-41.41867065, lat:-3.37050796},
    {lng:-41.40265656, lat:-3.36241698},
    {lng:-41.40062714, lat:-3.37790298},
    {lng:-41.40351868, lat:-3.39659691},
    {lng:-41.39381027, lat:-3.39958692},
    {lng:-41.38894653, lat:-3.41240311},
    {lng:-41.35597992, lat:-3.41085291},
    {lng:-41.34792328, lat:-3.41464305},
    {lng:-41.34473038, lat:-3.41933799},
    {lng:-41.34386444, lat:-3.440516},
    {lng:-41.34794617, lat:-3.45253801},
    {lng:-41.32958221, lat:-3.465837},
    {lng:-41.32796478, lat:-3.48867202},
    {lng:-41.32512283, lat:-3.4929719},
    {lng:-41.32329941, lat:-3.49407792},
    {lng:-41.31315994, lat:-3.48892689},
    {lng:-41.29916382, lat:-3.49103999},
    {lng:-41.32054138, lat:-3.49787688},
    {lng:-41.3241272, lat:-3.50338793},
    {lng:-41.32563019, lat:-3.53643298},
    {lng:-41.33682251, lat:-3.55391192},
    {lng:-41.36461258, lat:-3.55801892},
    {lng:-41.36729813, lat:-3.56201005},
    {lng:-41.37119675, lat:-3.56781507},
    {lng:-41.37057877, lat:-3.57488489},
    {lng:-41.36195374, lat:-3.58320093},
    {lng:-41.34485626, lat:-3.58875799},
    {lng:-41.33126831, lat:-3.62470388},
    {lng:-41.33905029, lat:-3.67043996},
    {lng:-41.34364319, lat:-3.67599392},
    {lng:-41.34169769, lat:-3.6807909},
    {lng:-41.32649612, lat:-3.68733692},
    {lng:-41.30761719, lat:-3.68482304},
    {lng:-41.29075623, lat:-3.68970704},
    {lng:-41.27928543, lat:-3.70076609},
    {lng:-41.25538635, lat:-3.70327711},
    {lng:-41.23942947, lat:-3.71258497},
    {lng:-41.23937988, lat:-3.72071505},
    {lng:-41.2518425, lat:-3.72335911},
    {lng:-41.25731277, lat:-3.72991991},
    {lng:-41.2610817, lat:-3.75774598},
    {lng:-41.2540741, lat:-3.77505898},
    {lng:-41.26478195, lat:-3.79159594},
    {lng:-41.30076599, lat:-3.82631898},
    {lng:-41.29511261, lat:-3.83019805},
    {lng:-41.28741837, lat:-3.82227612},
    {lng:-41.28262329, lat:-3.82683206},
    {lng:-41.27680588, lat:-3.82563996},
    {lng:-41.2685318, lat:-3.84451294},
    {lng:-41.27048874, lat:-3.85310292},
    {lng:-41.26771164, lat:-3.8618691},
    {lng:-41.25990677, lat:-3.86476994},
    {lng:-41.25880814, lat:-3.87029696},
    {lng:-41.24739456, lat:-3.88354111},
    {lng:-41.24546432, lat:-3.89634299},
    {lng:-41.22886658, lat:-3.91175008},
    {lng:-41.22019196, lat:-3.94152689},
    {lng:-41.2289772, lat:-3.96839595},
    {lng:-41.23290634, lat:-3.96796203},
    {lng:-41.23551941, lat:-3.97149706},
    {lng:-41.24007034, lat:-3.97921705},
    {lng:-41.24431229, lat:-3.97977805},
    {lng:-41.24414444, lat:-3.9864099},
    {lng:-41.24919128, lat:-3.98988509},
    {lng:-41.24568176, lat:-4.00660276},
    {lng:-41.23930359, lat:-4.01475286},
    {lng:-41.23939514, lat:-4.01590919},
    {lng:-41.25434875, lat:-4.02768707},
    {lng:-41.25463867, lat:-4.03577423},
    {lng:-41.25013351, lat:-4.03777218},
    {lng:-41.23460388, lat:-4.02968788},
    {lng:-41.22088623, lat:-4.02671909},
    {lng:-41.20885468, lat:-4.02560186},
    {lng:-41.19942474, lat:-4.01837683},
    {lng:-41.19255829, lat:-4.020679},
    {lng:-41.18367767, lat:-4.01832485},
    {lng:-41.18300247, lat:-4.01873302},
    {lng:-41.18219757, lat:-4.01921988},
    {lng:-41.18198395, lat:-4.02561522},
    {lng:-41.17176819, lat:-4.03249598},
    {lng:-41.15990448, lat:-4.03173018},
    {lng:-41.14304733, lat:-4.0368309},
    {lng:-41.12029648, lat:-4.03635693},
    {lng:-41.11423111, lat:-4.04074001},
    {lng:-41.11406708, lat:-4.05183697},
    {lng:-41.12710953, lat:-4.061409},
    {lng:-41.12218475, lat:-4.07720423},
    {lng:-41.1374855, lat:-4.12000799},
    {lng:-41.14132309, lat:-4.12206221},
    {lng:-41.14312363, lat:-4.12426281},
    {lng:-41.1280632, lat:-4.13934183},
    {lng:-41.12610245, lat:-4.1528511},
    {lng:-41.11828232, lat:-4.1652422},
    {lng:-41.0908432, lat:-4.17035007},
    {lng:-41.0990448, lat:-4.1818552},
    {lng:-41.08258438, lat:-4.18962717},
    {lng:-41.09922791, lat:-4.18211508},
    {lng:-41.13585663, lat:-4.23353004},
    {lng:-41.11919403, lat:-4.31325579},
    {lng:-41.11938477, lat:-4.32427311},
    {lng:-41.120121, lat:-4.33058405},
    {lng:-41.13337326, lat:-4.34016418},
    {lng:-41.14896011, lat:-4.36741686},
    {lng:-41.1599617, lat:-4.38151598},
    {lng:-41.15987778, lat:-4.38922024},
    {lng:-41.15964127, lat:-4.41057301},
    {lng:-41.17708588, lat:-4.44128418},
    {lng:-41.17649078, lat:-4.44700718},
    {lng:-41.17797089, lat:-4.46849918},
    {lng:-41.18929672, lat:-4.48870182},
    {lng:-41.19072723, lat:-4.51554823},
    {lng:-41.20374298, lat:-4.52843809},
    {lng:-41.20820618, lat:-4.54801416},
    {lng:-41.21406555, lat:-4.5526948},
    {lng:-41.22195435, lat:-4.56753206},
    {lng:-41.24069214, lat:-4.56847095},
    {lng:-41.24249268, lat:-4.57153177},
    {lng:-41.23535919, lat:-4.57375002},
    {lng:-41.22533417, lat:-4.57686806},
    {lng:-41.22140884, lat:-4.58039808},
    {lng:-41.22211456, lat:-4.58459187},
    {lng:-41.22479248, lat:-4.59310198},
    {lng:-41.233078, lat:-4.60957098},
    {lng:-41.22928238, lat:-4.62011385},
    {lng:-41.20276642, lat:-4.63821077},
    {lng:-41.18555069, lat:-4.66198397},
    {lng:-41.17451096, lat:-4.66666079},
    {lng:-41.17423248, lat:-4.66747904},
    {lng:-41.20244598, lat:-4.70191002},
    {lng:-41.22860336, lat:-4.72828007},
    {lng:-41.23660278, lat:-4.73877096},
    {lng:-41.23518372, lat:-4.74654722},
    {lng:-41.25028992, lat:-4.75664616},
    {lng:-41.24796295, lat:-4.76156902},
    {lng:-41.24056625, lat:-4.76535702},
    {lng:-41.21271515, lat:-4.77204418},
    {lng:-41.20796585, lat:-4.7767868},
    {lng:-41.20993042, lat:-4.78336716},
    {lng:-41.22256851, lat:-4.78999186},
    {lng:-41.23241806, lat:-4.80455303},
    {lng:-41.23278809, lat:-4.81575298},
    {lng:-41.24118042, lat:-4.82173777},
    {lng:-41.23939896, lat:-4.85455799},
    {lng:-41.24912643, lat:-4.86911201},
    {lng:-41.22805405, lat:-4.89100599},
    {lng:-41.23488235, lat:-4.90576077},
    {lng:-41.22290039, lat:-4.92652607},
    {lng:-41.2215004, lat:-4.93688917},
    {lng:-41.21971893, lat:-4.93830395},
    {lng:-41.21054077, lat:-4.93863297},
    {lng:-41.20956421, lat:-4.94597816},
    {lng:-41.20374298, lat:-4.94976902},
    {lng:-41.19740677, lat:-4.93783522},
    {lng:-41.19385147, lat:-4.93901587},
    {lng:-41.18016815, lat:-4.94756222},
    {lng:-41.15087128, lat:-4.99212599},
    {lng:-41.14641953, lat:-4.99221706},
    {lng:-41.14081573, lat:-4.98483515},
    {lng:-41.13747406, lat:-4.98498583},
    {lng:-41.13550949, lat:-4.99725914},
    {lng:-41.12255096, lat:-5.00809383},
    {lng:-41.12120819, lat:-5.02358484},
    {lng:-41.12136841, lat:-5.02396107},
    {lng:-41.13175201, lat:-5.04808378},
    {lng:-41.09695435, lat:-5.05316591},
    {lng:-41.09581757, lat:-5.06163311},
    {lng:-41.08895874, lat:-5.06519508},
    {lng:-41.08729935, lat:-5.07333422},
    {lng:-41.0803833, lat:-5.07870817},
    {lng:-41.08007812, lat:-5.09110689},
    {lng:-41.05236435, lat:-5.10342121},
    {lng:-41.04021835, lat:-5.0914011},
    {lng:-41.03395462, lat:-5.0910821},
    {lng:-41.02635574, lat:-5.10971403},
    {lng:-41.01402664, lat:-5.10582304},
    {lng:-41.01178741, lat:-5.12361908},
    {lng:-40.98855591, lat:-5.1387639},
    {lng:-40.98241425, lat:-5.15353918},
    {lng:-40.97488785, lat:-5.14954805},
    {lng:-40.96458435, lat:-5.15010214},
    {lng:-40.94927216, lat:-5.16689301},
    {lng:-40.93769836, lat:-5.16660595},
    {lng:-40.928936, lat:-5.17168617},
    {lng:-40.92524338, lat:-5.18211317},
    {lng:-40.93194962, lat:-5.20128012},
    {lng:-40.92198181, lat:-5.22646904},
    {lng:-40.94218063, lat:-5.24049091},
    {lng:-40.92529678, lat:-5.25299215},
    {lng:-40.92004013, lat:-5.25826788},
    {lng:-40.91173935, lat:-5.26888895},
    {lng:-40.91178513, lat:-5.27022219},
    {lng:-40.92419052, lat:-5.27485323},
    {lng:-40.92189407, lat:-5.28437519},
    {lng:-40.92584991, lat:-5.29442406},
    {lng:-40.92411423, lat:-5.29920578},
    {lng:-40.9131546, lat:-5.30806684},
    {lng:-40.91346359, lat:-5.31949186},
    {lng:-40.91840363, lat:-5.33827019},
    {lng:-40.93271637, lat:-5.34872198},
    {lng:-40.93384171, lat:-5.3505888},
    {lng:-40.93605423, lat:-5.36598015},
    {lng:-40.92899323, lat:-5.375844},
    {lng:-40.91643143, lat:-5.39122581},
    {lng:-40.91150284, lat:-5.40739202},
    {lng:-40.91764832, lat:-5.41630793},
    {lng:-40.93814087, lat:-5.41637087},
    {lng:-40.94235992, lat:-5.42054892},
    {lng:-40.94207764, lat:-5.42513514},
    {lng:-40.93668365, lat:-5.43847418},
    {lng:-40.93602371, lat:-5.44010878},
    {lng:-40.93140411, lat:-5.44290113},
    {lng:-40.92171478, lat:-5.4504261},
    {lng:-40.91576385, lat:-5.46619797},
    {lng:-40.91846466, lat:-5.47391701},
    {lng:-40.92910767, lat:-5.48335123},
    {lng:-40.92906952, lat:-5.49278212},
    {lng:-40.93300629, lat:-5.50073385},
    {lng:-40.92871094, lat:-5.50696516},
    {lng:-40.92882538, lat:-5.51786423},
    {lng:-40.93640518, lat:-5.5264039},
    {lng:-40.93170547, lat:-5.53644323},
    {lng:-40.93233109, lat:-5.54891205},
    {lng:-40.91432953, lat:-5.56768084},
    {lng:-40.91228485, lat:-5.59048796},
    {lng:-40.9039917, lat:-5.60490799},
    {lng:-40.90101624, lat:-5.61578417},
    {lng:-40.90764236, lat:-5.64236116},
    {lng:-40.9111824, lat:-5.65657377},
    {lng:-40.92907333, lat:-5.66314697},
    {lng:-40.93871689, lat:-5.67335796},
    {lng:-40.93032837, lat:-5.68623018},
    {lng:-40.92720795, lat:-5.70623207},
    {lng:-40.9251976, lat:-5.70923996},
    {lng:-40.9134903, lat:-5.72676182},
    {lng:-40.91770554, lat:-5.74480915},
    {lng:-40.90970612, lat:-5.76571703},
    {lng:-40.90650177, lat:-5.79486322},
    {lng:-40.90900421, lat:-5.82554913},
    {lng:-40.90559387, lat:-5.84929323},
    {lng:-40.89356232, lat:-5.88404608},
    {lng:-40.89746857, lat:-5.90131712},
    {lng:-40.88008881, lat:-5.91843319},
    {lng:-40.87415695, lat:-5.97427607},
    {lng:-40.87438965, lat:-5.97472811},
    {lng:-40.87476349, lat:-5.97546816},
    {lng:-40.88730621, lat:-5.98935318},
    {lng:-40.88922882, lat:-6.00078487},
    {lng:-40.89130783, lat:-6.00583601},
    {lng:-40.90389633, lat:-6.02089214},
    {lng:-40.9070549, lat:-6.04175711},
    {lng:-40.90548325, lat:-6.04639292},
    {lng:-40.90215683, lat:-6.04921722},
    {lng:-40.88422775, lat:-6.04780579},
    {lng:-40.87327576, lat:-6.05627298},
    {lng:-40.85836411, lat:-6.10311794},
    {lng:-40.85742187, lat:-6.10531521},
    {lng:-40.84685898, lat:-6.13210917},
    {lng:-40.84952545, lat:-6.14800978},
    {lng:-40.85306931, lat:-6.16521597},
    {lng:-40.85295105, lat:-6.16950989},
    {lng:-40.85196304, lat:-6.17525482},
    {lng:-40.84717941, lat:-6.20302916},
    {lng:-40.85217667, lat:-6.22423601},
    {lng:-40.82352448, lat:-6.2582798},
    {lng:-40.81045532, lat:-6.28707886},
    {lng:-40.80413055, lat:-6.29288387},
    {lng:-40.78717804, lat:-6.3049078},
    {lng:-40.78568649, lat:-6.30824089},
    {lng:-40.78107452, lat:-6.32425785},
    {lng:-40.77959061, lat:-6.33709383},
    {lng:-40.77930832, lat:-6.3424778},
    {lng:-40.77947235, lat:-6.34335279},
    {lng:-40.77965164, lat:-6.3443079},
    {lng:-40.79029846, lat:-6.37190104},
    {lng:-40.80003738, lat:-6.38171816},
    {lng:-40.8051033, lat:-6.39314699},
    {lng:-40.79603958, lat:-6.4282012},
    {lng:-40.79389954, lat:-6.457829},
    {lng:-40.79653549, lat:-6.470716},
    {lng:-40.79024124, lat:-6.49888992},
    {lng:-40.79053116, lat:-6.50111485},
    {lng:-40.7920723, lat:-6.51287508},
    {lng:-40.78761673, lat:-6.52379704},
    {lng:-40.74580002, lat:-6.56556177},
    {lng:-40.735569, lat:-6.600214},
    {lng:-40.72195053, lat:-6.61769676},
    {lng:-40.73188019, lat:-6.65408611},
    {lng:-40.72953033, lat:-6.65776014},
    {lng:-40.71012497, lat:-6.67614317},
    {lng:-40.65073395, lat:-6.67877102},
    {lng:-40.63236618, lat:-6.69891882},
    {lng:-40.61281586, lat:-6.71181822},
    {lng:-40.60707092, lat:-6.71408606},
    {lng:-40.56309891, lat:-6.72023821},
    {lng:-40.51733398, lat:-6.7305069},
    {lng:-40.49263763, lat:-6.73193598},
    {lng:-40.47618484, lat:-6.73452282},
    {lng:-40.47188568, lat:-6.744946},
    {lng:-40.45876312, lat:-6.75708723},
    {lng:-40.45695114, lat:-6.762609},
    {lng:-40.45197678, lat:-6.78379107},
    {lng:-40.44287872, lat:-6.78988791},
    {lng:-40.43893814, lat:-6.80670118},
    {lng:-40.43211746, lat:-6.8129921},
    {lng:-40.41678238, lat:-6.81254482},
    {lng:-40.40408325, lat:-6.80250311},
    {lng:-40.38874054, lat:-6.79701519},
    {lng:-40.37053299, lat:-6.80306816},
    {lng:-40.37052536, lat:-6.80800486},
    {lng:-40.38153839, lat:-6.81961918},
    {lng:-40.38662338, lat:-6.82922983},
    {lng:-40.40216827, lat:-6.84000397},
    {lng:-40.40933609, lat:-6.85309982},
    {lng:-40.41308212, lat:-6.85675812},
    {lng:-40.4284668, lat:-6.86427021},
    {lng:-40.4289093, lat:-6.88487291},
    {lng:-40.4330368, lat:-6.89915419},
    {lng:-40.42496872, lat:-6.93528509},
    {lng:-40.42555618, lat:-6.93718386},
    {lng:-40.42906952, lat:-6.94851589},
    {lng:-40.42925644, lat:-6.99464321},
    {lng:-40.41102219, lat:-6.99909019},
    {lng:-40.40619659, lat:-7.00533915},
    {lng:-40.42779922, lat:-7.01536512},
    {lng:-40.42796326, lat:-7.01848984},
    {lng:-40.43627548, lat:-7.01586008},
    {lng:-40.43309021, lat:-7.0236249},
    {lng:-40.43080521, lat:-7.02657413},
    {lng:-40.429039, lat:-7.0278821},
    {lng:-40.42688751, lat:-7.02947521},
    {lng:-40.42766571, lat:-7.03389502},
    {lng:-40.44322968, lat:-7.04810905},
    {lng:-40.44420624, lat:-7.05594301},
    {lng:-40.45933914, lat:-7.07855606},
    {lng:-40.46936798, lat:-7.08765697},
    {lng:-40.47038269, lat:-7.09398413},
    {lng:-40.48968887, lat:-7.11870289},
    {lng:-40.48431778, lat:-7.13321209},
    {lng:-40.49565887, lat:-7.169631},
    {lng:-40.49473953, lat:-7.18235683},
    {lng:-40.50124359, lat:-7.18866587},
    {lng:-40.51047134, lat:-7.22698116},
    {lng:-40.5150795, lat:-7.27370691},
    {lng:-40.51211929, lat:-7.30181599},
    {lng:-40.51817703, lat:-7.31360817},
    {lng:-40.54145813, lat:-7.33227921},
    {lng:-40.5404892, lat:-7.34486198},
    {lng:-40.54840851, lat:-7.39272213},
    {lng:-40.65227127, lat:-7.43335915},
    {lng:-40.65744019, lat:-7.44444895},
    {lng:-40.65862656, lat:-7.44647694},
    {lng:-40.6713295, lat:-7.45245123},
    {lng:-40.70484924, lat:-7.45875692},
    {lng:-40.71319962, lat:-7.47325706},
    {lng:-40.71465683, lat:-7.48773909},
    {lng:-40.71395111, lat:-7.48948479},
    {lng:-40.69431686, lat:-7.53800488},
    {lng:-40.69031143, lat:-7.54339981},
    {lng:-40.662682, lat:-7.579503},
    {lng:-40.659084, lat:-7.581805},
    {lng:-40.645611, lat:-7.594680},
    {lng:-40.636800, lat:-7.608353},
    {lng:-40.632539, lat:-7.617073},
    {lng:-40.630444, lat:-7.622049},
    {lng:-40.627023, lat:-7.630522},
    {lng:-40.626553, lat:-7.631665},
    {lng:-40.624860, lat:-7.637516},
    {lng:-40.622650, lat:-7.647501},
    {lng:-40.621991, lat:-7.651382},
    {lng:-40.621797, lat:-7.653354},
    {lng:-40.621716, lat:-7.655442},
    {lng:-40.621829, lat:-7.658321},
    {lng:-40.624375, lat:-7.673191},
    {lng:-40.627593, lat:-7.684759},
    {lng:-40.631284, lat:-7.692500},
    {lng:-40.635747, lat:-7.699938},
    {lng:-40.639245, lat:-7.704042},
    {lng:-40.651210, lat:-7.714236},
    {lng:-40.661007, lat:-7.720527},
    {lng:-40.666500, lat:-7.726374},
    {lng:-40.666500, lat:-7.726374},
    {lng:-40.671396, lat:-7.734749},
    {lng:-40.674619, lat:-7.743436},
    {lng:-40.675121, lat:-7.745525},
    {lng:-40.675298, lat:-7.746831},
    {lng:-40.675594, lat:-7.747806},
    {lng:-40.675461, lat:-7.748604},
    {lng:-40.675656, lat:-7.752675},
    {lng:-40.673561, lat:-7.761683},
    {lng:-40.672076, lat:-7.764869},
    {lng:-40.670002, lat:-7.767911},
    {lng:-40.665516, lat:-7.772853},
    {lng:-40.65364838, lat:-7.78223324},
    {lng:-40.62859344, lat:-7.7925868},
    {lng:-40.57472229, lat:-7.80705881},
    {lng:-40.56351089, lat:-7.81264114},
    {lng:-40.55578613, lat:-7.81881523},
    {lng:-40.54762268, lat:-7.82873917},
    {lng:-40.5436821, lat:-7.83558512},
    {lng:-40.53976059, lat:-7.85526085},
    {lng:-40.53817749, lat:-7.8670578},
    {lng:-40.54472733, lat:-7.94765902},
    {lng:-40.54438782, lat:-7.95773792},
    {lng:-40.54415894, lat:-7.96462297},
    {lng:-40.57575989, lat:-8.03049374},
    {lng:-40.58222961, lat:-8.04469776},
    {lng:-40.59870529, lat:-8.08086967},
    {lng:-40.6037941, lat:-8.10359764},
    {lng:-40.59644318, lat:-8.11803436},
    {lng:-40.59118271, lat:-8.12352943},
    {lng:-40.58973312, lat:-8.13798523},
    {lng:-40.60108948, lat:-8.14407539},
    {lng:-40.60138702, lat:-8.15014172},
    {lng:-40.63296127, lat:-8.13956165},
    {lng:-40.6382637, lat:-8.14722729},
    {lng:-40.64267731, lat:-8.15005302},
    {lng:-40.64350128, lat:-8.1575489},
    {lng:-40.65844345, lat:-8.15658283},
    {lng:-40.66654205, lat:-8.16232014},
    {lng:-40.66896057, lat:-8.17749214},
    {lng:-40.6751976, lat:-8.18488979},
    {lng:-40.68436432, lat:-8.18779087},
    {lng:-40.69430923, lat:-8.20089912},
    {lng:-40.70053864, lat:-8.20262814},
    {lng:-40.70655823, lat:-8.22153568},
    {lng:-40.70922089, lat:-8.22365284},
    {lng:-40.72893524, lat:-8.22492504},
    {lng:-40.73682022, lat:-8.22824955},
    {lng:-40.74444962, lat:-8.24009705},
    {lng:-40.76377106, lat:-8.2439146},
    {lng:-40.76397705, lat:-8.24412537},
    {lng:-40.76857758, lat:-8.24879456},
    {lng:-40.7827301, lat:-8.25509644},
    {lng:-40.78315353, lat:-8.25751877},
    {lng:-40.77820969, lat:-8.28601074},
    {lng:-40.7816124, lat:-8.29313278},
    {lng:-40.78101349, lat:-8.29607773},
    {lng:-40.77981567, lat:-8.30195999},
    {lng:-40.78638077, lat:-8.3064518},
    {lng:-40.79229355, lat:-8.31913567},
    {lng:-40.81945419, lat:-8.32193661},
    {lng:-40.8183403, lat:-8.33015537},
    {lng:-40.82260895, lat:-8.33774471},
    {lng:-40.81927109, lat:-8.36237144},
    {lng:-40.83735275, lat:-8.38114929},
    {lng:-40.85852432, lat:-8.37962246},
    {lng:-40.85729599, lat:-8.37565613},
    {lng:-40.86233521, lat:-8.36523342},
    {lng:-40.87106323, lat:-8.35848904},
    {lng:-40.8930397, lat:-8.35734081},
    {lng:-40.89768219, lat:-8.36793613},
    {lng:-40.89262009, lat:-8.37180901},
    {lng:-40.88981247, lat:-8.38675785},
    {lng:-40.89445877, lat:-8.39253139},
    {lng:-40.90755844, lat:-8.39899635},
    {lng:-40.90179443, lat:-8.40812016},
    {lng:-40.90276337, lat:-8.4230938},
    {lng:-40.91430283, lat:-8.43619919},
    {lng:-40.92667007, lat:-8.44624996},
    {lng:-40.93803024, lat:-8.43500519},
    {lng:-40.95703506, lat:-8.42348385},
    {lng:-40.95782852, lat:-8.41942024},
    {lng:-40.96544647, lat:-8.4164772},
    {lng:-40.96552658, lat:-8.41212177},
    {lng:-40.98078156, lat:-8.39843369},
    {lng:-40.99325562, lat:-8.39966869},
    {lng:-41.00013733, lat:-8.40066528},
    {lng:-41.0073204, lat:-8.42095757},
    {lng:-41.03894424, lat:-8.43184757},
    {lng:-41.04774857, lat:-8.44875526},
    {lng:-41.05105209, lat:-8.48049641},
    {lng:-41.07888031, lat:-8.4725256},
    {lng:-41.08321762, lat:-8.49664211},
    {lng:-41.09044266, lat:-8.51263905},
    {lng:-41.09790421, lat:-8.52077961},
    {lng:-41.10402679, lat:-8.52238655},
    {lng:-41.11140442, lat:-8.53365898},
    {lng:-41.12222672, lat:-8.53955841},
    {lng:-41.12748337, lat:-8.54111385},
    {lng:-41.13456726, lat:-8.53356266},
    {lng:-41.1485939, lat:-8.53392124},
    {lng:-41.15213013, lat:-8.54605484},
    {lng:-41.1657486, lat:-8.57645512},
    {lng:-41.16910934, lat:-8.58332157},
    {lng:-41.17857742, lat:-8.58838844},
    {lng:-41.17985916, lat:-8.59329319},
    {lng:-41.1985054, lat:-8.59248829},
    {lng:-41.20281219, lat:-8.59929562},
    {lng:-41.21191025, lat:-8.60243893},
    {lng:-41.20771408, lat:-8.61025238},
    {lng:-41.20659637, lat:-8.63345337},
    {lng:-41.21730423, lat:-8.64554882},
    {lng:-41.23373032, lat:-8.64762497},
    {lng:-41.23943329, lat:-8.65585327},
    {lng:-41.25379944, lat:-8.66220188},
    {lng:-41.28748322, lat:-8.66099739},
    {lng:-41.30631256, lat:-8.68830299},
    {lng:-41.30981064, lat:-8.69177437},
    {lng:-41.33693695, lat:-8.70837975},
    {lng:-41.35826874, lat:-8.70764446},
    {lng:-41.36968613, lat:-8.70606232},
    {lng:-41.37787247, lat:-8.70693111},
    {lng:-41.39893341, lat:-8.70498943},
    {lng:-41.37924957, lat:-8.70753384},
    {lng:-41.3822937, lat:-8.70886803},
    {lng:-41.39451218, lat:-8.72662163},
    {lng:-41.40026474, lat:-8.74638462},
    {lng:-41.41200638, lat:-8.77392769},
    {lng:-41.42417526, lat:-8.80247879},
    {lng:-41.43187332, lat:-8.79708576},
    {lng:-41.46259689, lat:-8.82876396},
    {lng:-41.47213745, lat:-8.84312534},
    {lng:-41.48779678, lat:-8.84391308},
    {lng:-41.49449158, lat:-8.86113453},
    {lng:-41.50242996, lat:-8.86398315},
    {lng:-41.50526047, lat:-8.86827278},
    {lng:-41.5104332, lat:-8.87669563},
    {lng:-41.50740433, lat:-8.89246368},
    {lng:-41.51873398, lat:-8.89997578},
    {lng:-41.5228653, lat:-8.90525246},
    {lng:-41.53129578, lat:-8.92771912},
    {lng:-41.5447998, lat:-8.937994},
    {lng:-41.54447174, lat:-8.96056175},
    {lng:-41.55994797, lat:-8.96673584},
    {lng:-41.56563568, lat:-8.96900845},
    {lng:-41.57000351, lat:-8.95505333},
    {lng:-41.58390045, lat:-8.95508099},
    {lng:-41.58996964, lat:-8.95536327},
    {lng:-41.59686279, lat:-8.9589119},
    {lng:-41.60574722, lat:-8.95741367},
    {lng:-41.60988235, lat:-8.96728516},
    {lng:-41.6211586, lat:-8.97087002},
    {lng:-41.62405014, lat:-8.98168278},
    {lng:-41.62894821, lat:-8.98490143},
    {lng:-41.66936111, lat:-8.99009037},
    {lng:-41.66985703, lat:-9.00348854},
    {lng:-41.68040085, lat:-9.01229382},
    {lng:-41.72355652, lat:-9.01355171},
    {lng:-41.72874451, lat:-9.02084732},
    {lng:-41.73291016, lat:-9.04598236},
    {lng:-41.73096466, lat:-9.06982803},
    {lng:-41.73513794, lat:-9.09471226},
    {lng:-41.75889206, lat:-9.11667061},
    {lng:-41.77575302, lat:-9.12633038},
    {lng:-41.77823257, lat:-9.1277523},
    {lng:-41.80001831, lat:-9.14803696},
    {lng:-41.80007935, lat:-9.16517353},
    {lng:-41.81985474, lat:-9.18911362},
    {lng:-41.83791733, lat:-9.24228096},
    {lng:-41.84632492, lat:-9.24371719},
    {lng:-41.8596611, lat:-9.23762512},
    {lng:-41.87047195, lat:-9.23744297},
    {lng:-41.8848877, lat:-9.253479},
    {lng:-41.90235138, lat:-9.25890827},
    {lng:-41.90954208, lat:-9.27378082},
    {lng:-41.91788483, lat:-9.27847576},
    {lng:-41.92472076, lat:-9.27780628},
    {lng:-41.93739319, lat:-9.26728058},
    {lng:-41.94908524, lat:-9.2635231},
    {lng:-41.9581337, lat:-9.26210976},
    {lng:-41.97221756, lat:-9.24864864},
    {lng:-41.99988937, lat:-9.26595879},
    {lng:-42.02245712, lat:-9.25004387},
    {lng:-42.03491592, lat:-9.25613213},
    {lng:-42.05173492, lat:-9.25605869},
    {lng:-42.06646729, lat:-9.25599289},
    {lng:-42.10048294, lat:-9.28103828},
    {lng:-42.12116623, lat:-9.28393459},
    {lng:-42.13686371, lat:-9.28711414},
    {lng:-42.17944717, lat:-9.28527737},
    {lng:-42.19418716, lat:-9.29169464},
    {lng:-42.20639038, lat:-9.29279613},
    {lng:-42.22462845, lat:-9.28398037},
    {lng:-42.22611618, lat:-9.2838459},
    {lng:-42.22735977, lat:-9.28373623},
    {lng:-42.24367905, lat:-9.28892612},
    {lng:-42.26357269, lat:-9.30600357},
    {lng:-42.26953888, lat:-9.30966187},
    {lng:-42.28987885, lat:-9.30951118},
    {lng:-42.31245422, lat:-9.31685162},
    {lng:-42.3149147, lat:-9.31764984},
    {lng:-42.31911469, lat:-9.32026386},
    {lng:-42.32580185, lat:-9.3333559},
    {lng:-42.35505676, lat:-9.34988213},
    {lng:-42.35910797, lat:-9.37529755},
    {lng:-42.36245346, lat:-9.3795557},
    {lng:-42.36911011, lat:-9.38387299},
    {lng:-42.39883804, lat:-9.39709568},
    {lng:-42.42108536, lat:-9.41241932},
    {lng:-42.42317581, lat:-9.41483021},
    {lng:-42.42823029, lat:-9.43979836},
    {lng:-42.43468857, lat:-9.44839478},
    {lng:-42.44286728, lat:-9.45741558},
    {lng:-42.45171738, lat:-9.46211147},
    {lng:-42.47354507, lat:-9.45921612},
    {lng:-42.48310471, lat:-9.46046066},
    {lng:-42.48784637, lat:-9.46173},
    {lng:-42.49117279, lat:-9.46961784},
    {lng:-42.48601532, lat:-9.48386955},
    {lng:-42.49212646, lat:-9.49346733},
    {lng:-42.52195358, lat:-9.50296211},
    {lng:-42.54911804, lat:-9.49588776},
    {lng:-42.56912994, lat:-9.50176334},
    {lng:-42.5864296, lat:-9.49678135},
    {lng:-42.59498596, lat:-9.504776},
    {lng:-42.6031456, lat:-9.51595783},
    {lng:-42.62159348, lat:-9.54124165},
    {lng:-42.63230515, lat:-9.53841782},
    {lng:-42.64017105, lat:-9.54384136},
    {lng:-42.6545639, lat:-9.54141331},
    {lng:-42.6730957, lat:-9.54861069},
    {lng:-42.69078445, lat:-9.54547024},
]
